import { MapMode as mt, EditorSelection as M, EditorState as Dt, Transaction as ln, Prec as je, Facet as k, StateEffect as Ht, RangeValue as $i, RangeSet as F, ChangeSet as Ui, findClusterBreak as gt, findColumn as xe, Annotation as hn, Text as _, codePointAt as Ji, countColumn as Zi, StateField as Qi, CharCategory as an, codePointSize as cn, combineConfig as Ye, RangeSetBuilder as fn } from "./ghl-ui.es268.js";
import { StyleModule as wt } from "./ghl-ui.es433.js";
import { keyName as dn, base as un, shift as gn } from "./ghl-ui.es434.js";
function ne(n) {
  let t;
  return n.nodeType == 11 ? t = n.getSelection ? n : n.ownerDocument : t = n, t.getSelection();
}
function Ce(n, t) {
  return t ? n == t || n.contains(t.nodeType != 1 ? t.parentNode : t) : !1;
}
function pn(n) {
  let t = n.activeElement;
  for (; t && t.shadowRoot; )
    t = t.shadowRoot.activeElement;
  return t;
}
function Zt(n, t) {
  if (!t.anchorNode)
    return !1;
  try {
    return Ce(n, t.anchorNode);
  } catch {
    return !1;
  }
}
function Rt(n) {
  return n.nodeType == 3 ? ft(n, 0, n.nodeValue.length).getClientRects() : n.nodeType == 1 ? n.getClientRects() : [];
}
function re(n, t, e, i) {
  return e ? ti(n, t, e, i, -1) || ti(n, t, e, i, 1) : !1;
}
function Lt(n) {
  for (var t = 0; ; t++)
    if (n = n.previousSibling, !n)
      return t;
}
function ti(n, t, e, i, s) {
  for (; ; ) {
    if (n == e && t == i)
      return !0;
    if (t == (s < 0 ? 0 : J(n))) {
      if (n.nodeName == "DIV")
        return !1;
      let r = n.parentNode;
      if (!r || r.nodeType != 1)
        return !1;
      t = Lt(n) + (s < 0 ? 0 : 1), n = r;
    } else if (n.nodeType == 1) {
      if (n = n.childNodes[t + (s < 0 ? -1 : 0)], n.nodeType == 1 && n.contentEditable == "false")
        return !1;
      t = s < 0 ? J(n) : 0;
    } else
      return !1;
  }
}
function J(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function Ge(n, t) {
  let e = t ? n.left : n.right;
  return { left: e, right: e, top: n.top, bottom: n.bottom };
}
function mn(n) {
  return {
    left: 0,
    right: n.innerWidth,
    top: 0,
    bottom: n.innerHeight
  };
}
function bn(n, t, e, i, s, r, o, l) {
  let h = n.ownerDocument, c = h.defaultView || window;
  for (let a = n, f = !1; a && !f; )
    if (a.nodeType == 1) {
      let d, u = a == h.body, g = 1, m = 1;
      if (u)
        d = mn(c);
      else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(a).position) && (f = !0), a.scrollHeight <= a.clientHeight && a.scrollWidth <= a.clientWidth) {
          a = a.assignedSlot || a.parentNode;
          continue;
        }
        let v = a.getBoundingClientRect();
        g = v.width / a.offsetWidth, m = v.height / a.offsetHeight, d = {
          left: v.left,
          right: v.left + a.clientWidth * g,
          top: v.top,
          bottom: v.top + a.clientHeight * m
        };
      }
      let p = 0, b = 0;
      if (s == "nearest")
        t.top < d.top ? (b = -(d.top - t.top + o), e > 0 && t.bottom > d.bottom + b && (b = t.bottom - d.bottom + b + o)) : t.bottom > d.bottom && (b = t.bottom - d.bottom + o, e < 0 && t.top - b < d.top && (b = -(d.top + b - t.top + o)));
      else {
        let v = t.bottom - t.top, x = d.bottom - d.top;
        b = (s == "center" && v <= x ? t.top + v / 2 - x / 2 : s == "start" || s == "center" && e < 0 ? t.top - o : t.bottom - x + o) - d.top;
      }
      if (i == "nearest" ? t.left < d.left ? (p = -(d.left - t.left + r), e > 0 && t.right > d.right + p && (p = t.right - d.right + p + r)) : t.right > d.right && (p = t.right - d.right + r, e < 0 && t.left < d.left + p && (p = -(d.left + p - t.left + r))) : p = (i == "center" ? t.left + (t.right - t.left) / 2 - (d.right - d.left) / 2 : i == "start" == l ? t.left - r : t.right - (d.right - d.left) + r) - d.left, p || b)
        if (u)
          c.scrollBy(p, b);
        else {
          let v = 0, x = 0;
          if (b) {
            let y = a.scrollTop;
            a.scrollTop += b / m, x = (a.scrollTop - y) * m;
          }
          if (p) {
            let y = a.scrollLeft;
            a.scrollLeft += p / g, v = (a.scrollLeft - y) * g;
          }
          t = {
            left: t.left - v,
            top: t.top - x,
            right: t.right - v,
            bottom: t.bottom - x
          }, v && Math.abs(v - p) < 1 && (i = "nearest"), x && Math.abs(x - b) < 1 && (s = "nearest");
        }
      if (u)
        break;
      a = a.assignedSlot || a.parentNode;
    } else if (a.nodeType == 11)
      a = a.host;
    else
      break;
}
function wn(n) {
  let t = n.ownerDocument;
  for (let e = n.parentNode; e && e != t.body; )
    if (e.nodeType == 1) {
      if (e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth)
        return e;
      e = e.assignedSlot || e.parentNode;
    } else if (e.nodeType == 11)
      e = e.host;
    else
      break;
  return null;
}
class yn {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  eq(t) {
    return this.anchorNode == t.anchorNode && this.anchorOffset == t.anchorOffset && this.focusNode == t.focusNode && this.focusOffset == t.focusOffset;
  }
  setRange(t) {
    let { anchorNode: e, focusNode: i } = t;
    this.set(e, Math.min(t.anchorOffset, e ? J(e) : 0), i, Math.min(t.focusOffset, i ? J(i) : 0));
  }
  set(t, e, i, s) {
    this.anchorNode = t, this.anchorOffset = e, this.focusNode = i, this.focusOffset = s;
  }
}
let ut = null;
function ts(n) {
  if (n.setActive)
    return n.setActive();
  if (ut)
    return n.focus(ut);
  let t = [];
  for (let e = n; e && (t.push(e, e.scrollTop, e.scrollLeft), e != e.ownerDocument); e = e.parentNode)
    ;
  if (n.focus(ut == null ? {
    get preventScroll() {
      return ut = { preventScroll: !0 }, !0;
    }
  } : void 0), !ut) {
    ut = !1;
    for (let e = 0; e < t.length; ) {
      let i = t[e++], s = t[e++], r = t[e++];
      i.scrollTop != s && (i.scrollTop = s), i.scrollLeft != r && (i.scrollLeft = r);
    }
  }
}
let ei;
function ft(n, t, e = t) {
  let i = ei || (ei = document.createRange());
  return i.setEnd(n, e), i.setStart(n, t), i;
}
function bt(n, t, e) {
  let i = { key: t, code: t, keyCode: e, which: e, cancelable: !0 }, s = new KeyboardEvent("keydown", i);
  s.synthetic = !0, n.dispatchEvent(s);
  let r = new KeyboardEvent("keyup", i);
  return r.synthetic = !0, n.dispatchEvent(r), s.defaultPrevented || r.defaultPrevented;
}
function vn(n) {
  for (; n; ) {
    if (n && (n.nodeType == 9 || n.nodeType == 11 && n.host))
      return n;
    n = n.assignedSlot || n.parentNode;
  }
  return null;
}
function es(n) {
  for (; n.attributes.length; )
    n.removeAttributeNode(n.attributes[0]);
}
function Sn(n, t) {
  let e = t.focusNode, i = t.focusOffset;
  if (!e || t.anchorNode != e || t.anchorOffset != i)
    return !1;
  for (i = Math.min(i, J(e)); ; )
    if (i) {
      if (e.nodeType != 1)
        return !1;
      let s = e.childNodes[i - 1];
      s.contentEditable == "false" ? i-- : (e = s, i = J(e));
    } else {
      if (e == n)
        return !0;
      i = Lt(e), e = e.parentNode;
    }
}
function is(n) {
  return n.scrollTop > Math.max(1, n.scrollHeight - n.clientHeight - 4);
}
class H {
  constructor(t, e, i = !0) {
    this.node = t, this.offset = e, this.precise = i;
  }
  static before(t, e) {
    return new H(t.parentNode, Lt(t), e);
  }
  static after(t, e) {
    return new H(t.parentNode, Lt(t) + 1, e);
  }
}
const _e = [];
class T {
  constructor() {
    this.parent = null, this.dom = null, this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(t) {
    let e = this.posAtStart;
    for (let i of this.children) {
      if (i == t)
        return e;
      e += i.length + i.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(t) {
    return this.posBefore(t) + t.length;
  }
  sync(t, e) {
    if (this.flags & 2) {
      let i = this.dom, s = null, r;
      for (let o of this.children) {
        if (o.flags & 7) {
          if (!o.dom && (r = s ? s.nextSibling : i.firstChild)) {
            let l = T.get(r);
            (!l || !l.parent && l.canReuseDOM(o)) && o.reuseDOM(r);
          }
          o.sync(t, e), o.flags &= -8;
        }
        if (r = s ? s.nextSibling : i.firstChild, e && !e.written && e.node == i && r != o.dom && (e.written = !0), o.dom.parentNode == i)
          for (; r && r != o.dom; )
            r = ii(r);
        else
          i.insertBefore(o.dom, r);
        s = o.dom;
      }
      for (r = s ? s.nextSibling : i.firstChild, r && e && e.node == i && (e.written = !0); r; )
        r = ii(r);
    } else if (this.flags & 1)
      for (let i of this.children)
        i.flags & 7 && (i.sync(t, e), i.flags &= -8);
  }
  reuseDOM(t) {
  }
  localPosFromDOM(t, e) {
    let i;
    if (t == this.dom)
      i = this.dom.childNodes[e];
    else {
      let s = J(t) == 0 ? 0 : e == 0 ? -1 : 1;
      for (; ; ) {
        let r = t.parentNode;
        if (r == this.dom)
          break;
        s == 0 && r.firstChild != r.lastChild && (t == r.firstChild ? s = -1 : s = 1), t = r;
      }
      s < 0 ? i = t : i = t.nextSibling;
    }
    if (i == this.dom.firstChild)
      return 0;
    for (; i && !T.get(i); )
      i = i.nextSibling;
    if (!i)
      return this.length;
    for (let s = 0, r = 0; ; s++) {
      let o = this.children[s];
      if (o.dom == i)
        return r;
      r += o.length + o.breakAfter;
    }
  }
  domBoundsAround(t, e, i = 0) {
    let s = -1, r = -1, o = -1, l = -1;
    for (let h = 0, c = i, a = i; h < this.children.length; h++) {
      let f = this.children[h], d = c + f.length;
      if (c < t && d > e)
        return f.domBoundsAround(t, e, c);
      if (d >= t && s == -1 && (s = h, r = c), c > e && f.dom.parentNode == this.dom) {
        o = h, l = a;
        break;
      }
      a = d, c = d + f.breakAfter;
    }
    return {
      from: r,
      to: l < 0 ? i + this.length : l,
      startDOM: (s ? this.children[s - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: o < this.children.length && o >= 0 ? this.children[o].dom : null
    };
  }
  markDirty(t = !1) {
    this.flags |= 2, this.markParentsDirty(t);
  }
  markParentsDirty(t) {
    for (let e = this.parent; e; e = e.parent) {
      if (t && (e.flags |= 2), e.flags & 1)
        return;
      e.flags |= 1, t = !1;
    }
  }
  setParent(t) {
    this.parent != t && (this.parent = t, this.flags & 7 && this.markParentsDirty(!0));
  }
  setDOM(t) {
    this.dom != t && (this.dom && (this.dom.cmView = null), this.dom = t, t.cmView = this);
  }
  get rootView() {
    for (let t = this; ; ) {
      let e = t.parent;
      if (!e)
        return t;
      t = e;
    }
  }
  replaceChildren(t, e, i = _e) {
    this.markDirty();
    for (let s = t; s < e; s++) {
      let r = this.children[s];
      r.parent == this && r.destroy();
    }
    this.children.splice(t, e - t, ...i);
    for (let s = 0; s < i.length; s++)
      i[s].setParent(this);
  }
  ignoreMutation(t) {
    return !1;
  }
  ignoreEvent(t) {
    return !1;
  }
  childCursor(t = this.length) {
    return new ss(this.children, t, this.children.length);
  }
  childPos(t, e = 1) {
    return this.childCursor().findPos(t, e);
  }
  toString() {
    let t = this.constructor.name.replace("View", "");
    return t + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (t == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(t) {
    return t.cmView;
  }
  get isEditable() {
    return !0;
  }
  get isWidget() {
    return !1;
  }
  get isHidden() {
    return !1;
  }
  merge(t, e, i, s, r, o) {
    return !1;
  }
  become(t) {
    return !1;
  }
  canReuseDOM(t) {
    return t.constructor == this.constructor && !((this.flags | t.flags) & 8);
  }
  // When this is a zero-length view with a side, this should return a
  // number <= 0 to indicate it is before its position, or a
  // number > 0 when after its position.
  getSide() {
    return 0;
  }
  destroy() {
    this.parent = null;
  }
}
T.prototype.breakAfter = 0;
function ii(n) {
  let t = n.nextSibling;
  return n.parentNode.removeChild(n), t;
}
class ss {
  constructor(t, e, i) {
    this.children = t, this.pos = e, this.i = i, this.off = 0;
  }
  findPos(t, e = 1) {
    for (; ; ) {
      if (t > this.pos || t == this.pos && (e > 0 || this.i == 0 || this.children[this.i - 1].breakAfter))
        return this.off = t - this.pos, this;
      let i = this.children[--this.i];
      this.pos -= i.length + i.breakAfter;
    }
  }
}
function ns(n, t, e, i, s, r, o, l, h) {
  let { children: c } = n, a = c.length ? c[t] : null, f = r.length ? r[r.length - 1] : null, d = f ? f.breakAfter : o;
  if (!(t == i && a && !o && !d && r.length < 2 && a.merge(e, s, r.length ? f : null, e == 0, l, h))) {
    if (i < c.length) {
      let u = c[i];
      u && (s < u.length || u.breakAfter && (f != null && f.breakAfter)) ? (t == i && (u = u.split(s), s = 0), !d && f && u.merge(0, s, f, !0, 0, h) ? r[r.length - 1] = u : ((s || u.children.length && !u.children[0].length) && u.merge(0, s, null, !1, 0, h), r.push(u))) : u != null && u.breakAfter && (f ? f.breakAfter = 1 : o = 1), i++;
    }
    for (a && (a.breakAfter = o, e > 0 && (!o && r.length && a.merge(e, a.length, r[0], !1, l, 0) ? a.breakAfter = r.shift().breakAfter : (e < a.length || a.children.length && a.children[a.children.length - 1].length == 0) && a.merge(e, a.length, null, !1, l, 0), t++)); t < i && r.length; )
      if (c[i - 1].become(r[r.length - 1]))
        i--, r.pop(), h = r.length ? 0 : l;
      else if (c[t].become(r[0]))
        t++, r.shift(), l = r.length ? 0 : h;
      else
        break;
    !r.length && t && i < c.length && !c[t - 1].breakAfter && c[i].merge(0, 0, c[t - 1], !1, l, h) && t--, (t < i || r.length) && n.replaceChildren(t, i, r);
  }
}
function rs(n, t, e, i, s, r) {
  let o = n.childCursor(), { i: l, off: h } = o.findPos(e, 1), { i: c, off: a } = o.findPos(t, -1), f = t - e;
  for (let d of i)
    f += d.length;
  n.length += f, ns(n, c, a, l, h, i, 0, s, r);
}
let K = typeof navigator < "u" ? navigator : { userAgent: "", vendor: "", platform: "" }, Me = typeof document < "u" ? document : { documentElement: { style: {} } };
const ke = /* @__PURE__ */ /Edge\/(\d+)/.exec(K.userAgent), os = /* @__PURE__ */ /MSIE \d/.test(K.userAgent), Ae = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(K.userAgent), ce = !!(os || Ae || ke), si = !ce && /* @__PURE__ */ /gecko\/(\d+)/i.test(K.userAgent), de = !ce && /* @__PURE__ */ /Chrome\/(\d+)/.exec(K.userAgent), ni = "webkitFontSmoothing" in Me.documentElement.style, ls = !ce && /* @__PURE__ */ /Apple Computer/.test(K.vendor), ri = ls && (/* @__PURE__ */ /Mobile\/\w+/.test(K.userAgent) || K.maxTouchPoints > 2);
var w = {
  mac: ri || /* @__PURE__ */ /Mac/.test(K.platform),
  windows: /* @__PURE__ */ /Win/.test(K.platform),
  linux: /* @__PURE__ */ /Linux|X11/.test(K.platform),
  ie: ce,
  ie_version: os ? Me.documentMode || 6 : Ae ? +Ae[1] : ke ? +ke[1] : 0,
  gecko: si,
  gecko_version: si ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec(K.userAgent) || [0, 0])[1] : 0,
  chrome: !!de,
  chrome_version: de ? +de[1] : 0,
  ios: ri,
  android: /* @__PURE__ */ /Android\b/.test(K.userAgent),
  webkit: ni,
  safari: ls,
  webkit_version: ni ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0,
  tabSize: Me.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const xn = 256;
class Z extends T {
  constructor(t) {
    super(), this.text = t;
  }
  get length() {
    return this.text.length;
  }
  createDOM(t) {
    this.setDOM(t || document.createTextNode(this.text));
  }
  sync(t, e) {
    this.dom || this.createDOM(), this.dom.nodeValue != this.text && (e && e.node == this.dom && (e.written = !0), this.dom.nodeValue = this.text);
  }
  reuseDOM(t) {
    t.nodeType == 3 && this.createDOM(t);
  }
  merge(t, e, i) {
    return this.flags & 8 || i && (!(i instanceof Z) || this.length - (e - t) + i.length > xn || i.flags & 8) ? !1 : (this.text = this.text.slice(0, t) + (i ? i.text : "") + this.text.slice(e), this.markDirty(), !0);
  }
  split(t) {
    let e = new Z(this.text.slice(t));
    return this.text = this.text.slice(0, t), this.markDirty(), e.flags |= this.flags & 8, e;
  }
  localPosFromDOM(t, e) {
    return t == this.dom ? e : e ? this.text.length : 0;
  }
  domAtPos(t) {
    return new H(this.dom, t);
  }
  domBoundsAround(t, e, i) {
    return { from: i, to: i + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(t, e) {
    return Cn(this.dom, t, e);
  }
}
class Q extends T {
  constructor(t, e = [], i = 0) {
    super(), this.mark = t, this.children = e, this.length = i;
    for (let s of e)
      s.setParent(this);
  }
  setAttrs(t) {
    if (es(t), this.mark.class && (t.className = this.mark.class), this.mark.attrs)
      for (let e in this.mark.attrs)
        t.setAttribute(e, this.mark.attrs[e]);
    return t;
  }
  canReuseDOM(t) {
    return super.canReuseDOM(t) && !((this.flags | t.flags) & 8);
  }
  reuseDOM(t) {
    t.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(t), this.flags |= 6);
  }
  sync(t, e) {
    this.dom ? this.flags & 4 && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), super.sync(t, e);
  }
  merge(t, e, i, s, r, o) {
    return i && (!(i instanceof Q && i.mark.eq(this.mark)) || t && r <= 0 || e < this.length && o <= 0) ? !1 : (rs(this, t, e, i ? i.children : [], r - 1, o - 1), this.markDirty(), !0);
  }
  split(t) {
    let e = [], i = 0, s = -1, r = 0;
    for (let l of this.children) {
      let h = i + l.length;
      h > t && e.push(i < t ? l.split(t - i) : l), s < 0 && i >= t && (s = r), i = h, r++;
    }
    let o = this.length - t;
    return this.length = t, s > -1 && (this.children.length = s, this.markDirty()), new Q(this.mark, e, o);
  }
  domAtPos(t) {
    return hs(this, t);
  }
  coordsAt(t, e) {
    return cs(this, t, e);
  }
}
function Cn(n, t, e) {
  let i = n.nodeValue.length;
  t > i && (t = i);
  let s = t, r = t, o = 0;
  t == 0 && e < 0 || t == i && e >= 0 ? w.chrome || w.gecko || (t ? (s--, o = 1) : r < i && (r++, o = -1)) : e < 0 ? s-- : r < i && r++;
  let l = ft(n, s, r).getClientRects();
  if (!l.length)
    return null;
  let h = l[(o ? o < 0 : e >= 0) ? 0 : l.length - 1];
  return w.safari && !o && h.width == 0 && (h = Array.prototype.find.call(l, (c) => c.width) || h), o ? Ge(h, o < 0) : h || null;
}
class st extends T {
  static create(t, e, i) {
    return new st(t, e, i);
  }
  constructor(t, e, i) {
    super(), this.widget = t, this.length = e, this.side = i, this.prevWidget = null;
  }
  split(t) {
    let e = st.create(this.widget, this.length - t, this.side);
    return this.length -= t, e;
  }
  sync(t) {
    (!this.dom || !this.widget.updateDOM(this.dom, t)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(t)), this.dom.contentEditable = "false");
  }
  getSide() {
    return this.side;
  }
  merge(t, e, i, s, r, o) {
    return i && (!(i instanceof st) || !this.widget.compare(i.widget) || t > 0 && r <= 0 || e < this.length && o <= 0) ? !1 : (this.length = t + (i ? i.length : 0) + (this.length - e), !0);
  }
  become(t) {
    return t instanceof st && t.side == this.side && this.widget.constructor == t.widget.constructor ? (this.widget.compare(t.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = t.widget, this.length = t.length, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(t) {
    return this.widget.ignoreEvent(t);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return _.empty;
    let t = this;
    for (; t.parent; )
      t = t.parent;
    let { view: e } = t, i = e && e.state.doc, s = this.posAtStart;
    return i ? i.slice(s, s + this.length) : _.empty;
  }
  domAtPos(t) {
    return (this.length ? t == 0 : this.side > 0) ? H.before(this.dom) : H.after(this.dom, t == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(t, e) {
    let i = this.widget.coordsAt(this.dom, t, e);
    if (i)
      return i;
    let s = this.dom.getClientRects(), r = null;
    if (!s.length)
      return null;
    let o = this.side ? this.side < 0 : t > 0;
    for (let l = o ? s.length - 1 : 0; r = s[l], !(t > 0 ? l == 0 : l == s.length - 1 || r.top < r.bottom); l += o ? -1 : 1)
      ;
    return Ge(r, !o);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
}
class yt extends T {
  constructor(t) {
    super(), this.side = t;
  }
  get length() {
    return 0;
  }
  merge() {
    return !1;
  }
  become(t) {
    return t instanceof yt && t.side == this.side;
  }
  split() {
    return new yt(this.side);
  }
  sync() {
    if (!this.dom) {
      let t = document.createElement("img");
      t.className = "cm-widgetBuffer", t.setAttribute("aria-hidden", "true"), this.setDOM(t);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(t) {
    return this.side > 0 ? H.before(this.dom) : H.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(t) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return _.empty;
  }
  get isHidden() {
    return !0;
  }
}
Z.prototype.children = st.prototype.children = yt.prototype.children = _e;
function hs(n, t) {
  let e = n.dom, { children: i } = n, s = 0;
  for (let r = 0; s < i.length; s++) {
    let o = i[s], l = r + o.length;
    if (!(l == r && o.getSide() <= 0)) {
      if (t > r && t < l && o.dom.parentNode == e)
        return o.domAtPos(t - r);
      if (t <= r)
        break;
      r = l;
    }
  }
  for (let r = s; r > 0; r--) {
    let o = i[r - 1];
    if (o.dom.parentNode == e)
      return o.domAtPos(o.length);
  }
  for (let r = s; r < i.length; r++) {
    let o = i[r];
    if (o.dom.parentNode == e)
      return o.domAtPos(0);
  }
  return new H(e, 0);
}
function as(n, t, e) {
  let i, { children: s } = n;
  e > 0 && t instanceof Q && s.length && (i = s[s.length - 1]) instanceof Q && i.mark.eq(t.mark) ? as(i, t.children[0], e - 1) : (s.push(t), t.setParent(n)), n.length += t.length;
}
function cs(n, t, e) {
  let i = null, s = -1, r = null, o = -1;
  function l(c, a) {
    for (let f = 0, d = 0; f < c.children.length && d <= a; f++) {
      let u = c.children[f], g = d + u.length;
      g >= a && (u.children.length ? l(u, a - d) : (!r || r.isHidden && e > 0) && (g > a || d == g && u.getSide() > 0) ? (r = u, o = a - d) : (d < a || d == g && u.getSide() < 0 && !u.isHidden) && (i = u, s = a - d)), d = g;
    }
  }
  l(n, t);
  let h = (e < 0 ? i : r) || i || r;
  return h ? h.coordsAt(Math.max(0, h == i ? s : o), e) : Mn(n);
}
function Mn(n) {
  let t = n.dom.lastChild;
  if (!t)
    return n.dom.getBoundingClientRect();
  let e = Rt(t);
  return e[e.length - 1] || null;
}
function De(n, t) {
  for (let e in n)
    e == "class" && t.class ? t.class += " " + n.class : e == "style" && t.style ? t.style += ";" + n.style : t[e] = n[e];
  return t;
}
const oi = /* @__PURE__ */ Object.create(null);
function Xe(n, t, e) {
  if (n == t)
    return !0;
  n || (n = oi), t || (t = oi);
  let i = Object.keys(n), s = Object.keys(t);
  if (i.length - (e && i.indexOf(e) > -1 ? 1 : 0) != s.length - (e && s.indexOf(e) > -1 ? 1 : 0))
    return !1;
  for (let r of i)
    if (r != e && (s.indexOf(r) == -1 || n[r] !== t[r]))
      return !1;
  return !0;
}
function Oe(n, t, e) {
  let i = !1;
  if (t)
    for (let s in t)
      e && s in e || (i = !0, s == "style" ? n.style.cssText = "" : n.removeAttribute(s));
  if (e)
    for (let s in e)
      t && t[s] == e[s] || (i = !0, s == "style" ? n.style.cssText = e[s] : n.setAttribute(s, e[s]));
  return i;
}
function kn(n) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let e = 0; e < n.attributes.length; e++) {
    let i = n.attributes[e];
    t[i.name] = i.value;
  }
  return t;
}
class B extends T {
  constructor() {
    super(...arguments), this.children = [], this.length = 0, this.prevAttrs = void 0, this.attrs = null, this.breakAfter = 0;
  }
  // Consumes source
  merge(t, e, i, s, r, o) {
    if (i) {
      if (!(i instanceof B))
        return !1;
      this.dom || i.transferDOM(this);
    }
    return s && this.setDeco(i ? i.attrs : null), rs(this, t, e, i ? i.children : [], r, o), !0;
  }
  split(t) {
    let e = new B();
    if (e.breakAfter = this.breakAfter, this.length == 0)
      return e;
    let { i, off: s } = this.childPos(t);
    s && (e.append(this.children[i].split(s), 0), this.children[i].merge(s, this.children[i].length, null, !1, 0, 0), i++);
    for (let r = i; r < this.children.length; r++)
      e.append(this.children[r], 0);
    for (; i > 0 && this.children[i - 1].length == 0; )
      this.children[--i].destroy();
    return this.children.length = i, this.markDirty(), this.length = t, e;
  }
  transferDOM(t) {
    this.dom && (this.markDirty(), t.setDOM(this.dom), t.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
  }
  setDeco(t) {
    Xe(this.attrs, t) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = t);
  }
  append(t, e) {
    as(this, t, e);
  }
  // Only called when building a line view in ContentBuilder
  addLineDeco(t) {
    let e = t.spec.attributes, i = t.spec.class;
    e && (this.attrs = De(e, this.attrs || {})), i && (this.attrs = De({ class: i }, this.attrs || {}));
  }
  domAtPos(t) {
    return hs(this, t);
  }
  reuseDOM(t) {
    t.nodeName == "DIV" && (this.setDOM(t), this.flags |= 6);
  }
  sync(t, e) {
    var i;
    this.dom ? this.flags & 4 && (es(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), this.prevAttrs !== void 0 && (Oe(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), super.sync(t, e);
    let s = this.dom.lastChild;
    for (; s && T.get(s) instanceof Q; )
      s = s.lastChild;
    if (!s || !this.length || s.nodeName != "BR" && ((i = T.get(s)) === null || i === void 0 ? void 0 : i.isEditable) == !1 && (!w.ios || !this.children.some((r) => r instanceof Z))) {
      let r = document.createElement("BR");
      r.cmIgnore = !0, this.dom.appendChild(r);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let t = 0, e;
    for (let i of this.children) {
      if (!(i instanceof Z) || /[^ -~]/.test(i.text))
        return null;
      let s = Rt(i.dom);
      if (s.length != 1)
        return null;
      t += s[0].width, e = s[0].height;
    }
    return t ? {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: t / this.length,
      textHeight: e
    } : null;
  }
  coordsAt(t, e) {
    let i = cs(this, t, e);
    if (!this.children.length && i && this.parent) {
      let { heightOracle: s } = this.parent.view.viewState, r = i.bottom - i.top;
      if (Math.abs(r - s.lineHeight) < 2 && s.textHeight < r) {
        let o = (r - s.textHeight) / 2;
        return { top: i.top + o, bottom: i.bottom - o, left: i.left, right: i.left };
      }
    }
    return i;
  }
  become(t) {
    return !1;
  }
  covers() {
    return !0;
  }
  static find(t, e) {
    for (let i = 0, s = 0; i < t.children.length; i++) {
      let r = t.children[i], o = s + r.length;
      if (o >= e) {
        if (r instanceof B)
          return r;
        if (o > e)
          break;
      }
      s = o + r.breakAfter;
    }
    return null;
  }
}
class rt extends T {
  constructor(t, e, i) {
    super(), this.widget = t, this.length = e, this.deco = i, this.breakAfter = 0, this.prevWidget = null;
  }
  merge(t, e, i, s, r, o) {
    return i && (!(i instanceof rt) || !this.widget.compare(i.widget) || t > 0 && r <= 0 || e < this.length && o <= 0) ? !1 : (this.length = t + (i ? i.length : 0) + (this.length - e), !0);
  }
  domAtPos(t) {
    return t == 0 ? H.before(this.dom) : H.after(this.dom, t == this.length);
  }
  split(t) {
    let e = this.length - t;
    this.length = t;
    let i = new rt(this.widget, e, this.deco);
    return i.breakAfter = this.breakAfter, i;
  }
  get children() {
    return _e;
  }
  sync(t) {
    (!this.dom || !this.widget.updateDOM(this.dom, t)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(t)), this.dom.contentEditable = "false");
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : _.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(t) {
    return t instanceof rt && t.widget.constructor == this.widget.constructor ? (t.widget.compare(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = t.widget, this.length = t.length, this.deco = t.deco, this.breakAfter = t.breakAfter, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(t) {
    return this.widget.ignoreEvent(t);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  coordsAt(t, e) {
    return this.widget.coordsAt(this.dom, t, e);
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
  covers(t) {
    let { startSide: e, endSide: i } = this.deco;
    return e == i ? !1 : t < 0 ? e < 0 : i > 0;
  }
}
class Nt {
  /**
  Compare this instance to another instance of the same type.
  (TypeScript can't express this, but only instances of the same
  specific class will be passed to this method.) This is used to
  avoid redrawing widgets when they are replaced by a new
  decoration of the same type. The default implementation just
  returns `false`, which will cause new instances of the widget to
  always be redrawn.
  */
  eq(t) {
    return !1;
  }
  /**
  Update a DOM element created by a widget of the same type (but
  different, non-`eq` content) to reflect this widget. May return
  true to indicate that it could update, false to indicate it
  couldn't (in which case the widget will be redrawn). The default
  implementation just returns false.
  */
  updateDOM(t, e) {
    return !1;
  }
  /**
  @internal
  */
  compare(t) {
    return this == t || this.constructor == t.constructor && this.eq(t);
  }
  /**
  The estimated height this widget will have, to be used when
  estimating the height of content that hasn't been drawn. May
  return -1 to indicate you don't know. The default implementation
  returns -1.
  */
  get estimatedHeight() {
    return -1;
  }
  /**
  For inline widgets that are displayed inline (as opposed to
  `inline-block`) and introduce line breaks (through `<br>` tags
  or textual newlines), this must indicate the amount of line
  breaks they introduce. Defaults to 0.
  */
  get lineBreaks() {
    return 0;
  }
  /**
  Can be used to configure which kinds of events inside the widget
  should be ignored by the editor. The default is to ignore all
  events.
  */
  ignoreEvent(t) {
    return !0;
  }
  /**
  Override the way screen coordinates for positions at/in the
  widget are found. `pos` will be the offset into the widget, and
  `side` the side of the position that is being queried—less than
  zero for before, greater than zero for after, and zero for
  directly at that position.
  */
  coordsAt(t, e, i) {
    return null;
  }
  /**
  @internal
  */
  get isHidden() {
    return !1;
  }
  /**
  This is called when the an instance of the widget is removed
  from the editor view.
  */
  destroy(t) {
  }
}
var N = /* @__PURE__ */ function(n) {
  return n[n.Text = 0] = "Text", n[n.WidgetBefore = 1] = "WidgetBefore", n[n.WidgetAfter = 2] = "WidgetAfter", n[n.WidgetRange = 3] = "WidgetRange", n;
}(N || (N = {}));
class V extends $i {
  constructor(t, e, i, s) {
    super(), this.startSide = t, this.endSide = e, this.widget = i, this.spec = s;
  }
  /**
  @internal
  */
  get heightRelevant() {
    return !1;
  }
  /**
  Create a mark decoration, which influences the styling of the
  content in its range. Nested mark decorations will cause nested
  DOM elements to be created. Nesting order is determined by
  precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
  the higher-precedence decorations creating the inner DOM nodes.
  Such elements are split on line boundaries and on the boundaries
  of lower-precedence decorations.
  */
  static mark(t) {
    return new Vt(t);
  }
  /**
  Create a widget decoration, which displays a DOM element at the
  given position.
  */
  static widget(t) {
    let e = Math.max(-1e4, Math.min(1e4, t.side || 0)), i = !!t.block;
    return e += i && !t.inlineOrder ? e > 0 ? 3e8 : -4e8 : e > 0 ? 1e8 : -1e8, new ot(t, e, e, i, t.widget || null, !1);
  }
  /**
  Create a replace decoration which replaces the given range with
  a widget, or simply hides it.
  */
  static replace(t) {
    let e = !!t.block, i, s;
    if (t.isBlockGap)
      i = -5e8, s = 4e8;
    else {
      let { start: r, end: o } = fs(t, e);
      i = (r ? e ? -3e8 : -1 : 5e8) - 1, s = (o ? e ? 2e8 : 1 : -6e8) + 1;
    }
    return new ot(t, i, s, e, t.widget || null, !0);
  }
  /**
  Create a line decoration, which can add DOM attributes to the
  line starting at the given position.
  */
  static line(t) {
    return new Wt(t);
  }
  /**
  Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
  decorated range or ranges. If the ranges aren't already sorted,
  pass `true` for `sort` to make the library sort them for you.
  */
  static set(t, e = !1) {
    return F.of(t, e);
  }
  /**
  @internal
  */
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : !1;
  }
}
V.none = F.empty;
class Vt extends V {
  constructor(t) {
    let { start: e, end: i } = fs(t);
    super(e ? -1 : 5e8, i ? 1 : -6e8, null, t), this.tagName = t.tagName || "span", this.class = t.class || "", this.attrs = t.attributes || null;
  }
  eq(t) {
    var e, i;
    return this == t || t instanceof Vt && this.tagName == t.tagName && (this.class || ((e = this.attrs) === null || e === void 0 ? void 0 : e.class)) == (t.class || ((i = t.attrs) === null || i === void 0 ? void 0 : i.class)) && Xe(this.attrs, t.attrs, "class");
  }
  range(t, e = t) {
    if (t >= e)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(t, e);
  }
}
Vt.prototype.point = !1;
class Wt extends V {
  constructor(t) {
    super(-2e8, -2e8, null, t);
  }
  eq(t) {
    return t instanceof Wt && this.spec.class == t.spec.class && Xe(this.spec.attributes, t.spec.attributes);
  }
  range(t, e = t) {
    if (e != t)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(t, e);
  }
}
Wt.prototype.mapMode = mt.TrackBefore;
Wt.prototype.point = !0;
class ot extends V {
  constructor(t, e, i, s, r, o) {
    super(e, i, r, t), this.block = s, this.isReplace = o, this.mapMode = s ? e <= 0 ? mt.TrackBefore : mt.TrackAfter : mt.TrackDel;
  }
  // Only relevant when this.block == true
  get type() {
    return this.startSide != this.endSide ? N.WidgetRange : this.startSide <= 0 ? N.WidgetBefore : N.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(t) {
    return t instanceof ot && An(this.widget, t.widget) && this.block == t.block && this.startSide == t.startSide && this.endSide == t.endSide;
  }
  range(t, e = t) {
    if (this.isReplace && (t > e || t == e && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && e != t)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(t, e);
  }
}
ot.prototype.point = !0;
function fs(n, t = !1) {
  let { inclusiveStart: e, inclusiveEnd: i } = n;
  return e == null && (e = n.inclusive), i == null && (i = n.inclusive), { start: e ?? t, end: i ?? t };
}
function An(n, t) {
  return n == t || !!(n && t && n.compare(t));
}
function Te(n, t, e, i = 0) {
  let s = e.length - 1;
  s >= 0 && e[s] + i >= n ? e[s] = Math.max(e[s], t) : e.push(n, t);
}
class Ot {
  constructor(t, e, i, s) {
    this.doc = t, this.pos = e, this.end = i, this.disallowBlockEffectsFor = s, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.bufferMarks = [], this.atCursorPos = !0, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = t.iter(), this.skip = e;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let t = this.content[this.content.length - 1];
    return !(t.breakAfter || t instanceof rt && t.deco.endSide < 0);
  }
  getLine() {
    return this.curLine || (this.content.push(this.curLine = new B()), this.atCursorPos = !0), this.curLine;
  }
  flushBuffer(t = this.bufferMarks) {
    this.pendingBuffer && (this.curLine.append(qt(new yt(-1), t), t.length), this.pendingBuffer = 0);
  }
  addBlockWidget(t) {
    this.flushBuffer(), this.curLine = null, this.content.push(t);
  }
  finish(t) {
    this.pendingBuffer && t <= this.bufferMarks.length ? this.flushBuffer() : this.pendingBuffer = 0, !this.posCovered() && !(t && this.content.length && this.content[this.content.length - 1] instanceof rt) && this.getLine();
  }
  buildText(t, e, i) {
    for (; t > 0; ) {
      if (this.textOff == this.text.length) {
        let { value: r, lineBreak: o, done: l } = this.cursor.next(this.skip);
        if (this.skip = 0, l)
          throw new Error("Ran out of text content when drawing inline views");
        if (o) {
          this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer(), this.curLine = null, this.atCursorPos = !0, t--;
          continue;
        } else
          this.text = r, this.textOff = 0;
      }
      let s = Math.min(
        this.text.length - this.textOff,
        t,
        512
        /* T.Chunk */
      );
      this.flushBuffer(e.slice(e.length - i)), this.getLine().append(qt(new Z(this.text.slice(this.textOff, this.textOff + s)), e), i), this.atCursorPos = !0, this.textOff += s, t -= s, i = 0;
    }
  }
  span(t, e, i, s) {
    this.buildText(e - t, i, s), this.pos = e, this.openStart < 0 && (this.openStart = s);
  }
  point(t, e, i, s, r, o) {
    if (this.disallowBlockEffectsFor[o] && i instanceof ot) {
      if (i.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (e > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let l = e - t;
    if (i instanceof ot)
      if (i.block)
        i.startSide > 0 && !this.posCovered() && this.getLine(), this.addBlockWidget(new rt(i.widget || new li("div"), l, i));
      else {
        let h = st.create(i.widget || new li("span"), l, l ? 0 : i.startSide), c = this.atCursorPos && !h.isEditable && r <= s.length && (t < e || i.startSide > 0), a = !h.isEditable && (t < e || r > s.length || i.startSide <= 0), f = this.getLine();
        this.pendingBuffer == 2 && !c && !h.isEditable && (this.pendingBuffer = 0), this.flushBuffer(s), c && (f.append(qt(new yt(1), s), r), r = s.length + Math.max(0, r - s.length)), f.append(qt(h, s), r), this.atCursorPos = a, this.pendingBuffer = a ? t < e || r > s.length ? 1 : 2 : 0, this.pendingBuffer && (this.bufferMarks = s.slice());
      }
    else
      this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(i);
    l && (this.textOff + l <= this.text.length ? this.textOff += l : (this.skip += l - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = e), this.openStart < 0 && (this.openStart = r);
  }
  static build(t, e, i, s, r) {
    let o = new Ot(t, e, i, r);
    return o.openEnd = F.spans(s, e, i, o), o.openStart < 0 && (o.openStart = o.openEnd), o.finish(o.openEnd), o;
  }
}
function qt(n, t) {
  for (let e of t)
    n = new Q(e, [n], n.length);
  return n;
}
class li extends Nt {
  constructor(t) {
    super(), this.tag = t;
  }
  eq(t) {
    return t.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(t) {
    return t.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return !0;
  }
}
const ds = /* @__PURE__ */ k.define(), us = /* @__PURE__ */ k.define(), gs = /* @__PURE__ */ k.define(), ps = /* @__PURE__ */ k.define(), Re = /* @__PURE__ */ k.define(), ms = /* @__PURE__ */ k.define(), bs = /* @__PURE__ */ k.define(), ws = /* @__PURE__ */ k.define({
  combine: (n) => n.some((t) => t)
}), ys = /* @__PURE__ */ k.define({
  combine: (n) => n.some((t) => t)
});
class oe {
  constructor(t, e = "nearest", i = "nearest", s = 5, r = 5) {
    this.range = t, this.y = e, this.x = i, this.yMargin = s, this.xMargin = r;
  }
  map(t) {
    return t.empty ? this : new oe(this.range.map(t), this.y, this.x, this.yMargin, this.xMargin);
  }
}
const hi = /* @__PURE__ */ Ht.define({ map: (n, t) => n.map(t) });
function ct(n, t, e) {
  let i = n.facet(ps);
  i.length ? i[0](t) : window.onerror ? window.onerror(String(t), e, void 0, void 0, t) : e ? console.error(e + ":", t) : console.error(t);
}
const fe = /* @__PURE__ */ k.define({ combine: (n) => n.length ? n[0] : !0 });
let Dn = 0;
const xt = /* @__PURE__ */ k.define();
class z {
  constructor(t, e, i, s, r) {
    this.id = t, this.create = e, this.domEventHandlers = i, this.domEventObservers = s, this.extension = r(this);
  }
  /**
  Define a plugin from a constructor function that creates the
  plugin's value, given an editor view.
  */
  static define(t, e) {
    const { eventHandlers: i, eventObservers: s, provide: r, decorations: o } = e || {};
    return new z(Dn++, t, i, s, (l) => {
      let h = [xt.of(l)];
      return o && h.push(Bt.of((c) => {
        let a = c.plugin(l);
        return a ? o(a) : V.none;
      })), r && h.push(r(l)), h;
    });
  }
  /**
  Create a plugin for a class whose constructor takes a single
  editor view as argument.
  */
  static fromClass(t, e) {
    return z.define((i) => new t(i), e);
  }
}
class ue {
  constructor(t) {
    this.spec = t, this.mustUpdate = null, this.value = null;
  }
  update(t) {
    if (this.value) {
      if (this.mustUpdate) {
        let e = this.mustUpdate;
        if (this.mustUpdate = null, this.value.update)
          try {
            this.value.update(e);
          } catch (i) {
            if (ct(e.state, i, "CodeMirror plugin crashed"), this.value.destroy)
              try {
                this.value.destroy();
              } catch {
              }
            this.deactivate();
          }
      }
    } else if (this.spec)
      try {
        this.value = this.spec.create(t);
      } catch (e) {
        ct(t.state, e, "CodeMirror plugin crashed"), this.deactivate();
      }
    return this;
  }
  destroy(t) {
    var e;
    if (!((e = this.value) === null || e === void 0) && e.destroy)
      try {
        this.value.destroy();
      } catch (i) {
        ct(t.state, i, "CodeMirror plugin crashed");
      }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const vs = /* @__PURE__ */ k.define(), $e = /* @__PURE__ */ k.define(), Bt = /* @__PURE__ */ k.define(), Ue = /* @__PURE__ */ k.define(), Ss = /* @__PURE__ */ k.define();
function ai(n, t, e) {
  let i = n.state.facet(Ss);
  if (!i.length)
    return i;
  let s = i.map((o) => o instanceof Function ? o(n) : o), r = [];
  return F.spans(s, t, e, {
    point() {
    },
    span(o, l, h, c) {
      let a = r;
      for (let f = h.length - 1; f >= 0; f--, c--) {
        let d = h[f].spec.bidiIsolate, u;
        if (d != null)
          if (c > 0 && a.length && (u = a[a.length - 1]).to == o && u.direction == d)
            u.to = l, a = u.inner;
          else {
            let g = { from: o, to: l, direction: d, inner: [] };
            a.push(g), a = g.inner;
          }
      }
    }
  }), r;
}
const xs = /* @__PURE__ */ k.define();
function Cs(n) {
  let t = 0, e = 0, i = 0, s = 0;
  for (let r of n.state.facet(xs)) {
    let o = r(n);
    o && (o.left != null && (t = Math.max(t, o.left)), o.right != null && (e = Math.max(e, o.right)), o.top != null && (i = Math.max(i, o.top)), o.bottom != null && (s = Math.max(s, o.bottom)));
  }
  return { left: t, right: e, top: i, bottom: s };
}
const Ct = /* @__PURE__ */ k.define();
class q {
  constructor(t, e, i, s) {
    this.fromA = t, this.toA = e, this.fromB = i, this.toB = s;
  }
  join(t) {
    return new q(Math.min(this.fromA, t.fromA), Math.max(this.toA, t.toA), Math.min(this.fromB, t.fromB), Math.max(this.toB, t.toB));
  }
  addToSet(t) {
    let e = t.length, i = this;
    for (; e > 0; e--) {
      let s = t[e - 1];
      if (!(s.fromA > i.toA)) {
        if (s.toA < i.fromA)
          break;
        i = i.join(s), t.splice(e - 1, 1);
      }
    }
    return t.splice(e, 0, i), t;
  }
  static extendWithRanges(t, e) {
    if (e.length == 0)
      return t;
    let i = [];
    for (let s = 0, r = 0, o = 0, l = 0; ; s++) {
      let h = s == t.length ? null : t[s], c = o - l, a = h ? h.fromB : 1e9;
      for (; r < e.length && e[r] < a; ) {
        let f = e[r], d = e[r + 1], u = Math.max(l, f), g = Math.min(a, d);
        if (u <= g && new q(u + c, g + c, u, g).addToSet(i), d > a)
          break;
        r += 2;
      }
      if (!h)
        return i;
      new q(h.fromA, h.toA, h.fromB, h.toB).addToSet(i), o = h.toA, l = h.toB;
    }
  }
}
class le {
  constructor(t, e, i) {
    this.view = t, this.state = e, this.transactions = i, this.flags = 0, this.startState = t.state, this.changes = Ui.empty(this.startState.doc.length);
    for (let r of i)
      this.changes = this.changes.compose(r.changes);
    let s = [];
    this.changes.iterChangedRanges((r, o, l, h) => s.push(new q(r, o, l, h))), this.changedRanges = s;
  }
  /**
  @internal
  */
  static create(t, e, i) {
    return new le(t, e, i);
  }
  /**
  Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
  [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
  update.
  */
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  /**
  Indicates whether the height of a block element in the editor
  changed in this update.
  */
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  /**
  Returns true when the document was modified or the size of the
  editor, or elements within the editor, changed.
  */
  get geometryChanged() {
    return this.docChanged || (this.flags & 10) > 0;
  }
  /**
  True when this update indicates a focus change.
  */
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  /**
  Whether the document changed in this update.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Whether the selection was explicitly set in this update.
  */
  get selectionSet() {
    return this.transactions.some((t) => t.selection);
  }
  /**
  @internal
  */
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
var L = /* @__PURE__ */ function(n) {
  return n[n.LTR = 0] = "LTR", n[n.RTL = 1] = "RTL", n;
}(L || (L = {}));
const Et = L.LTR, Ms = L.RTL;
function ks(n) {
  let t = [];
  for (let e = 0; e < n.length; e++)
    t.push(1 << +n[e]);
  return t;
}
const On = /* @__PURE__ */ ks("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), Tn = /* @__PURE__ */ ks("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), Le = /* @__PURE__ */ Object.create(null), Y = [];
for (let n of ["()", "[]", "{}"]) {
  let t = /* @__PURE__ */ n.charCodeAt(0), e = /* @__PURE__ */ n.charCodeAt(1);
  Le[t] = e, Le[e] = -t;
}
function Rn(n) {
  return n <= 247 ? On[n] : 1424 <= n && n <= 1524 ? 2 : 1536 <= n && n <= 1785 ? Tn[n - 1536] : 1774 <= n && n <= 2220 ? 4 : 8192 <= n && n <= 8203 ? 256 : 64336 <= n && n <= 65023 ? 4 : n == 8204 ? 256 : 1;
}
const Ln = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
class nt {
  /**
  The direction of this span.
  */
  get dir() {
    return this.level % 2 ? Ms : Et;
  }
  /**
  @internal
  */
  constructor(t, e, i) {
    this.from = t, this.to = e, this.level = i;
  }
  /**
  @internal
  */
  side(t, e) {
    return this.dir == e == t ? this.to : this.from;
  }
  /**
  @internal
  */
  static find(t, e, i, s) {
    let r = -1;
    for (let o = 0; o < t.length; o++) {
      let l = t[o];
      if (l.from <= e && l.to >= e) {
        if (l.level == i)
          return o;
        (r < 0 || (s != 0 ? s < 0 ? l.from < e : l.to > e : t[r].level > l.level)) && (r = o);
      }
    }
    if (r < 0)
      throw new RangeError("Index out of range");
    return r;
  }
}
function As(n, t) {
  if (n.length != t.length)
    return !1;
  for (let e = 0; e < n.length; e++) {
    let i = n[e], s = t[e];
    if (i.from != s.from || i.to != s.to || i.direction != s.direction || !As(i.inner, s.inner))
      return !1;
  }
  return !0;
}
const D = [];
function Bn(n, t, e, i, s) {
  for (let r = 0; r <= i.length; r++) {
    let o = r ? i[r - 1].to : t, l = r < i.length ? i[r].from : e, h = r ? 256 : s;
    for (let c = o, a = h, f = h; c < l; c++) {
      let d = Rn(n.charCodeAt(c));
      d == 512 ? d = a : d == 8 && f == 4 && (d = 16), D[c] = d == 4 ? 2 : d, d & 7 && (f = d), a = d;
    }
    for (let c = o, a = h, f = h; c < l; c++) {
      let d = D[c];
      if (d == 128)
        c < l - 1 && a == D[c + 1] && a & 24 ? d = D[c] = a : D[c] = 256;
      else if (d == 64) {
        let u = c + 1;
        for (; u < l && D[u] == 64; )
          u++;
        let g = c && a == 8 || u < e && D[u] == 8 ? f == 1 ? 1 : 8 : 256;
        for (let m = c; m < u; m++)
          D[m] = g;
        c = u - 1;
      } else
        d == 8 && f == 1 && (D[c] = 1);
      a = d, d & 7 && (f = d);
    }
  }
}
function En(n, t, e, i, s) {
  let r = s == 1 ? 2 : 1;
  for (let o = 0, l = 0, h = 0; o <= i.length; o++) {
    let c = o ? i[o - 1].to : t, a = o < i.length ? i[o].from : e;
    for (let f = c, d, u, g; f < a; f++)
      if (u = Le[d = n.charCodeAt(f)])
        if (u < 0) {
          for (let m = l - 3; m >= 0; m -= 3)
            if (Y[m + 1] == -u) {
              let p = Y[m + 2], b = p & 2 ? s : p & 4 ? p & 1 ? r : s : 0;
              b && (D[f] = D[Y[m]] = b), l = m;
              break;
            }
        } else {
          if (Y.length == 189)
            break;
          Y[l++] = f, Y[l++] = d, Y[l++] = h;
        }
      else if ((g = D[f]) == 2 || g == 1) {
        let m = g == s;
        h = m ? 0 : 1;
        for (let p = l - 3; p >= 0; p -= 3) {
          let b = Y[p + 2];
          if (b & 2)
            break;
          if (m)
            Y[p + 2] |= 2;
          else {
            if (b & 4)
              break;
            Y[p + 2] |= 4;
          }
        }
      }
  }
}
function Pn(n, t, e, i) {
  for (let s = 0, r = i; s <= e.length; s++) {
    let o = s ? e[s - 1].to : n, l = s < e.length ? e[s].from : t;
    for (let h = o; h < l; ) {
      let c = D[h];
      if (c == 256) {
        let a = h + 1;
        for (; ; )
          if (a == l) {
            if (s == e.length)
              break;
            a = e[s++].to, l = s < e.length ? e[s].from : t;
          } else if (D[a] == 256)
            a++;
          else
            break;
        let f = r == 1, d = (a < t ? D[a] : i) == 1, u = f == d ? f ? 1 : 2 : i;
        for (let g = a, m = s, p = m ? e[m - 1].to : n; g > h; )
          g == p && (g = e[--m].from, p = m ? e[m - 1].to : n), D[--g] = u;
        h = a;
      } else
        r = c, h++;
    }
  }
}
function Be(n, t, e, i, s, r, o) {
  let l = i % 2 ? 2 : 1;
  if (i % 2 == s % 2)
    for (let h = t, c = 0; h < e; ) {
      let a = !0, f = !1;
      if (c == r.length || h < r[c].from) {
        let m = D[h];
        m != l && (a = !1, f = m == 16);
      }
      let d = !a && l == 1 ? [] : null, u = a ? i : i + 1, g = h;
      t:
        for (; ; )
          if (c < r.length && g == r[c].from) {
            if (f)
              break t;
            let m = r[c];
            if (!a)
              for (let p = m.to, b = c + 1; ; ) {
                if (p == e)
                  break t;
                if (b < r.length && r[b].from == p)
                  p = r[b++].to;
                else {
                  if (D[p] == l)
                    break t;
                  break;
                }
              }
            if (c++, d)
              d.push(m);
            else {
              m.from > h && o.push(new nt(h, m.from, u));
              let p = m.direction == Et != !(u % 2);
              Ee(n, p ? i + 1 : i, s, m.inner, m.from, m.to, o), h = m.to;
            }
            g = m.to;
          } else {
            if (g == e || (a ? D[g] != l : D[g] == l))
              break;
            g++;
          }
      d ? Be(n, h, g, i + 1, s, d, o) : h < g && o.push(new nt(h, g, u)), h = g;
    }
  else
    for (let h = e, c = r.length; h > t; ) {
      let a = !0, f = !1;
      if (!c || h > r[c - 1].to) {
        let m = D[h - 1];
        m != l && (a = !1, f = m == 16);
      }
      let d = !a && l == 1 ? [] : null, u = a ? i : i + 1, g = h;
      t:
        for (; ; )
          if (c && g == r[c - 1].to) {
            if (f)
              break t;
            let m = r[--c];
            if (!a)
              for (let p = m.from, b = c; ; ) {
                if (p == t)
                  break t;
                if (b && r[b - 1].to == p)
                  p = r[--b].from;
                else {
                  if (D[p - 1] == l)
                    break t;
                  break;
                }
              }
            if (d)
              d.push(m);
            else {
              m.to < h && o.push(new nt(m.to, h, u));
              let p = m.direction == Et != !(u % 2);
              Ee(n, p ? i + 1 : i, s, m.inner, m.from, m.to, o), h = m.from;
            }
            g = m.from;
          } else {
            if (g == t || (a ? D[g - 1] != l : D[g - 1] == l))
              break;
            g--;
          }
      d ? Be(n, g, h, i + 1, s, d, o) : g < h && o.push(new nt(g, h, u)), h = g;
    }
}
function Ee(n, t, e, i, s, r, o) {
  let l = t % 2 ? 2 : 1;
  Bn(n, s, r, i, l), En(n, s, r, i, l), Pn(s, r, i, l), Be(n, s, r, t, e, i, o);
}
function Hn(n, t, e) {
  if (!n)
    return [new nt(0, 0, t == Ms ? 1 : 0)];
  if (t == Et && !e.length && !Ln.test(n))
    return Ds(n.length);
  if (e.length)
    for (; n.length > D.length; )
      D[D.length] = 256;
  let i = [], s = t == Et ? 0 : 1;
  return Ee(n, s, s, e, 0, n.length, i), i;
}
function Ds(n) {
  return [new nt(0, n, 0)];
}
let Os = "";
function Nn(n, t, e, i, s) {
  var r;
  let o = i.head - n.from, l = -1;
  if (o == 0) {
    if (!s || !n.length)
      return null;
    t[0].level != e && (o = t[0].side(!1, e), l = 0);
  } else if (o == n.length) {
    if (s)
      return null;
    let d = t[t.length - 1];
    d.level != e && (o = d.side(!0, e), l = t.length - 1);
  }
  l < 0 && (l = nt.find(t, o, (r = i.bidiLevel) !== null && r !== void 0 ? r : -1, i.assoc));
  let h = t[l];
  o == h.side(s, e) && (h = t[l += s ? 1 : -1], o = h.side(!s, e));
  let c = s == (h.dir == e), a = gt(n.text, o, c);
  if (Os = n.text.slice(Math.min(o, a), Math.max(o, a)), a != h.side(s, e))
    return M.cursor(a + n.from, c ? -1 : 1, h.level);
  let f = l == (s ? t.length - 1 : 0) ? null : t[l + (s ? 1 : -1)];
  return !f && h.level != e ? M.cursor(s ? n.to : n.from, s ? -1 : 1, e) : f && f.level < h.level ? M.cursor(f.side(!s, e) + n.from, s ? 1 : -1, f.level) : M.cursor(a + n.from, s ? -1 : 1, h.level);
}
class ci extends T {
  get length() {
    return this.view.state.doc.length;
  }
  constructor(t) {
    super(), this.view = t, this.decorations = [], this.dynamicDecorationMap = [], this.domChanged = null, this.hasComposition = null, this.markedForComposition = /* @__PURE__ */ new Set(), this.minWidth = 0, this.minWidthFrom = 0, this.minWidthTo = 0, this.impreciseAnchor = null, this.impreciseHead = null, this.forceSelection = !1, this.lastUpdate = Date.now(), this.setDOM(t.contentDOM), this.children = [new B()], this.children[0].setParent(this), this.updateDeco(), this.updateInner([new q(0, 0, 0, t.state.doc.length)], 0, null);
  }
  // Update the document view to a given state.
  update(t) {
    var e;
    let i = t.changedRanges;
    this.minWidth > 0 && i.length && (i.every(({ fromA: c, toA: a }) => a < this.minWidthFrom || c > this.minWidthTo) ? (this.minWidthFrom = t.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = t.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0);
    let s = -1;
    this.view.inputState.composing >= 0 && (!((e = this.domChanged) === null || e === void 0) && e.newSel ? s = this.domChanged.newSel.head : !qn(t.changes, this.hasComposition) && !t.selectionSet && (s = t.state.selection.main.head));
    let r = s > -1 ? Wn(this.view, t.changes, s) : null;
    if (this.domChanged = null, this.hasComposition) {
      this.markedForComposition.clear();
      let { from: c, to: a } = this.hasComposition;
      i = new q(c, a, t.changes.mapPos(c, -1), t.changes.mapPos(a, 1)).addToSet(i.slice());
    }
    this.hasComposition = r ? { from: r.range.fromB, to: r.range.toB } : null, (w.ie || w.chrome) && !r && t && t.state.doc.lines != t.startState.doc.lines && (this.forceSelection = !0);
    let o = this.decorations, l = this.updateDeco(), h = In(o, l, t.changes);
    return i = q.extendWithRanges(i, h), !(this.flags & 7) && i.length == 0 ? !1 : (this.updateInner(i, t.startState.doc.length, r), t.transactions.length && (this.lastUpdate = Date.now()), !0);
  }
  // Used by update and the constructor do perform the actual DOM
  // update
  updateInner(t, e, i) {
    this.view.viewState.mustMeasureContent = !0, this.updateChildren(t, e, i);
    let { observer: s } = this.view;
    s.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let o = w.chrome || w.ios ? { node: s.selectionRange.focusNode, written: !1 } : void 0;
      this.sync(this.view, o), this.flags &= -8, o && (o.written || s.selectionRange.focusNode != o.node) && (this.forceSelection = !0), this.dom.style.height = "";
    }), this.markedForComposition.forEach(
      (o) => o.flags &= -9
      /* ViewFlag.Composition */
    );
    let r = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length)
      for (let o of this.children)
        o instanceof rt && o.widget instanceof fi && r.push(o.dom);
    s.updateGaps(r);
  }
  updateChildren(t, e, i) {
    let s = i ? i.range.addToSet(t.slice()) : t, r = this.childCursor(e);
    for (let o = s.length - 1; ; o--) {
      let l = o >= 0 ? s[o] : null;
      if (!l)
        break;
      let { fromA: h, toA: c, fromB: a, toB: f } = l, d, u, g, m;
      if (i && i.range.fromB < f && i.range.toB > a) {
        let y = Ot.build(this.view.state.doc, a, i.range.fromB, this.decorations, this.dynamicDecorationMap), S = Ot.build(this.view.state.doc, i.range.toB, f, this.decorations, this.dynamicDecorationMap);
        u = y.breakAtStart, g = y.openStart, m = S.openEnd;
        let C = this.compositionView(i);
        S.breakAtStart ? C.breakAfter = 1 : S.content.length && C.merge(C.length, C.length, S.content[0], !1, S.openStart, 0) && (C.breakAfter = S.content[0].breakAfter, S.content.shift()), y.content.length && C.merge(0, 0, y.content[y.content.length - 1], !0, 0, y.openEnd) && y.content.pop(), d = y.content.concat(C).concat(S.content);
      } else
        ({ content: d, breakAtStart: u, openStart: g, openEnd: m } = Ot.build(this.view.state.doc, a, f, this.decorations, this.dynamicDecorationMap));
      let { i: p, off: b } = r.findPos(c, 1), { i: v, off: x } = r.findPos(h, -1);
      ns(this, v, x, p, b, d, u, g, m);
    }
    i && this.fixCompositionDOM(i);
  }
  compositionView(t) {
    let e = new Z(t.text.nodeValue);
    e.flags |= 8;
    for (let { deco: s } of t.marks)
      e = new Q(s, [e], e.length);
    let i = new B();
    return i.append(e, 0), i;
  }
  fixCompositionDOM(t) {
    let e = (r, o) => {
      o.flags |= 8 | (o.children.some(
        (h) => h.flags & 7
        /* ViewFlag.Dirty */
      ) ? 1 : 0), this.markedForComposition.add(o);
      let l = T.get(r);
      l && l != o && (l.dom = null), o.setDOM(r);
    }, i = this.childPos(t.range.fromB, 1), s = this.children[i.i];
    e(t.line, s);
    for (let r = t.marks.length - 1; r >= -1; r--)
      i = s.childPos(i.off, 1), s = s.children[i.i], e(r >= 0 ? t.marks[r].node : t.text, s);
  }
  // Sync the DOM selection to this.state.selection
  updateSelection(t = !1, e = !1) {
    (t || !this.view.observer.selectionRange.focusNode) && this.view.observer.readSelectionRange();
    let i = this.view.root.activeElement, s = i == this.dom, r = !s && Zt(this.dom, this.view.observer.selectionRange) && !(i && this.dom.contains(i));
    if (!(s || e || r))
      return;
    let o = this.forceSelection;
    this.forceSelection = !1;
    let l = this.view.state.selection.main, h = this.moveToLine(this.domAtPos(l.anchor)), c = l.empty ? h : this.moveToLine(this.domAtPos(l.head));
    if (w.gecko && l.empty && !this.hasComposition && Vn(h)) {
      let f = document.createTextNode("");
      this.view.observer.ignore(() => h.node.insertBefore(f, h.node.childNodes[h.offset] || null)), h = c = new H(f, 0), o = !0;
    }
    let a = this.view.observer.selectionRange;
    (o || !a.focusNode || !re(h.node, h.offset, a.anchorNode, a.anchorOffset) || !re(c.node, c.offset, a.focusNode, a.focusOffset)) && (this.view.observer.ignore(() => {
      w.android && w.chrome && this.dom.contains(a.focusNode) && Kn(a.focusNode, this.dom) && (this.dom.blur(), this.dom.focus({ preventScroll: !0 }));
      let f = ne(this.view.root);
      if (f)
        if (l.empty) {
          if (w.gecko) {
            let d = Fn(h.node, h.offset);
            if (d && d != 3) {
              let u = Rs(h.node, h.offset, d == 1 ? 1 : -1);
              u && (h = new H(u.node, u.offset));
            }
          }
          f.collapse(h.node, h.offset), l.bidiLevel != null && f.caretBidiLevel !== void 0 && (f.caretBidiLevel = l.bidiLevel);
        } else if (f.extend) {
          f.collapse(h.node, h.offset);
          try {
            f.extend(c.node, c.offset);
          } catch {
          }
        } else {
          let d = document.createRange();
          l.anchor > l.head && ([h, c] = [c, h]), d.setEnd(c.node, c.offset), d.setStart(h.node, h.offset), f.removeAllRanges(), f.addRange(d);
        }
      r && this.view.root.activeElement == this.dom && (this.dom.blur(), i && i.focus());
    }), this.view.observer.setSelectionRange(h, c)), this.impreciseAnchor = h.precise ? null : new H(a.anchorNode, a.anchorOffset), this.impreciseHead = c.precise ? null : new H(a.focusNode, a.focusOffset);
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view: t } = this, e = t.state.selection.main, i = ne(t.root), { anchorNode: s, anchorOffset: r } = t.observer.selectionRange;
    if (!i || !e.empty || !e.assoc || !i.modify)
      return;
    let o = B.find(this, e.head);
    if (!o)
      return;
    let l = o.posAtStart;
    if (e.head == l || e.head == l + o.length)
      return;
    let h = this.coordsAt(e.head, -1), c = this.coordsAt(e.head, 1);
    if (!h || !c || h.bottom > c.top)
      return;
    let a = this.domAtPos(e.head + e.assoc);
    i.collapse(a.node, a.offset), i.modify("move", e.assoc < 0 ? "forward" : "backward", "lineboundary"), t.observer.readSelectionRange();
    let f = t.observer.selectionRange;
    t.docView.posFromDOM(f.anchorNode, f.anchorOffset) != e.from && i.collapse(s, r);
  }
  // If a position is in/near a block widget, move it to a nearby text
  // line, since we don't want the cursor inside a block widget.
  moveToLine(t) {
    let e = this.dom, i;
    if (t.node != e)
      return t;
    for (let s = t.offset; !i && s < e.childNodes.length; s++) {
      let r = T.get(e.childNodes[s]);
      r instanceof B && (i = r.domAtPos(0));
    }
    for (let s = t.offset - 1; !i && s >= 0; s--) {
      let r = T.get(e.childNodes[s]);
      r instanceof B && (i = r.domAtPos(r.length));
    }
    return i ? new H(i.node, i.offset, !0) : t;
  }
  nearest(t) {
    for (let e = t; e; ) {
      let i = T.get(e);
      if (i && i.rootView == this)
        return i;
      e = e.parentNode;
    }
    return null;
  }
  posFromDOM(t, e) {
    let i = this.nearest(t);
    if (!i)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return i.localPosFromDOM(t, e) + i.posAtStart;
  }
  domAtPos(t) {
    let { i: e, off: i } = this.childCursor().findPos(t, -1);
    for (; e < this.children.length - 1; ) {
      let s = this.children[e];
      if (i < s.length || s instanceof B)
        break;
      e++, i = 0;
    }
    return this.children[e].domAtPos(i);
  }
  coordsAt(t, e) {
    let i = null, s = 0;
    for (let r = this.length, o = this.children.length - 1; o >= 0; o--) {
      let l = this.children[o], h = r - l.breakAfter, c = h - l.length;
      if (h < t)
        break;
      c <= t && (c < t || l.covers(-1)) && (h > t || l.covers(1)) && (!i || l instanceof B && !(i instanceof B && e >= 0)) && (i = l, s = c), r = c;
    }
    return i ? i.coordsAt(t - s, e) : null;
  }
  coordsForChar(t) {
    let { i: e, off: i } = this.childPos(t, 1), s = this.children[e];
    if (!(s instanceof B))
      return null;
    for (; s.children.length; ) {
      let { i: l, off: h } = s.childPos(i, 1);
      for (; ; l++) {
        if (l == s.children.length)
          return null;
        if ((s = s.children[l]).length)
          break;
      }
      i = h;
    }
    if (!(s instanceof Z))
      return null;
    let r = gt(s.text, i);
    if (r == i)
      return null;
    let o = ft(s.dom, i, r).getClientRects();
    for (let l = 0; l < o.length; l++) {
      let h = o[l];
      if (l == o.length - 1 || h.top < h.bottom && h.left < h.right)
        return h;
    }
    return null;
  }
  measureVisibleLineHeights(t) {
    let e = [], { from: i, to: s } = t, r = this.view.contentDOM.clientWidth, o = r > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, l = -1, h = this.view.textDirection == L.LTR;
    for (let c = 0, a = 0; a < this.children.length; a++) {
      let f = this.children[a], d = c + f.length;
      if (d > s)
        break;
      if (c >= i) {
        let u = f.dom.getBoundingClientRect();
        if (e.push(u.height), o) {
          let g = f.dom.lastChild, m = g ? Rt(g) : [];
          if (m.length) {
            let p = m[m.length - 1], b = h ? p.right - u.left : u.right - p.left;
            b > l && (l = b, this.minWidth = r, this.minWidthFrom = c, this.minWidthTo = d);
          }
        }
      }
      c = d + f.breakAfter;
    }
    return e;
  }
  textDirectionAt(t) {
    let { i: e } = this.childPos(t, 1);
    return getComputedStyle(this.children[e].dom).direction == "rtl" ? L.RTL : L.LTR;
  }
  measureTextSize() {
    for (let r of this.children)
      if (r instanceof B) {
        let o = r.measureTextSize();
        if (o)
          return o;
      }
    let t = document.createElement("div"), e, i, s;
    return t.className = "cm-line", t.style.width = "99999px", t.style.position = "absolute", t.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
      this.dom.appendChild(t);
      let r = Rt(t.firstChild)[0];
      e = t.getBoundingClientRect().height, i = r ? r.width / 27 : 7, s = r ? r.height : e, t.remove();
    }), { lineHeight: e, charWidth: i, textHeight: s };
  }
  childCursor(t = this.length) {
    let e = this.children.length;
    return e && (t -= this.children[--e].length), new ss(this.children, t, e);
  }
  computeBlockGapDeco() {
    let t = [], e = this.view.viewState;
    for (let i = 0, s = 0; ; s++) {
      let r = s == e.viewports.length ? null : e.viewports[s], o = r ? r.from - 1 : this.length;
      if (o > i) {
        let l = (e.lineBlockAt(o).bottom - e.lineBlockAt(i).top) / this.view.scaleY;
        t.push(V.replace({
          widget: new fi(l),
          block: !0,
          inclusive: !0,
          isBlockGap: !0
        }).range(i, o));
      }
      if (!r)
        break;
      i = r.to + 1;
    }
    return V.set(t);
  }
  updateDeco() {
    let t = this.view.state.facet(Bt).map((e, i) => (this.dynamicDecorationMap[i] = typeof e == "function") ? e(this.view) : e);
    for (let e = t.length; e < t.length + 3; e++)
      this.dynamicDecorationMap[e] = !1;
    return this.decorations = [
      ...t,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ];
  }
  scrollIntoView(t) {
    let { range: e } = t, i = this.coordsAt(e.head, e.empty ? e.assoc : e.head > e.anchor ? -1 : 1), s;
    if (!i)
      return;
    !e.empty && (s = this.coordsAt(e.anchor, e.anchor > e.head ? -1 : 1)) && (i = {
      left: Math.min(i.left, s.left),
      top: Math.min(i.top, s.top),
      right: Math.max(i.right, s.right),
      bottom: Math.max(i.bottom, s.bottom)
    });
    let r = Cs(this.view), o = {
      left: i.left - r.left,
      top: i.top - r.top,
      right: i.right + r.right,
      bottom: i.bottom + r.bottom
    };
    bn(this.view.scrollDOM, o, e.head < e.anchor ? -1 : 1, t.x, t.y, t.xMargin, t.yMargin, this.view.textDirection == L.LTR);
  }
}
function Vn(n) {
  return n.node.nodeType == 1 && n.node.firstChild && (n.offset == 0 || n.node.childNodes[n.offset - 1].contentEditable == "false") && (n.offset == n.node.childNodes.length || n.node.childNodes[n.offset].contentEditable == "false");
}
class fi extends Nt {
  constructor(t) {
    super(), this.height = t;
  }
  toDOM() {
    let t = document.createElement("div");
    return this.updateDOM(t), t;
  }
  eq(t) {
    return t.height == this.height;
  }
  updateDOM(t) {
    return t.style.height = this.height + "px", !0;
  }
  get estimatedHeight() {
    return this.height;
  }
}
function Ts(n, t) {
  let e = n.observer.selectionRange, i = e.focusNode && Rs(e.focusNode, e.focusOffset, 0);
  if (!i)
    return null;
  let s = t - i.offset;
  return { from: s, to: s + i.node.nodeValue.length, node: i.node };
}
function Wn(n, t, e) {
  let i = Ts(n, e);
  if (!i)
    return null;
  let { node: s, from: r, to: o } = i, l = s.nodeValue;
  if (/[\n\r]/.test(l) || n.state.doc.sliceString(i.from, i.to) != l)
    return null;
  let h = t.invertedDesc, c = new q(h.mapPos(r), h.mapPos(o), r, o), a = [];
  for (let f = s.parentNode; ; f = f.parentNode) {
    let d = T.get(f);
    if (d instanceof Q)
      a.push({ node: f, deco: d.mark });
    else {
      if (d instanceof B || f.nodeName == "DIV" && f.parentNode == n.contentDOM)
        return { range: c, text: s, marks: a, line: f };
      if (f != n.contentDOM)
        a.push({ node: f, deco: new Vt({
          inclusive: !0,
          attributes: kn(f),
          tagName: f.tagName.toLowerCase()
        }) });
      else
        return null;
    }
  }
}
function Rs(n, t, e) {
  if (e <= 0)
    for (let i = n, s = t; ; ) {
      if (i.nodeType == 3)
        return { node: i, offset: s };
      if (i.nodeType == 1 && s > 0)
        i = i.childNodes[s - 1], s = J(i);
      else
        break;
    }
  if (e >= 0)
    for (let i = n, s = t; ; ) {
      if (i.nodeType == 3)
        return { node: i, offset: s };
      if (i.nodeType == 1 && s < i.childNodes.length && e >= 0)
        i = i.childNodes[s], s = 0;
      else
        break;
    }
  return null;
}
function Fn(n, t) {
  return n.nodeType != 1 ? 0 : (t && n.childNodes[t - 1].contentEditable == "false" ? 1 : 0) | (t < n.childNodes.length && n.childNodes[t].contentEditable == "false" ? 2 : 0);
}
let zn = class {
  constructor() {
    this.changes = [];
  }
  compareRange(t, e) {
    Te(t, e, this.changes);
  }
  comparePoint(t, e) {
    Te(t, e, this.changes);
  }
};
function In(n, t, e) {
  let i = new zn();
  return F.compare(n, t, e, i), i.changes;
}
function Kn(n, t) {
  for (let e = n; e && e != t; e = e.assignedSlot || e.parentNode)
    if (e.nodeType == 1 && e.contentEditable == "false")
      return !0;
  return !1;
}
function qn(n, t) {
  let e = !1;
  return t && n.iterChangedRanges((i, s) => {
    i < t.to && s > t.from && (e = !0);
  }), e;
}
function jn(n, t, e = 1) {
  let i = n.charCategorizer(t), s = n.doc.lineAt(t), r = t - s.from;
  if (s.length == 0)
    return M.cursor(t);
  r == 0 ? e = 1 : r == s.length && (e = -1);
  let o = r, l = r;
  e < 0 ? o = gt(s.text, r, !1) : l = gt(s.text, r);
  let h = i(s.text.slice(o, l));
  for (; o > 0; ) {
    let c = gt(s.text, o, !1);
    if (i(s.text.slice(c, o)) != h)
      break;
    o = c;
  }
  for (; l < s.length; ) {
    let c = gt(s.text, l);
    if (i(s.text.slice(l, c)) != h)
      break;
    l = c;
  }
  return M.range(o + s.from, l + s.from);
}
function Yn(n, t) {
  return t.left > n ? t.left - n : Math.max(0, n - t.right);
}
function Gn(n, t) {
  return t.top > n ? t.top - n : Math.max(0, n - t.bottom);
}
function ge(n, t) {
  return n.top < t.bottom - 1 && n.bottom > t.top + 1;
}
function di(n, t) {
  return t < n.top ? { top: t, left: n.left, right: n.right, bottom: n.bottom } : n;
}
function ui(n, t) {
  return t > n.bottom ? { top: n.top, left: n.left, right: n.right, bottom: t } : n;
}
function Pe(n, t, e) {
  let i, s, r, o, l = !1, h, c, a, f;
  for (let g = n.firstChild; g; g = g.nextSibling) {
    let m = Rt(g);
    for (let p = 0; p < m.length; p++) {
      let b = m[p];
      s && ge(s, b) && (b = di(ui(b, s.bottom), s.top));
      let v = Yn(t, b), x = Gn(e, b);
      if (v == 0 && x == 0)
        return g.nodeType == 3 ? gi(g, t, e) : Pe(g, t, e);
      if (!i || o > x || o == x && r > v) {
        i = g, s = b, r = v, o = x;
        let y = x ? e < b.top ? -1 : 1 : v ? t < b.left ? -1 : 1 : 0;
        l = !y || (y > 0 ? p < m.length - 1 : p > 0);
      }
      v == 0 ? e > b.bottom && (!a || a.bottom < b.bottom) ? (h = g, a = b) : e < b.top && (!f || f.top > b.top) && (c = g, f = b) : a && ge(a, b) ? a = ui(a, b.bottom) : f && ge(f, b) && (f = di(f, b.top));
    }
  }
  if (a && a.bottom >= e ? (i = h, s = a) : f && f.top <= e && (i = c, s = f), !i)
    return { node: n, offset: 0 };
  let d = Math.max(s.left, Math.min(s.right, t));
  if (i.nodeType == 3)
    return gi(i, d, e);
  if (l && i.contentEditable != "false")
    return Pe(i, d, e);
  let u = Array.prototype.indexOf.call(n.childNodes, i) + (t >= (s.left + s.right) / 2 ? 1 : 0);
  return { node: n, offset: u };
}
function gi(n, t, e) {
  let i = n.nodeValue.length, s = -1, r = 1e9, o = 0;
  for (let l = 0; l < i; l++) {
    let h = ft(n, l, l + 1).getClientRects();
    for (let c = 0; c < h.length; c++) {
      let a = h[c];
      if (a.top == a.bottom)
        continue;
      o || (o = t - a.left);
      let f = (a.top > e ? a.top - e : e - a.bottom) - 1;
      if (a.left - 1 <= t && a.right + 1 >= t && f < r) {
        let d = t >= (a.left + a.right) / 2, u = d;
        if ((w.chrome || w.gecko) && ft(n, l).getBoundingClientRect().left == a.right && (u = !d), f <= 0)
          return { node: n, offset: l + (u ? 1 : 0) };
        s = l + (u ? 1 : 0), r = f;
      }
    }
  }
  return { node: n, offset: s > -1 ? s : o > 0 ? n.nodeValue.length : 0 };
}
function Ls(n, t, e, i = -1) {
  var s, r;
  let o = n.contentDOM.getBoundingClientRect(), l = o.top + n.viewState.paddingTop, h, { docHeight: c } = n.viewState, { x: a, y: f } = t, d = f - l;
  if (d < 0)
    return 0;
  if (d > c)
    return n.state.doc.length;
  for (let y = n.viewState.heightOracle.textHeight / 2, S = !1; h = n.elementAtHeight(d), h.type != N.Text; )
    for (; d = i > 0 ? h.bottom + y : h.top - y, !(d >= 0 && d <= c); ) {
      if (S)
        return e ? null : 0;
      S = !0, i = -i;
    }
  f = l + d;
  let u = h.from;
  if (u < n.viewport.from)
    return n.viewport.from == 0 ? 0 : e ? null : pi(n, o, h, a, f);
  if (u > n.viewport.to)
    return n.viewport.to == n.state.doc.length ? n.state.doc.length : e ? null : pi(n, o, h, a, f);
  let g = n.dom.ownerDocument, m = n.root.elementFromPoint ? n.root : g, p = m.elementFromPoint(a, f);
  p && !n.contentDOM.contains(p) && (p = null), p || (a = Math.max(o.left + 1, Math.min(o.right - 1, a)), p = m.elementFromPoint(a, f), p && !n.contentDOM.contains(p) && (p = null));
  let b, v = -1;
  if (p && ((s = n.docView.nearest(p)) === null || s === void 0 ? void 0 : s.isEditable) != !1) {
    if (g.caretPositionFromPoint) {
      let y = g.caretPositionFromPoint(a, f);
      y && ({ offsetNode: b, offset: v } = y);
    } else if (g.caretRangeFromPoint) {
      let y = g.caretRangeFromPoint(a, f);
      y && ({ startContainer: b, startOffset: v } = y, (!n.contentDOM.contains(b) || w.safari && _n(b, v, a) || w.chrome && Xn(b, v, a)) && (b = void 0));
    }
  }
  if (!b || !n.docView.dom.contains(b)) {
    let y = B.find(n.docView, u);
    if (!y)
      return d > h.top + h.height / 2 ? h.to : h.from;
    ({ node: b, offset: v } = Pe(y.dom, a, f));
  }
  let x = n.docView.nearest(b);
  if (!x)
    return null;
  if (x.isWidget && ((r = x.dom) === null || r === void 0 ? void 0 : r.nodeType) == 1) {
    let y = x.dom.getBoundingClientRect();
    return t.y < y.top || t.y <= y.bottom && t.x <= (y.left + y.right) / 2 ? x.posAtStart : x.posAtEnd;
  } else
    return x.localPosFromDOM(b, v) + x.posAtStart;
}
function pi(n, t, e, i, s) {
  let r = Math.round((i - t.left) * n.defaultCharacterWidth);
  if (n.lineWrapping && e.height > n.defaultLineHeight * 1.5) {
    let l = n.viewState.heightOracle.textHeight, h = Math.floor((s - e.top - (n.defaultLineHeight - l) * 0.5) / l);
    r += h * n.viewState.heightOracle.lineLength;
  }
  let o = n.state.sliceDoc(e.from, e.to);
  return e.from + xe(o, r, n.state.tabSize);
}
function _n(n, t, e) {
  let i;
  if (n.nodeType != 3 || t != (i = n.nodeValue.length))
    return !1;
  for (let s = n.nextSibling; s; s = s.nextSibling)
    if (s.nodeType != 1 || s.nodeName != "BR")
      return !1;
  return ft(n, i - 1, i).getBoundingClientRect().left > e;
}
function Xn(n, t, e) {
  if (t != 0)
    return !1;
  for (let s = n; ; ) {
    let r = s.parentNode;
    if (!r || r.nodeType != 1 || r.firstChild != s)
      return !1;
    if (r.classList.contains("cm-line"))
      break;
    s = r;
  }
  let i = n.nodeType == 1 ? n.getBoundingClientRect() : ft(n, 0, Math.max(n.nodeValue.length, 1)).getBoundingClientRect();
  return e - i.left > 5;
}
function He(n, t) {
  let e = n.lineBlockAt(t);
  if (Array.isArray(e.type)) {
    for (let i of e.type)
      if (i.to > t || i.to == t && (i.to == e.to || i.type == N.Text))
        return i;
  }
  return e;
}
function $n(n, t, e, i) {
  let s = He(n, t.head), r = !i || s.type != N.Text || !(n.lineWrapping || s.widgetLineBreaks) ? null : n.coordsAtPos(t.assoc < 0 && t.head > s.from ? t.head - 1 : t.head);
  if (r) {
    let o = n.dom.getBoundingClientRect(), l = n.textDirectionAt(s.from), h = n.posAtCoords({
      x: e == (l == L.LTR) ? o.right - 1 : o.left + 1,
      y: (r.top + r.bottom) / 2
    });
    if (h != null)
      return M.cursor(h, e ? -1 : 1);
  }
  return M.cursor(e ? s.to : s.from, e ? -1 : 1);
}
function mi(n, t, e, i) {
  let s = n.state.doc.lineAt(t.head), r = n.bidiSpans(s), o = n.textDirectionAt(s.from);
  for (let l = t, h = null; ; ) {
    let c = Nn(s, r, o, l, e), a = Os;
    if (!c) {
      if (s.number == (e ? n.state.doc.lines : 1))
        return l;
      a = `
`, s = n.state.doc.line(s.number + (e ? 1 : -1)), r = n.bidiSpans(s), c = M.cursor(e ? s.from : s.to);
    }
    if (h) {
      if (!h(a))
        return l;
    } else {
      if (!i)
        return c;
      h = i(a);
    }
    l = c;
  }
}
function Un(n, t, e) {
  let i = n.state.charCategorizer(t), s = i(e);
  return (r) => {
    let o = i(r);
    return s == an.Space && (s = o), s == o;
  };
}
function Jn(n, t, e, i) {
  let s = t.head, r = e ? 1 : -1;
  if (s == (e ? n.state.doc.length : 0))
    return M.cursor(s, t.assoc);
  let o = t.goalColumn, l, h = n.contentDOM.getBoundingClientRect(), c = n.coordsAtPos(s, t.assoc || -1), a = n.documentTop;
  if (c)
    o == null && (o = c.left - h.left), l = r < 0 ? c.top : c.bottom;
  else {
    let u = n.viewState.lineBlockAt(s);
    o == null && (o = Math.min(h.right - h.left, n.defaultCharacterWidth * (s - u.from))), l = (r < 0 ? u.top : u.bottom) + a;
  }
  let f = h.left + o, d = i ?? n.viewState.heightOracle.textHeight >> 1;
  for (let u = 0; ; u += 10) {
    let g = l + (d + u) * r, m = Ls(n, { x: f, y: g }, !1, r);
    if (g < h.top || g > h.bottom || (r < 0 ? m < s : m > s)) {
      let p = n.docView.coordsForChar(m), b = !p || g < p.top ? -1 : 1;
      return M.cursor(m, b, void 0, o);
    }
  }
}
function Qt(n, t, e) {
  for (; ; ) {
    let i = 0;
    for (let s of n)
      s.between(t - 1, t + 1, (r, o, l) => {
        if (t > r && t < o) {
          let h = i || e || (t - r < o - t ? -1 : 1);
          t = h < 0 ? r : o, i = h;
        }
      });
    if (!i)
      return t;
  }
}
function pe(n, t, e) {
  let i = Qt(n.state.facet(Ue).map((s) => s(n)), e.from, t.head > e.from ? -1 : 1);
  return i == e.from ? e : M.cursor(i, i < e.from ? 1 : -1);
}
class Zn {
  setSelectionOrigin(t) {
    this.lastSelectionOrigin = t, this.lastSelectionTime = Date.now();
  }
  constructor(t) {
    this.view = t, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.pendingIOSKey = void 0, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastEscPress = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = /* @__PURE__ */ Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingKey = !1, this.compositionPendingChange = !1, this.mouseSelection = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = t.hasFocus, w.safari && t.contentDOM.addEventListener("input", () => null), w.gecko && gr(t.contentDOM.ownerDocument);
  }
  handleEvent(t) {
    !or(this.view, t) || this.ignoreDuringComposition(t) || t.type == "keydown" && this.keydown(t) || this.runHandlers(t.type, t);
  }
  runHandlers(t, e) {
    let i = this.handlers[t];
    if (i) {
      for (let s of i.observers)
        s(this.view, e);
      for (let s of i.handlers) {
        if (e.defaultPrevented)
          break;
        if (s(this.view, e)) {
          e.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(t) {
    let e = Qn(t), i = this.handlers, s = this.view.contentDOM;
    for (let r in e)
      if (r != "scroll") {
        let o = !e[r].handlers.length, l = i[r];
        l && o != !l.handlers.length && (s.removeEventListener(r, this.handleEvent), l = null), l || s.addEventListener(r, this.handleEvent, { passive: o });
      }
    for (let r in i)
      r != "scroll" && !e[r] && s.removeEventListener(r, this.handleEvent);
    this.handlers = e;
  }
  keydown(t) {
    if (this.lastKeyCode = t.keyCode, this.lastKeyTime = Date.now(), t.keyCode == 9 && Date.now() < this.lastEscPress + 2e3)
      return !0;
    if (t.keyCode != 27 && Es.indexOf(t.keyCode) < 0 && (this.view.inputState.lastEscPress = 0), w.android && w.chrome && !t.synthetic && (t.keyCode == 13 || t.keyCode == 8))
      return this.view.observer.delayAndroidKey(t.key, t.keyCode), !0;
    let e;
    return w.ios && !t.synthetic && !t.altKey && !t.metaKey && ((e = Bs.find((i) => i.keyCode == t.keyCode)) && !t.ctrlKey || tr.indexOf(t.key) > -1 && t.ctrlKey && !t.shiftKey) ? (this.pendingIOSKey = e || t, setTimeout(() => this.flushIOSKey(), 250), !0) : (t.keyCode != 229 && this.view.observer.forceFlush(), !1);
  }
  flushIOSKey() {
    let t = this.pendingIOSKey;
    return t ? (this.pendingIOSKey = void 0, bt(this.view.contentDOM, t.key, t.keyCode)) : !1;
  }
  ignoreDuringComposition(t) {
    return /^key/.test(t.type) ? this.composing > 0 ? !0 : w.safari && !w.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100 ? (this.compositionPendingKey = !1, !0) : !1 : !1;
  }
  startMouseSelection(t) {
    this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = t;
  }
  update(t) {
    this.mouseSelection && this.mouseSelection.update(t), t.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
  }
  destroy() {
    this.mouseSelection && this.mouseSelection.destroy();
  }
}
function bi(n, t) {
  return (e, i) => {
    try {
      return t.call(n, i, e);
    } catch (s) {
      ct(e.state, s);
    }
  };
}
function Qn(n) {
  let t = /* @__PURE__ */ Object.create(null);
  function e(i) {
    return t[i] || (t[i] = { observers: [], handlers: [] });
  }
  for (let i of n) {
    let s = i.spec;
    if (s && s.domEventHandlers)
      for (let r in s.domEventHandlers) {
        let o = s.domEventHandlers[r];
        o && e(r).handlers.push(bi(i.value, o));
      }
    if (s && s.domEventObservers)
      for (let r in s.domEventObservers) {
        let o = s.domEventObservers[r];
        o && e(r).observers.push(bi(i.value, o));
      }
  }
  for (let i in X)
    e(i).handlers.push(X[i]);
  for (let i in j)
    e(i).observers.push(j[i]);
  return t;
}
const Bs = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
], tr = "dthko", Es = [16, 17, 18, 20, 91, 92, 224, 225], jt = 6;
function Yt(n) {
  return Math.max(0, n) * 0.7 + 8;
}
function er(n, t) {
  return Math.max(Math.abs(n.clientX - t.clientX), Math.abs(n.clientY - t.clientY));
}
class ir {
  constructor(t, e, i, s) {
    this.view = t, this.startEvent = e, this.style = i, this.mustSelect = s, this.scrollSpeed = { x: 0, y: 0 }, this.scrolling = -1, this.lastEvent = e, this.scrollParent = wn(t.contentDOM), this.atoms = t.state.facet(Ue).map((o) => o(t));
    let r = t.contentDOM.ownerDocument;
    r.addEventListener("mousemove", this.move = this.move.bind(this)), r.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = e.shiftKey, this.multiple = t.state.facet(Dt.allowMultipleSelections) && sr(t, e), this.dragging = rr(t, e) && Vs(e) == 1 ? null : !1;
  }
  start(t) {
    this.dragging === !1 && this.select(t);
  }
  move(t) {
    var e;
    if (t.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && er(this.startEvent, t) < 10)
      return;
    this.select(this.lastEvent = t);
    let i = 0, s = 0, r = ((e = this.scrollParent) === null || e === void 0 ? void 0 : e.getBoundingClientRect()) || { left: 0, top: 0, right: this.view.win.innerWidth, bottom: this.view.win.innerHeight }, o = Cs(this.view);
    t.clientX - o.left <= r.left + jt ? i = -Yt(r.left - t.clientX) : t.clientX + o.right >= r.right - jt && (i = Yt(t.clientX - r.right)), t.clientY - o.top <= r.top + jt ? s = -Yt(r.top - t.clientY) : t.clientY + o.bottom >= r.bottom - jt && (s = Yt(t.clientY - r.bottom)), this.setScrollSpeed(i, s);
  }
  up(t) {
    this.dragging == null && this.select(this.lastEvent), this.dragging || t.preventDefault(), this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let t = this.view.contentDOM.ownerDocument;
    t.removeEventListener("mousemove", this.move), t.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = null;
  }
  setScrollSpeed(t, e) {
    this.scrollSpeed = { x: t, y: e }, t || e ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
  }
  scroll() {
    this.scrollParent ? (this.scrollParent.scrollLeft += this.scrollSpeed.x, this.scrollParent.scrollTop += this.scrollSpeed.y) : this.view.win.scrollBy(this.scrollSpeed.x, this.scrollSpeed.y), this.dragging === !1 && this.select(this.lastEvent);
  }
  skipAtoms(t) {
    let e = null;
    for (let i = 0; i < t.ranges.length; i++) {
      let s = t.ranges[i], r = null;
      if (s.empty) {
        let o = Qt(this.atoms, s.from, 0);
        o != s.from && (r = M.cursor(o, -1));
      } else {
        let o = Qt(this.atoms, s.from, -1), l = Qt(this.atoms, s.to, 1);
        (o != s.from || l != s.to) && (r = M.range(s.from == s.anchor ? o : l, s.from == s.head ? o : l));
      }
      r && (e || (e = t.ranges.slice()), e[i] = r);
    }
    return e ? M.create(e, t.mainIndex) : t;
  }
  select(t) {
    let { view: e } = this, i = this.skipAtoms(this.style.get(t, this.extend, this.multiple));
    (this.mustSelect || !i.eq(e.state.selection) || i.main.assoc != e.state.selection.main.assoc && this.dragging === !1) && this.view.dispatch({
      selection: i,
      userEvent: "select.pointer"
    }), this.mustSelect = !1;
  }
  update(t) {
    t.docChanged && this.dragging && (this.dragging = this.dragging.map(t.changes)), this.style.update(t) && setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function sr(n, t) {
  let e = n.state.facet(ds);
  return e.length ? e[0](t) : w.mac ? t.metaKey : t.ctrlKey;
}
function nr(n, t) {
  let e = n.state.facet(us);
  return e.length ? e[0](t) : w.mac ? !t.altKey : !t.ctrlKey;
}
function rr(n, t) {
  let { main: e } = n.state.selection;
  if (e.empty)
    return !1;
  let i = ne(n.root);
  if (!i || i.rangeCount == 0)
    return !0;
  let s = i.getRangeAt(0).getClientRects();
  for (let r = 0; r < s.length; r++) {
    let o = s[r];
    if (o.left <= t.clientX && o.right >= t.clientX && o.top <= t.clientY && o.bottom >= t.clientY)
      return !0;
  }
  return !1;
}
function or(n, t) {
  if (!t.bubbles)
    return !0;
  if (t.defaultPrevented)
    return !1;
  for (let e = t.target, i; e != n.contentDOM; e = e.parentNode)
    if (!e || e.nodeType == 11 || (i = T.get(e)) && i.ignoreEvent(t))
      return !1;
  return !0;
}
const X = /* @__PURE__ */ Object.create(null), j = /* @__PURE__ */ Object.create(null), Ps = w.ie && w.ie_version < 15 || w.ios && w.webkit_version < 604;
function lr(n) {
  let t = n.dom.parentNode;
  if (!t)
    return;
  let e = t.appendChild(document.createElement("textarea"));
  e.style.cssText = "position: fixed; left: -10000px; top: 10px", e.focus(), setTimeout(() => {
    n.focus(), e.remove(), Hs(n, e.value);
  }, 50);
}
function Hs(n, t) {
  let { state: e } = n, i, s = 1, r = e.toText(t), o = r.lines == e.selection.ranges.length;
  if (Ne != null && e.selection.ranges.every((h) => h.empty) && Ne == r.toString()) {
    let h = -1;
    i = e.changeByRange((c) => {
      let a = e.doc.lineAt(c.from);
      if (a.from == h)
        return { range: c };
      h = a.from;
      let f = e.toText((o ? r.line(s++).text : t) + e.lineBreak);
      return {
        changes: { from: a.from, insert: f },
        range: M.cursor(c.from + f.length)
      };
    });
  } else
    o ? i = e.changeByRange((h) => {
      let c = r.line(s++);
      return {
        changes: { from: h.from, to: h.to, insert: c.text },
        range: M.cursor(h.from + c.length)
      };
    }) : i = e.replaceSelection(r);
  n.dispatch(i, {
    userEvent: "input.paste",
    scrollIntoView: !0
  });
}
j.scroll = (n) => {
  n.inputState.lastScrollTop = n.scrollDOM.scrollTop, n.inputState.lastScrollLeft = n.scrollDOM.scrollLeft;
};
X.keydown = (n, t) => (n.inputState.setSelectionOrigin("select"), t.keyCode == 27 && (n.inputState.lastEscPress = Date.now()), !1);
j.touchstart = (n, t) => {
  n.inputState.lastTouchTime = Date.now(), n.inputState.setSelectionOrigin("select.pointer");
};
j.touchmove = (n) => {
  n.inputState.setSelectionOrigin("select.pointer");
};
X.mousedown = (n, t) => {
  if (n.observer.flush(), n.inputState.lastTouchTime > Date.now() - 2e3)
    return !1;
  let e = null;
  for (let i of n.state.facet(gs))
    if (e = i(n, t), e)
      break;
  if (!e && t.button == 0 && (e = cr(n, t)), e) {
    let i = !n.hasFocus;
    n.inputState.startMouseSelection(new ir(n, t, e, i)), i && n.observer.ignore(() => ts(n.contentDOM));
    let s = n.inputState.mouseSelection;
    if (s)
      return s.start(t), s.dragging === !1;
  }
  return !1;
};
function wi(n, t, e, i) {
  if (i == 1)
    return M.cursor(t, e);
  if (i == 2)
    return jn(n.state, t, e);
  {
    let s = B.find(n.docView, t), r = n.state.doc.lineAt(s ? s.posAtEnd : t), o = s ? s.posAtStart : r.from, l = s ? s.posAtEnd : r.to;
    return l < n.state.doc.length && l == r.to && l++, M.range(o, l);
  }
}
let Ns = (n, t) => n >= t.top && n <= t.bottom, yi = (n, t, e) => Ns(t, e) && n >= e.left && n <= e.right;
function hr(n, t, e, i) {
  let s = B.find(n.docView, t);
  if (!s)
    return 1;
  let r = t - s.posAtStart;
  if (r == 0)
    return 1;
  if (r == s.length)
    return -1;
  let o = s.coordsAt(r, -1);
  if (o && yi(e, i, o))
    return -1;
  let l = s.coordsAt(r, 1);
  return l && yi(e, i, l) ? 1 : o && Ns(i, o) ? -1 : 1;
}
function vi(n, t) {
  let e = n.posAtCoords({ x: t.clientX, y: t.clientY }, !1);
  return { pos: e, bias: hr(n, e, t.clientX, t.clientY) };
}
const ar = w.ie && w.ie_version <= 11;
let Si = null, xi = 0, Ci = 0;
function Vs(n) {
  if (!ar)
    return n.detail;
  let t = Si, e = Ci;
  return Si = n, Ci = Date.now(), xi = !t || e > Date.now() - 400 && Math.abs(t.clientX - n.clientX) < 2 && Math.abs(t.clientY - n.clientY) < 2 ? (xi + 1) % 3 : 1;
}
function cr(n, t) {
  let e = vi(n, t), i = Vs(t), s = n.state.selection;
  return {
    update(r) {
      r.docChanged && (e.pos = r.changes.mapPos(e.pos), s = s.map(r.changes));
    },
    get(r, o, l) {
      let h = vi(n, r), c, a = wi(n, h.pos, h.bias, i);
      if (e.pos != h.pos && !o) {
        let f = wi(n, e.pos, e.bias, i), d = Math.min(f.from, a.from), u = Math.max(f.to, a.to);
        a = d < a.from ? M.range(d, u) : M.range(u, d);
      }
      return o ? s.replaceRange(s.main.extend(a.from, a.to)) : l && i == 1 && s.ranges.length > 1 && (c = fr(s, h.pos)) ? c : l ? s.addRange(a) : M.create([a]);
    }
  };
}
function fr(n, t) {
  for (let e = 0; e < n.ranges.length; e++) {
    let { from: i, to: s } = n.ranges[e];
    if (i <= t && s >= t)
      return M.create(n.ranges.slice(0, e).concat(n.ranges.slice(e + 1)), n.mainIndex == e ? 0 : n.mainIndex - (n.mainIndex > e ? 1 : 0));
  }
  return null;
}
X.dragstart = (n, t) => {
  let { selection: { main: e } } = n.state, { mouseSelection: i } = n.inputState;
  return i && (i.dragging = e), t.dataTransfer && (t.dataTransfer.setData("Text", n.state.sliceDoc(e.from, e.to)), t.dataTransfer.effectAllowed = "copyMove"), !1;
};
function Mi(n, t, e, i) {
  if (!e)
    return;
  let s = n.posAtCoords({ x: t.clientX, y: t.clientY }, !1), { mouseSelection: r } = n.inputState, o = i && r && r.dragging && nr(n, t) ? { from: r.dragging.from, to: r.dragging.to } : null, l = { from: s, insert: e }, h = n.state.changes(o ? [o, l] : l);
  n.focus(), n.dispatch({
    changes: h,
    selection: { anchor: h.mapPos(s, -1), head: h.mapPos(s, 1) },
    userEvent: o ? "move.drop" : "input.drop"
  });
}
X.drop = (n, t) => {
  if (!t.dataTransfer)
    return !1;
  if (n.state.readOnly)
    return !0;
  let e = t.dataTransfer.files;
  if (e && e.length) {
    let i = Array(e.length), s = 0, r = () => {
      ++s == e.length && Mi(n, t, i.filter((o) => o != null).join(n.state.lineBreak), !1);
    };
    for (let o = 0; o < e.length; o++) {
      let l = new FileReader();
      l.onerror = r, l.onload = () => {
        /[\x00-\x08\x0e-\x1f]{2}/.test(l.result) || (i[o] = l.result), r();
      }, l.readAsText(e[o]);
    }
    return !0;
  } else {
    let i = t.dataTransfer.getData("Text");
    if (i)
      return Mi(n, t, i, !0), !0;
  }
  return !1;
};
X.paste = (n, t) => {
  if (n.state.readOnly)
    return !0;
  n.observer.flush();
  let e = Ps ? null : t.clipboardData;
  return e ? (Hs(n, e.getData("text/plain") || e.getData("text/uri-text")), !0) : (lr(n), !1);
};
function dr(n, t) {
  let e = n.dom.parentNode;
  if (!e)
    return;
  let i = e.appendChild(document.createElement("textarea"));
  i.style.cssText = "position: fixed; left: -10000px; top: 10px", i.value = t, i.focus(), i.selectionEnd = t.length, i.selectionStart = 0, setTimeout(() => {
    i.remove(), n.focus();
  }, 50);
}
function ur(n) {
  let t = [], e = [], i = !1;
  for (let s of n.selection.ranges)
    s.empty || (t.push(n.sliceDoc(s.from, s.to)), e.push(s));
  if (!t.length) {
    let s = -1;
    for (let { from: r } of n.selection.ranges) {
      let o = n.doc.lineAt(r);
      o.number > s && (t.push(o.text), e.push({ from: o.from, to: Math.min(n.doc.length, o.to + 1) })), s = o.number;
    }
    i = !0;
  }
  return { text: t.join(n.lineBreak), ranges: e, linewise: i };
}
let Ne = null;
X.copy = X.cut = (n, t) => {
  let { text: e, ranges: i, linewise: s } = ur(n.state);
  if (!e && !s)
    return !1;
  Ne = s ? e : null, t.type == "cut" && !n.state.readOnly && n.dispatch({
    changes: i,
    scrollIntoView: !0,
    userEvent: "delete.cut"
  });
  let r = Ps ? null : t.clipboardData;
  return r ? (r.clearData(), r.setData("text/plain", e), !0) : (dr(n, e), !1);
};
const Ws = /* @__PURE__ */ hn.define();
function Fs(n, t) {
  let e = [];
  for (let i of n.facet(bs)) {
    let s = i(n, t);
    s && e.push(s);
  }
  return e ? n.update({ effects: e, annotations: Ws.of(!0) }) : null;
}
function zs(n) {
  setTimeout(() => {
    let t = n.hasFocus;
    if (t != n.inputState.notifiedFocused) {
      let e = Fs(n.state, t);
      e ? n.dispatch(e) : n.update([]);
    }
  }, 10);
}
j.focus = (n) => {
  n.inputState.lastFocusTime = Date.now(), !n.scrollDOM.scrollTop && (n.inputState.lastScrollTop || n.inputState.lastScrollLeft) && (n.scrollDOM.scrollTop = n.inputState.lastScrollTop, n.scrollDOM.scrollLeft = n.inputState.lastScrollLeft), zs(n);
};
j.blur = (n) => {
  n.observer.clearSelectionRange(), zs(n);
};
j.compositionstart = j.compositionupdate = (n) => {
  n.inputState.compositionFirstChange == null && (n.inputState.compositionFirstChange = !0), n.inputState.composing < 0 && (n.inputState.composing = 0);
};
j.compositionend = (n) => {
  n.inputState.composing = -1, n.inputState.compositionEndedAt = Date.now(), n.inputState.compositionPendingKey = !0, n.inputState.compositionPendingChange = n.observer.pendingRecords().length > 0, n.inputState.compositionFirstChange = null, w.chrome && w.android ? n.observer.flushSoon() : n.inputState.compositionPendingChange ? Promise.resolve().then(() => n.observer.flush()) : setTimeout(() => {
    n.inputState.composing < 0 && n.docView.hasComposition && n.update([]);
  }, 50);
};
j.contextmenu = (n) => {
  n.inputState.lastContextMenu = Date.now();
};
X.beforeinput = (n, t) => {
  var e;
  let i;
  if (w.chrome && w.android && (i = Bs.find((s) => s.inputType == t.inputType)) && (n.observer.delayAndroidKey(i.key, i.keyCode), i.key == "Backspace" || i.key == "Delete")) {
    let s = ((e = window.visualViewport) === null || e === void 0 ? void 0 : e.height) || 0;
    setTimeout(() => {
      var r;
      (((r = window.visualViewport) === null || r === void 0 ? void 0 : r.height) || 0) > s + 10 && n.hasFocus && (n.contentDOM.blur(), n.focus());
    }, 100);
  }
  return !1;
};
const ki = /* @__PURE__ */ new Set();
function gr(n) {
  ki.has(n) || (ki.add(n), n.addEventListener("copy", () => {
  }), n.addEventListener("cut", () => {
  }));
}
const Ai = ["pre-wrap", "normal", "pre-line", "break-spaces"];
class pr {
  constructor(t) {
    this.lineWrapping = t, this.doc = _.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30, this.heightChanged = !1;
  }
  heightForGap(t, e) {
    let i = this.doc.lineAt(e).number - this.doc.lineAt(t).number + 1;
    return this.lineWrapping && (i += Math.max(0, Math.ceil((e - t - i * this.lineLength * 0.5) / this.lineLength))), this.lineHeight * i;
  }
  heightForLine(t) {
    return this.lineWrapping ? (1 + Math.max(0, Math.ceil((t - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
  }
  setDoc(t) {
    return this.doc = t, this;
  }
  mustRefreshForWrapping(t) {
    return Ai.indexOf(t) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(t) {
    let e = !1;
    for (let i = 0; i < t.length; i++) {
      let s = t[i];
      s < 0 ? i++ : this.heightSamples[Math.floor(s * 10)] || (e = !0, this.heightSamples[Math.floor(s * 10)] = !0);
    }
    return e;
  }
  refresh(t, e, i, s, r, o) {
    let l = Ai.indexOf(t) > -1, h = Math.round(e) != Math.round(this.lineHeight) || this.lineWrapping != l;
    if (this.lineWrapping = l, this.lineHeight = e, this.charWidth = i, this.textHeight = s, this.lineLength = r, h) {
      this.heightSamples = {};
      for (let c = 0; c < o.length; c++) {
        let a = o[c];
        a < 0 ? c++ : this.heightSamples[Math.floor(a * 10)] = !0;
      }
    }
    return h;
  }
}
class mr {
  constructor(t, e) {
    this.from = t, this.heights = e, this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
class G {
  /**
  @internal
  */
  constructor(t, e, i, s, r) {
    this.from = t, this.length = e, this.top = i, this.height = s, this._content = r;
  }
  /**
  The type of element this is. When querying lines, this may be
  an array of all the blocks that make up the line.
  */
  get type() {
    return typeof this._content == "number" ? N.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  /**
  The end of the element as a document position.
  */
  get to() {
    return this.from + this.length;
  }
  /**
  The bottom position of the element.
  */
  get bottom() {
    return this.top + this.height;
  }
  /**
  If this is a widget block, this will return the widget
  associated with it.
  */
  get widget() {
    return this._content instanceof ot ? this._content.widget : null;
  }
  /**
  If this is a textblock, this holds the number of line breaks
  that appear in widgets inside the block.
  */
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  /**
  @internal
  */
  join(t) {
    let e = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(t._content) ? t._content : [t]);
    return new G(this.from, this.length + t.length, this.top, this.height + t.height, e);
  }
}
var O = /* @__PURE__ */ function(n) {
  return n[n.ByPos = 0] = "ByPos", n[n.ByHeight = 1] = "ByHeight", n[n.ByPosNoHeight = 2] = "ByPosNoHeight", n;
}(O || (O = {}));
const te = 1e-3;
class W {
  constructor(t, e, i = 2) {
    this.length = t, this.height = e, this.flags = i;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(t) {
    this.flags = (t ? 2 : 0) | this.flags & -3;
  }
  setHeight(t, e) {
    this.height != e && (Math.abs(this.height - e) > te && (t.heightChanged = !0), this.height = e);
  }
  // Base case is to replace a leaf node, which simply builds a tree
  // from the new nodes and returns that (HeightMapBranch and
  // HeightMapGap override this to actually use from/to)
  replace(t, e, i) {
    return W.of(i);
  }
  // Again, these are base cases, and are overridden for branch and gap nodes.
  decomposeLeft(t, e) {
    e.push(this);
  }
  decomposeRight(t, e) {
    e.push(this);
  }
  applyChanges(t, e, i, s) {
    let r = this, o = i.doc;
    for (let l = s.length - 1; l >= 0; l--) {
      let { fromA: h, toA: c, fromB: a, toB: f } = s[l], d = r.lineAt(h, O.ByPosNoHeight, i.setDoc(e), 0, 0), u = d.to >= c ? d : r.lineAt(c, O.ByPosNoHeight, i, 0, 0);
      for (f += u.to - c, c = u.to; l > 0 && d.from <= s[l - 1].toA; )
        h = s[l - 1].fromA, a = s[l - 1].fromB, l--, h < d.from && (d = r.lineAt(h, O.ByPosNoHeight, i, 0, 0));
      a += d.from - h, h = d.from;
      let g = Je.build(i.setDoc(o), t, a, f);
      r = r.replace(h, c, g);
    }
    return r.updateHeight(i, 0);
  }
  static empty() {
    return new I(0, 0);
  }
  // nodes uses null values to indicate the position of line breaks.
  // There are never line breaks at the start or end of the array, or
  // two line breaks next to each other, and the array isn't allowed
  // to be empty (same restrictions as return value from the builder).
  static of(t) {
    if (t.length == 1)
      return t[0];
    let e = 0, i = t.length, s = 0, r = 0;
    for (; ; )
      if (e == i)
        if (s > r * 2) {
          let l = t[e - 1];
          l.break ? t.splice(--e, 1, l.left, null, l.right) : t.splice(--e, 1, l.left, l.right), i += 1 + l.break, s -= l.size;
        } else if (r > s * 2) {
          let l = t[i];
          l.break ? t.splice(i, 1, l.left, null, l.right) : t.splice(i, 1, l.left, l.right), i += 2 + l.break, r -= l.size;
        } else
          break;
      else if (s < r) {
        let l = t[e++];
        l && (s += l.size);
      } else {
        let l = t[--i];
        l && (r += l.size);
      }
    let o = 0;
    return t[e - 1] == null ? (o = 1, e--) : t[e] == null && (o = 1, i++), new br(W.of(t.slice(0, e)), o, W.of(t.slice(i)));
  }
}
W.prototype.size = 1;
class Is extends W {
  constructor(t, e, i) {
    super(t, e), this.deco = i;
  }
  blockAt(t, e, i, s) {
    return new G(s, this.length, i, this.height, this.deco || 0);
  }
  lineAt(t, e, i, s, r) {
    return this.blockAt(0, i, s, r);
  }
  forEachLine(t, e, i, s, r, o) {
    t <= r + this.length && e >= r && o(this.blockAt(0, i, s, r));
  }
  updateHeight(t, e = 0, i = !1, s) {
    return s && s.from <= e && s.more && this.setHeight(t, s.heights[s.index++]), this.outdated = !1, this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
class I extends Is {
  constructor(t, e) {
    super(t, e, null), this.collapsed = 0, this.widgetHeight = 0, this.breaks = 0;
  }
  blockAt(t, e, i, s) {
    return new G(s, this.length, i, this.height, this.breaks);
  }
  replace(t, e, i) {
    let s = i[0];
    return i.length == 1 && (s instanceof I || s instanceof P && s.flags & 4) && Math.abs(this.length - s.length) < 10 ? (s instanceof P ? s = new I(s.length, this.height) : s.height = this.height, this.outdated || (s.outdated = !1), s) : W.of(i);
  }
  updateHeight(t, e = 0, i = !1, s) {
    return s && s.from <= e && s.more ? this.setHeight(t, s.heights[s.index++]) : (i || this.outdated) && this.setHeight(t, Math.max(this.widgetHeight, t.heightForLine(this.length - this.collapsed)) + this.breaks * t.lineHeight), this.outdated = !1, this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}
class P extends W {
  constructor(t) {
    super(t, 0);
  }
  heightMetrics(t, e) {
    let i = t.doc.lineAt(e).number, s = t.doc.lineAt(e + this.length).number, r = s - i + 1, o, l = 0;
    if (t.lineWrapping) {
      let h = Math.min(this.height, t.lineHeight * r);
      o = h / r, this.length > r + 1 && (l = (this.height - h) / (this.length - r - 1));
    } else
      o = this.height / r;
    return { firstLine: i, lastLine: s, perLine: o, perChar: l };
  }
  blockAt(t, e, i, s) {
    let { firstLine: r, lastLine: o, perLine: l, perChar: h } = this.heightMetrics(e, s);
    if (e.lineWrapping) {
      let c = s + Math.round(Math.max(0, Math.min(1, (t - i) / this.height)) * this.length), a = e.doc.lineAt(c), f = l + a.length * h, d = Math.max(i, t - f / 2);
      return new G(a.from, a.length, d, f, 0);
    } else {
      let c = Math.max(0, Math.min(o - r, Math.floor((t - i) / l))), { from: a, length: f } = e.doc.line(r + c);
      return new G(a, f, i + l * c, l, 0);
    }
  }
  lineAt(t, e, i, s, r) {
    if (e == O.ByHeight)
      return this.blockAt(t, i, s, r);
    if (e == O.ByPosNoHeight) {
      let { from: u, to: g } = i.doc.lineAt(t);
      return new G(u, g - u, 0, 0, 0);
    }
    let { firstLine: o, perLine: l, perChar: h } = this.heightMetrics(i, r), c = i.doc.lineAt(t), a = l + c.length * h, f = c.number - o, d = s + l * f + h * (c.from - r - f);
    return new G(c.from, c.length, Math.max(s, Math.min(d, s + this.height - a)), a, 0);
  }
  forEachLine(t, e, i, s, r, o) {
    t = Math.max(t, r), e = Math.min(e, r + this.length);
    let { firstLine: l, perLine: h, perChar: c } = this.heightMetrics(i, r);
    for (let a = t, f = s; a <= e; ) {
      let d = i.doc.lineAt(a);
      if (a == t) {
        let g = d.number - l;
        f += h * g + c * (t - r - g);
      }
      let u = h + c * d.length;
      o(new G(d.from, d.length, f, u, 0)), f += u, a = d.to + 1;
    }
  }
  replace(t, e, i) {
    let s = this.length - e;
    if (s > 0) {
      let r = i[i.length - 1];
      r instanceof P ? i[i.length - 1] = new P(r.length + s) : i.push(null, new P(s - 1));
    }
    if (t > 0) {
      let r = i[0];
      r instanceof P ? i[0] = new P(t + r.length) : i.unshift(new P(t - 1), null);
    }
    return W.of(i);
  }
  decomposeLeft(t, e) {
    e.push(new P(t - 1), null);
  }
  decomposeRight(t, e) {
    e.push(null, new P(this.length - t - 1));
  }
  updateHeight(t, e = 0, i = !1, s) {
    let r = e + this.length;
    if (s && s.from <= e + this.length && s.more) {
      let o = [], l = Math.max(e, s.from), h = -1;
      for (s.from > e && o.push(new P(s.from - e - 1).updateHeight(t, e)); l <= r && s.more; ) {
        let a = t.doc.lineAt(l).length;
        o.length && o.push(null);
        let f = s.heights[s.index++];
        h == -1 ? h = f : Math.abs(f - h) >= te && (h = -2);
        let d = new I(a, f);
        d.outdated = !1, o.push(d), l += a + 1;
      }
      l <= r && o.push(null, new P(r - l).updateHeight(t, l));
      let c = W.of(o);
      return (h < 0 || Math.abs(c.height - this.height) >= te || Math.abs(h - this.heightMetrics(t, e).perLine) >= te) && (t.heightChanged = !0), c;
    } else
      (i || this.outdated) && (this.setHeight(t, t.heightForGap(e, e + this.length)), this.outdated = !1);
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}
class br extends W {
  constructor(t, e, i) {
    super(t.length + e + i.length, t.height + i.height, e | (t.outdated || i.outdated ? 2 : 0)), this.left = t, this.right = i, this.size = t.size + i.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(t, e, i, s) {
    let r = i + this.left.height;
    return t < r ? this.left.blockAt(t, e, i, s) : this.right.blockAt(t, e, r, s + this.left.length + this.break);
  }
  lineAt(t, e, i, s, r) {
    let o = s + this.left.height, l = r + this.left.length + this.break, h = e == O.ByHeight ? t < o : t < l, c = h ? this.left.lineAt(t, e, i, s, r) : this.right.lineAt(t, e, i, o, l);
    if (this.break || (h ? c.to < l : c.from > l))
      return c;
    let a = e == O.ByPosNoHeight ? O.ByPosNoHeight : O.ByPos;
    return h ? c.join(this.right.lineAt(l, a, i, o, l)) : this.left.lineAt(l, a, i, s, r).join(c);
  }
  forEachLine(t, e, i, s, r, o) {
    let l = s + this.left.height, h = r + this.left.length + this.break;
    if (this.break)
      t < h && this.left.forEachLine(t, e, i, s, r, o), e >= h && this.right.forEachLine(t, e, i, l, h, o);
    else {
      let c = this.lineAt(h, O.ByPos, i, s, r);
      t < c.from && this.left.forEachLine(t, c.from - 1, i, s, r, o), c.to >= t && c.from <= e && o(c), e > c.to && this.right.forEachLine(c.to + 1, e, i, l, h, o);
    }
  }
  replace(t, e, i) {
    let s = this.left.length + this.break;
    if (e < s)
      return this.balanced(this.left.replace(t, e, i), this.right);
    if (t > this.left.length)
      return this.balanced(this.left, this.right.replace(t - s, e - s, i));
    let r = [];
    t > 0 && this.decomposeLeft(t, r);
    let o = r.length;
    for (let l of i)
      r.push(l);
    if (t > 0 && Di(r, o - 1), e < this.length) {
      let l = r.length;
      this.decomposeRight(e, r), Di(r, l);
    }
    return W.of(r);
  }
  decomposeLeft(t, e) {
    let i = this.left.length;
    if (t <= i)
      return this.left.decomposeLeft(t, e);
    e.push(this.left), this.break && (i++, t >= i && e.push(null)), t > i && this.right.decomposeLeft(t - i, e);
  }
  decomposeRight(t, e) {
    let i = this.left.length, s = i + this.break;
    if (t >= s)
      return this.right.decomposeRight(t - s, e);
    t < i && this.left.decomposeRight(t, e), this.break && t < s && e.push(null), e.push(this.right);
  }
  balanced(t, e) {
    return t.size > 2 * e.size || e.size > 2 * t.size ? W.of(this.break ? [t, null, e] : [t, e]) : (this.left = t, this.right = e, this.height = t.height + e.height, this.outdated = t.outdated || e.outdated, this.size = t.size + e.size, this.length = t.length + this.break + e.length, this);
  }
  updateHeight(t, e = 0, i = !1, s) {
    let { left: r, right: o } = this, l = e + r.length + this.break, h = null;
    return s && s.from <= e + r.length && s.more ? h = r = r.updateHeight(t, e, i, s) : r.updateHeight(t, e, i), s && s.from <= l + o.length && s.more ? h = o = o.updateHeight(t, l, i, s) : o.updateHeight(t, l, i), h ? this.balanced(r, o) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function Di(n, t) {
  let e, i;
  n[t] == null && (e = n[t - 1]) instanceof P && (i = n[t + 1]) instanceof P && n.splice(t - 1, 3, new P(e.length + 1 + i.length));
}
const wr = 5;
class Je {
  constructor(t, e) {
    this.pos = t, this.oracle = e, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = t;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(t, e) {
    if (this.lineStart > -1) {
      let i = Math.min(e, this.lineEnd), s = this.nodes[this.nodes.length - 1];
      s instanceof I ? s.length += i - this.pos : (i > this.pos || !this.isCovered) && this.nodes.push(new I(i - this.pos, -1)), this.writtenTo = i, e > i && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
    }
    this.pos = e;
  }
  point(t, e, i) {
    if (t < e || i.heightRelevant) {
      let s = i.widget ? i.widget.estimatedHeight : 0, r = i.widget ? i.widget.lineBreaks : 0;
      s < 0 && (s = this.oracle.lineHeight);
      let o = e - t;
      i.block ? this.addBlock(new Is(o, s, i)) : (o || r || s >= wr) && this.addLineDeco(s, r, o);
    } else
      e > t && this.span(t, e);
    this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from: t, to: e } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = t, this.lineEnd = e, this.writtenTo < t && ((this.writtenTo < t - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, t - 1)), this.nodes.push(null)), this.pos > t && this.nodes.push(new I(this.pos - t, -1)), this.writtenTo = this.pos;
  }
  blankContent(t, e) {
    let i = new P(e - t);
    return this.oracle.doc.lineAt(t).to == e && (i.flags |= 4), i;
  }
  ensureLine() {
    this.enterLine();
    let t = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (t instanceof I)
      return t;
    let e = new I(0, -1);
    return this.nodes.push(e), e;
  }
  addBlock(t) {
    this.enterLine();
    let e = t.deco;
    e && e.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(t), this.writtenTo = this.pos = this.pos + t.length, e && e.endSide > 0 && (this.covering = t);
  }
  addLineDeco(t, e, i) {
    let s = this.ensureLine();
    s.length += i, s.collapsed += i, s.widgetHeight = Math.max(s.widgetHeight, t), s.breaks += e, this.writtenTo = this.pos = this.pos + i;
  }
  finish(t) {
    let e = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    this.lineStart > -1 && !(e instanceof I) && !this.isCovered ? this.nodes.push(new I(0, -1)) : (this.writtenTo < this.pos || e == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let i = t;
    for (let s of this.nodes)
      s instanceof I && s.updateHeight(this.oracle, i), i += s ? s.length : 1;
    return this.nodes;
  }
  // Always called with a region that on both sides either stretches
  // to a line break or the end of the document.
  // The returned array uses null to indicate line breaks, but never
  // starts or ends in a line break, or has multiple line breaks next
  // to each other.
  static build(t, e, i, s) {
    let r = new Je(i, t);
    return F.spans(e, i, s, r, 0), r.finish(i);
  }
}
function yr(n, t, e) {
  let i = new vr();
  return F.compare(n, t, e, i, 0), i.changes;
}
class vr {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(t, e, i, s) {
    (t < e || i && i.heightRelevant || s && s.heightRelevant) && Te(t, e, this.changes, 5);
  }
}
function Sr(n, t) {
  let e = n.getBoundingClientRect(), i = n.ownerDocument, s = i.defaultView || window, r = Math.max(0, e.left), o = Math.min(s.innerWidth, e.right), l = Math.max(0, e.top), h = Math.min(s.innerHeight, e.bottom);
  for (let c = n.parentNode; c && c != i.body; )
    if (c.nodeType == 1) {
      let a = c, f = window.getComputedStyle(a);
      if ((a.scrollHeight > a.clientHeight || a.scrollWidth > a.clientWidth) && f.overflow != "visible") {
        let d = a.getBoundingClientRect();
        r = Math.max(r, d.left), o = Math.min(o, d.right), l = Math.max(l, d.top), h = c == n.parentNode ? d.bottom : Math.min(h, d.bottom);
      }
      c = f.position == "absolute" || f.position == "fixed" ? a.offsetParent : a.parentNode;
    } else if (c.nodeType == 11)
      c = c.host;
    else
      break;
  return {
    left: r - e.left,
    right: Math.max(r, o) - e.left,
    top: l - (e.top + t),
    bottom: Math.max(l, h) - (e.top + t)
  };
}
function xr(n, t) {
  let e = n.getBoundingClientRect();
  return {
    left: 0,
    right: e.right - e.left,
    top: t,
    bottom: e.bottom - (e.top + t)
  };
}
class me {
  constructor(t, e, i) {
    this.from = t, this.to = e, this.size = i;
  }
  static same(t, e) {
    if (t.length != e.length)
      return !1;
    for (let i = 0; i < t.length; i++) {
      let s = t[i], r = e[i];
      if (s.from != r.from || s.to != r.to || s.size != r.size)
        return !1;
    }
    return !0;
  }
  draw(t, e) {
    return V.replace({
      widget: new Cr(this.size * (e ? t.scaleY : t.scaleX), e)
    }).range(this.from, this.to);
  }
}
class Cr extends Nt {
  constructor(t, e) {
    super(), this.size = t, this.vertical = e;
  }
  eq(t) {
    return t.size == this.size && t.vertical == this.vertical;
  }
  toDOM() {
    let t = document.createElement("div");
    return this.vertical ? t.style.height = this.size + "px" : (t.style.width = this.size + "px", t.style.height = "2px", t.style.display = "inline-block"), t;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class Oi {
  constructor(t) {
    this.state = t, this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 }, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scrollTop = 0, this.scrolledToBottom = !0, this.scaleX = 1, this.scaleY = 1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = Ti, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = L.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
    let e = t.facet($e).some((i) => typeof i != "function" && i.class == "cm-lineWrapping");
    this.heightOracle = new pr(e), this.stateDeco = t.facet(Bt).filter((i) => typeof i != "function"), this.heightMap = W.empty().applyChanges(this.stateDeco, _.empty, this.heightOracle.setDoc(t.doc), [new q(0, 0, 0, t.doc.length)]), this.viewport = this.getViewport(0, null), this.updateViewportLines(), this.updateForViewport(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = V.set(this.lineGaps.map((i) => i.draw(this, !1))), this.computeVisibleRanges();
  }
  updateForViewport() {
    let t = [this.viewport], { main: e } = this.state.selection;
    for (let i = 0; i <= 1; i++) {
      let s = i ? e.head : e.anchor;
      if (!t.some(({ from: r, to: o }) => s >= r && s <= o)) {
        let { from: r, to: o } = this.lineBlockAt(s);
        t.push(new Gt(r, o));
      }
    }
    this.viewports = t.sort((i, s) => i.from - s.from), this.scaler = this.heightMap.height <= 7e6 ? Ti : new Ar(this.heightOracle, this.heightMap, this.viewports);
  }
  updateViewportLines() {
    this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (t) => {
      this.viewportLines.push(this.scaler.scale == 1 ? t : Mt(t, this.scaler));
    });
  }
  update(t, e = null) {
    this.state = t.state;
    let i = this.stateDeco;
    this.stateDeco = this.state.facet(Bt).filter((a) => typeof a != "function");
    let s = t.changedRanges, r = q.extendWithRanges(s, yr(i, this.stateDeco, t ? t.changes : Ui.empty(this.state.doc.length))), o = this.heightMap.height, l = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    this.heightMap = this.heightMap.applyChanges(this.stateDeco, t.startState.doc, this.heightOracle.setDoc(this.state.doc), r), this.heightMap.height != o && (t.flags |= 2), l ? (this.scrollAnchorPos = t.changes.mapPos(l.from, -1), this.scrollAnchorHeight = l.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = this.heightMap.height);
    let h = r.length ? this.mapViewport(this.viewport, t.changes) : this.viewport;
    (e && (e.range.head < h.from || e.range.head > h.to) || !this.viewportIsAppropriate(h)) && (h = this.getViewport(0, e));
    let c = !t.changes.empty || t.flags & 2 || h.from != this.viewport.from || h.to != this.viewport.to;
    this.viewport = h, this.updateForViewport(), c && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, t.changes))), t.flags |= this.computeVisibleRanges(), e && (this.scrollTarget = e), !this.mustEnforceCursorAssoc && t.selectionSet && t.view.lineWrapping && t.state.selection.main.empty && t.state.selection.main.assoc && !t.state.facet(ys) && (this.mustEnforceCursorAssoc = !0);
  }
  measure(t) {
    let e = t.contentDOM, i = window.getComputedStyle(e), s = this.heightOracle, r = i.whiteSpace;
    this.defaultTextDirection = i.direction == "rtl" ? L.RTL : L.LTR;
    let o = this.heightOracle.mustRefreshForWrapping(r), l = e.getBoundingClientRect(), h = o || this.mustMeasureContent || this.contentDOMHeight != l.height;
    this.contentDOMHeight = l.height, this.mustMeasureContent = !1;
    let c = 0, a = 0;
    if (l.width && l.height) {
      let y = l.width / e.offsetWidth, S = l.height / e.offsetHeight;
      (y > 0.995 && y < 1.005 || !isFinite(y) || Math.abs(l.width - e.offsetWidth) < 1) && (y = 1), (S > 0.995 && S < 1.005 || !isFinite(S) || Math.abs(l.height - e.offsetHeight) < 1) && (S = 1), (this.scaleX != y || this.scaleY != S) && (this.scaleX = y, this.scaleY = S, c |= 8, o = h = !0);
    }
    let f = (parseInt(i.paddingTop) || 0) * this.scaleY, d = (parseInt(i.paddingBottom) || 0) * this.scaleY;
    (this.paddingTop != f || this.paddingBottom != d) && (this.paddingTop = f, this.paddingBottom = d, c |= 10), this.editorWidth != t.scrollDOM.clientWidth && (s.lineWrapping && (h = !0), this.editorWidth = t.scrollDOM.clientWidth, c |= 8);
    let u = t.scrollDOM.scrollTop * this.scaleY;
    this.scrollTop != u && (this.scrollAnchorHeight = -1, this.scrollTop = u), this.scrolledToBottom = is(t.scrollDOM);
    let g = (this.printing ? xr : Sr)(e, this.paddingTop), m = g.top - this.pixelViewport.top, p = g.bottom - this.pixelViewport.bottom;
    this.pixelViewport = g;
    let b = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (b != this.inView && (this.inView = b, b && (h = !0)), !this.inView && !this.scrollTarget)
      return 0;
    let v = l.width;
    if ((this.contentDOMWidth != v || this.editorHeight != t.scrollDOM.clientHeight) && (this.contentDOMWidth = l.width, this.editorHeight = t.scrollDOM.clientHeight, c |= 8), h) {
      let y = t.docView.measureVisibleLineHeights(this.viewport);
      if (s.mustRefreshForHeights(y) && (o = !0), o || s.lineWrapping && Math.abs(v - this.contentDOMWidth) > s.charWidth) {
        let { lineHeight: S, charWidth: C, textHeight: R } = t.docView.measureTextSize();
        o = S > 0 && s.refresh(r, S, C, R, v / C, y), o && (t.docView.minWidth = 0, c |= 8);
      }
      m > 0 && p > 0 ? a = Math.max(m, p) : m < 0 && p < 0 && (a = Math.min(m, p)), s.heightChanged = !1;
      for (let S of this.viewports) {
        let C = S.from == this.viewport.from ? y : t.docView.measureVisibleLineHeights(S);
        this.heightMap = (o ? W.empty().applyChanges(this.stateDeco, _.empty, this.heightOracle, [new q(0, 0, 0, t.state.doc.length)]) : this.heightMap).updateHeight(s, 0, o, new mr(S.from, C));
      }
      s.heightChanged && (c |= 2);
    }
    let x = !this.viewportIsAppropriate(this.viewport, a) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    return x && (this.viewport = this.getViewport(a, this.scrollTarget)), this.updateForViewport(), (c & 2 || x) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(o ? [] : this.lineGaps, t)), c |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, t.docView.enforceCursorAssoc()), c;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(t, e) {
    let i = 0.5 - Math.max(-0.5, Math.min(0.5, t / 1e3 / 2)), s = this.heightMap, r = this.heightOracle, { visibleTop: o, visibleBottom: l } = this, h = new Gt(s.lineAt(o - i * 1e3, O.ByHeight, r, 0, 0).from, s.lineAt(l + (1 - i) * 1e3, O.ByHeight, r, 0, 0).to);
    if (e) {
      let { head: c } = e.range;
      if (c < h.from || c > h.to) {
        let a = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), f = s.lineAt(c, O.ByPos, r, 0, 0), d;
        e.y == "center" ? d = (f.top + f.bottom) / 2 - a / 2 : e.y == "start" || e.y == "nearest" && c < h.from ? d = f.top : d = f.bottom - a, h = new Gt(s.lineAt(d - 1e3 / 2, O.ByHeight, r, 0, 0).from, s.lineAt(d + a + 1e3 / 2, O.ByHeight, r, 0, 0).to);
      }
    }
    return h;
  }
  mapViewport(t, e) {
    let i = e.mapPos(t.from, -1), s = e.mapPos(t.to, 1);
    return new Gt(this.heightMap.lineAt(i, O.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(s, O.ByPos, this.heightOracle, 0, 0).to);
  }
  // Checks if a given viewport covers the visible part of the
  // document and not too much beyond that.
  viewportIsAppropriate({ from: t, to: e }, i = 0) {
    if (!this.inView)
      return !0;
    let { top: s } = this.heightMap.lineAt(t, O.ByPos, this.heightOracle, 0, 0), { bottom: r } = this.heightMap.lineAt(e, O.ByPos, this.heightOracle, 0, 0), { visibleTop: o, visibleBottom: l } = this;
    return (t == 0 || s <= o - Math.max(10, Math.min(
      -i,
      250
      /* VP.MaxCoverMargin */
    ))) && (e == this.state.doc.length || r >= l + Math.max(10, Math.min(
      i,
      250
      /* VP.MaxCoverMargin */
    ))) && s > o - 2 * 1e3 && r < l + 2 * 1e3;
  }
  mapLineGaps(t, e) {
    if (!t.length || e.empty)
      return t;
    let i = [];
    for (let s of t)
      e.touchesRange(s.from, s.to) || i.push(new me(e.mapPos(s.from), e.mapPos(s.to), s.size));
    return i;
  }
  // Computes positions in the viewport where the start or end of a
  // line should be hidden, trying to reuse existing line gaps when
  // appropriate to avoid unneccesary redraws.
  // Uses crude character-counting for the positioning and sizing,
  // since actual DOM coordinates aren't always available and
  // predictable. Relies on generous margins (see LG.Margin) to hide
  // the artifacts this might produce from the user.
  ensureLineGaps(t, e) {
    let i = this.heightOracle.lineWrapping, s = i ? 1e4 : 2e3, r = s >> 1, o = s << 1;
    if (this.defaultTextDirection != L.LTR && !i)
      return [];
    let l = [], h = (c, a, f, d) => {
      if (a - c < r)
        return;
      let u = this.state.selection.main, g = [u.from];
      u.empty || g.push(u.to);
      for (let p of g)
        if (p > c && p < a) {
          h(c, p - 10, f, d), h(p + 10, a, f, d);
          return;
        }
      let m = kr(t, (p) => p.from >= f.from && p.to <= f.to && Math.abs(p.from - c) < r && Math.abs(p.to - a) < r && !g.some((b) => p.from < b && p.to > b));
      if (!m) {
        if (a < f.to && e && i && e.visibleRanges.some((p) => p.from <= a && p.to >= a)) {
          let p = e.moveToLineBoundary(M.cursor(a), !1, !0).head;
          p > c && (a = p);
        }
        m = new me(c, a, this.gapSize(f, c, a, d));
      }
      l.push(m);
    };
    for (let c of this.viewportLines) {
      if (c.length < o)
        continue;
      let a = Mr(c.from, c.to, this.stateDeco);
      if (a.total < o)
        continue;
      let f = this.scrollTarget ? this.scrollTarget.range.head : null, d, u;
      if (i) {
        let g = s / this.heightOracle.lineLength * this.heightOracle.lineHeight, m, p;
        if (f != null) {
          let b = Xt(a, f), v = ((this.visibleBottom - this.visibleTop) / 2 + g) / c.height;
          m = b - v, p = b + v;
        } else
          m = (this.visibleTop - c.top - g) / c.height, p = (this.visibleBottom - c.top + g) / c.height;
        d = _t(a, m), u = _t(a, p);
      } else {
        let g = a.total * this.heightOracle.charWidth, m = s * this.heightOracle.charWidth, p, b;
        if (f != null) {
          let v = Xt(a, f), x = ((this.pixelViewport.right - this.pixelViewport.left) / 2 + m) / g;
          p = v - x, b = v + x;
        } else
          p = (this.pixelViewport.left - m) / g, b = (this.pixelViewport.right + m) / g;
        d = _t(a, p), u = _t(a, b);
      }
      d > c.from && h(c.from, d, c, a), u < c.to && h(u, c.to, c, a);
    }
    return l;
  }
  gapSize(t, e, i, s) {
    let r = Xt(s, i) - Xt(s, e);
    return this.heightOracle.lineWrapping ? t.height * r : s.total * this.heightOracle.charWidth * r;
  }
  updateLineGaps(t) {
    me.same(t, this.lineGaps) || (this.lineGaps = t, this.lineGapDeco = V.set(t.map((e) => e.draw(this, this.heightOracle.lineWrapping))));
  }
  computeVisibleRanges() {
    let t = this.stateDeco;
    this.lineGaps.length && (t = t.concat(this.lineGapDeco));
    let e = [];
    F.spans(t, this.viewport.from, this.viewport.to, {
      span(s, r) {
        e.push({ from: s, to: r });
      },
      point() {
      }
    }, 20);
    let i = e.length != this.visibleRanges.length || this.visibleRanges.some((s, r) => s.from != e[r].from || s.to != e[r].to);
    return this.visibleRanges = e, i ? 4 : 0;
  }
  lineBlockAt(t) {
    return t >= this.viewport.from && t <= this.viewport.to && this.viewportLines.find((e) => e.from <= t && e.to >= t) || Mt(this.heightMap.lineAt(t, O.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(t) {
    return Mt(this.heightMap.lineAt(this.scaler.fromDOM(t), O.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(t) {
    let e = this.lineBlockAtHeight(t + 8);
    return e.from >= this.viewport.from || this.viewportLines[0].top - t > 200 ? e : this.viewportLines[0];
  }
  elementAtHeight(t) {
    return Mt(this.heightMap.blockAt(this.scaler.fromDOM(t), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
class Gt {
  constructor(t, e) {
    this.from = t, this.to = e;
  }
}
function Mr(n, t, e) {
  let i = [], s = n, r = 0;
  return F.spans(e, n, t, {
    span() {
    },
    point(o, l) {
      o > s && (i.push({ from: s, to: o }), r += o - s), s = l;
    }
  }, 20), s < t && (i.push({ from: s, to: t }), r += t - s), { total: r, ranges: i };
}
function _t({ total: n, ranges: t }, e) {
  if (e <= 0)
    return t[0].from;
  if (e >= 1)
    return t[t.length - 1].to;
  let i = Math.floor(n * e);
  for (let s = 0; ; s++) {
    let { from: r, to: o } = t[s], l = o - r;
    if (i <= l)
      return r + i;
    i -= l;
  }
}
function Xt(n, t) {
  let e = 0;
  for (let { from: i, to: s } of n.ranges) {
    if (t <= s) {
      e += t - i;
      break;
    }
    e += s - i;
  }
  return e / n.total;
}
function kr(n, t) {
  for (let e of n)
    if (t(e))
      return e;
}
const Ti = {
  toDOM(n) {
    return n;
  },
  fromDOM(n) {
    return n;
  },
  scale: 1
};
class Ar {
  constructor(t, e, i) {
    let s = 0, r = 0, o = 0;
    this.viewports = i.map(({ from: l, to: h }) => {
      let c = e.lineAt(l, O.ByPos, t, 0, 0).top, a = e.lineAt(h, O.ByPos, t, 0, 0).bottom;
      return s += a - c, { from: l, to: h, top: c, bottom: a, domTop: 0, domBottom: 0 };
    }), this.scale = (7e6 - s) / (e.height - s);
    for (let l of this.viewports)
      l.domTop = o + (l.top - r) * this.scale, o = l.domBottom = l.domTop + (l.bottom - l.top), r = l.bottom;
  }
  toDOM(t) {
    for (let e = 0, i = 0, s = 0; ; e++) {
      let r = e < this.viewports.length ? this.viewports[e] : null;
      if (!r || t < r.top)
        return s + (t - i) * this.scale;
      if (t <= r.bottom)
        return r.domTop + (t - r.top);
      i = r.bottom, s = r.domBottom;
    }
  }
  fromDOM(t) {
    for (let e = 0, i = 0, s = 0; ; e++) {
      let r = e < this.viewports.length ? this.viewports[e] : null;
      if (!r || t < r.domTop)
        return i + (t - s) / this.scale;
      if (t <= r.domBottom)
        return r.top + (t - r.domTop);
      i = r.bottom, s = r.domBottom;
    }
  }
}
function Mt(n, t) {
  if (t.scale == 1)
    return n;
  let e = t.toDOM(n.top), i = t.toDOM(n.bottom);
  return new G(n.from, n.length, e, i - e, Array.isArray(n._content) ? n._content.map((s) => Mt(s, t)) : n._content);
}
const $t = /* @__PURE__ */ k.define({ combine: (n) => n.join(" ") }), Ve = /* @__PURE__ */ k.define({ combine: (n) => n.indexOf(!0) > -1 }), We = /* @__PURE__ */ wt.newName(), Ks = /* @__PURE__ */ wt.newName(), qs = /* @__PURE__ */ wt.newName(), js = { "&light": "." + Ks, "&dark": "." + qs };
function Fe(n, t, e) {
  return new wt(t, {
    finish(i) {
      return /&/.test(i) ? i.replace(/&\w*/, (s) => {
        if (s == "&")
          return n;
        if (!e || !e[s])
          throw new RangeError(`Unsupported selector: ${s}`);
        return e[s];
      }) : n + " " + i;
    }
  });
}
const Dr = /* @__PURE__ */ Fe("." + We, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      // Provide a simple default outline to make sure a focused
      // editor is visually distinct. Can't leave the default behavior
      // because that will apply to the content element, which is
      // inside the scrollable container and doesn't include the
      // gutters. We also can't use an 'auto' outline, since those
      // are, for some reason, drawn behind the element content, which
      // will cause things like the active line background to cover
      // the outline (#297).
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    boxSizing: "border-box",
    minHeight: "100%",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  // Two animations defined so that we can switch between them to
  // restart the animation without forcing another style
  // recomputation.
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#444"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    insetInlineStart: 0,
    zIndex: 200
  },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    borderRight: "1px solid #ddd"
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top"
  },
  ".cm-highlightSpace:before": {
    content: "attr(data-display)",
    position: "absolute",
    pointerEvents: "none",
    color: "#888"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, js), kt = "￿";
class Or {
  constructor(t, e) {
    this.points = t, this.text = "", this.lineSeparator = e.facet(Dt.lineSeparator);
  }
  append(t) {
    this.text += t;
  }
  lineBreak() {
    this.text += kt;
  }
  readRange(t, e) {
    if (!t)
      return this;
    let i = t.parentNode;
    for (let s = t; ; ) {
      this.findPointBefore(i, s);
      let r = this.text.length;
      this.readNode(s);
      let o = s.nextSibling;
      if (o == e)
        break;
      let l = T.get(s), h = T.get(o);
      (l && h ? l.breakAfter : (l ? l.breakAfter : Ri(s)) || Ri(o) && (s.nodeName != "BR" || s.cmIgnore) && this.text.length > r) && this.lineBreak(), s = o;
    }
    return this.findPointBefore(i, e), this;
  }
  readTextNode(t) {
    let e = t.nodeValue;
    for (let i of this.points)
      i.node == t && (i.pos = this.text.length + Math.min(i.offset, e.length));
    for (let i = 0, s = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let r = -1, o = 1, l;
      if (this.lineSeparator ? (r = e.indexOf(this.lineSeparator, i), o = this.lineSeparator.length) : (l = s.exec(e)) && (r = l.index, o = l[0].length), this.append(e.slice(i, r < 0 ? e.length : r)), r < 0)
        break;
      if (this.lineBreak(), o > 1)
        for (let h of this.points)
          h.node == t && h.pos > this.text.length && (h.pos -= o - 1);
      i = r + o;
    }
  }
  readNode(t) {
    if (t.cmIgnore)
      return;
    let e = T.get(t), i = e && e.overrideDOMText;
    if (i != null) {
      this.findPointInside(t, i.length);
      for (let s = i.iter(); !s.next().done; )
        s.lineBreak ? this.lineBreak() : this.append(s.value);
    } else
      t.nodeType == 3 ? this.readTextNode(t) : t.nodeName == "BR" ? t.nextSibling && this.lineBreak() : t.nodeType == 1 && this.readRange(t.firstChild, null);
  }
  findPointBefore(t, e) {
    for (let i of this.points)
      i.node == t && t.childNodes[i.offset] == e && (i.pos = this.text.length);
  }
  findPointInside(t, e) {
    for (let i of this.points)
      (t.nodeType == 3 ? i.node == t : t.contains(i.node)) && (i.pos = this.text.length + (Tr(t, i.node, i.offset) ? e : 0));
  }
}
function Tr(n, t, e) {
  for (; ; ) {
    if (!t || e < J(t))
      return !1;
    if (t == n)
      return !0;
    e = Lt(t) + 1, t = t.parentNode;
  }
}
function Ri(n) {
  return n.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(n.nodeName);
}
class Li {
  constructor(t, e) {
    this.node = t, this.offset = e, this.pos = -1;
  }
}
class Rr {
  constructor(t, e, i, s) {
    this.typeOver = s, this.bounds = null, this.text = "";
    let { impreciseHead: r, impreciseAnchor: o } = t.docView;
    if (t.state.readOnly && e > -1)
      this.newSel = null;
    else if (e > -1 && (this.bounds = t.docView.domBoundsAround(e, i, 0))) {
      let l = r || o ? [] : Er(t), h = new Or(l, t.state);
      h.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = h.text, this.newSel = Pr(l, this.bounds.from);
    } else {
      let l = t.observer.selectionRange, h = r && r.node == l.focusNode && r.offset == l.focusOffset || !Ce(t.contentDOM, l.focusNode) ? t.state.selection.main.head : t.docView.posFromDOM(l.focusNode, l.focusOffset), c = o && o.node == l.anchorNode && o.offset == l.anchorOffset || !Ce(t.contentDOM, l.anchorNode) ? t.state.selection.main.anchor : t.docView.posFromDOM(l.anchorNode, l.anchorOffset);
      this.newSel = M.single(c, h);
    }
  }
}
function Ys(n, t) {
  let e, { newSel: i } = t, s = n.state.selection.main, r = n.inputState.lastKeyTime > Date.now() - 100 ? n.inputState.lastKeyCode : -1;
  if (t.bounds) {
    let { from: o, to: l } = t.bounds, h = s.from, c = null;
    (r === 8 || w.android && t.text.length < l - o) && (h = s.to, c = "end");
    let a = Br(n.state.doc.sliceString(o, l, kt), t.text, h - o, c);
    a && (w.chrome && r == 13 && a.toB == a.from + 2 && t.text.slice(a.from, a.toB) == kt + kt && a.toB--, e = {
      from: o + a.from,
      to: o + a.toA,
      insert: _.of(t.text.slice(a.from, a.toB).split(kt))
    });
  } else
    i && (!n.hasFocus && n.state.facet(fe) || i.main.eq(s)) && (i = null);
  if (!e && !i)
    return !1;
  if (!e && t.typeOver && !s.empty && i && i.main.empty ? e = { from: s.from, to: s.to, insert: n.state.doc.slice(s.from, s.to) } : e && e.from >= s.from && e.to <= s.to && (e.from != s.from || e.to != s.to) && s.to - s.from - (e.to - e.from) <= 4 ? e = {
    from: s.from,
    to: s.to,
    insert: n.state.doc.slice(s.from, e.from).append(e.insert).append(n.state.doc.slice(e.to, s.to))
  } : (w.mac || w.android) && e && e.from == e.to && e.from == s.head - 1 && /^\. ?$/.test(e.insert.toString()) && n.contentDOM.getAttribute("autocorrect") == "off" ? (i && e.insert.length == 2 && (i = M.single(i.main.anchor - 1, i.main.head - 1)), e = { from: s.from, to: s.to, insert: _.of([" "]) }) : w.chrome && e && e.from == e.to && e.from == s.head && e.insert.toString() == `
 ` && n.lineWrapping && (i && (i = M.single(i.main.anchor - 1, i.main.head - 1)), e = { from: s.from, to: s.to, insert: _.of([" "]) }), e) {
    if (w.ios && n.inputState.flushIOSKey() || w.android && (e.from == s.from && e.to == s.to && e.insert.length == 1 && e.insert.lines == 2 && bt(n.contentDOM, "Enter", 13) || (e.from == s.from - 1 && e.to == s.to && e.insert.length == 0 || r == 8 && e.insert.length < e.to - e.from && e.to > s.head) && bt(n.contentDOM, "Backspace", 8) || e.from == s.from && e.to == s.to + 1 && e.insert.length == 0 && bt(n.contentDOM, "Delete", 46)))
      return !0;
    let o = e.insert.toString();
    n.inputState.composing >= 0 && n.inputState.composing++;
    let l, h = () => l || (l = Lr(n, e, i));
    return n.state.facet(ms).some((c) => c(n, e.from, e.to, o, h)) || n.dispatch(h()), !0;
  } else if (i && !i.main.eq(s)) {
    let o = !1, l = "select";
    return n.inputState.lastSelectionTime > Date.now() - 50 && (n.inputState.lastSelectionOrigin == "select" && (o = !0), l = n.inputState.lastSelectionOrigin), n.dispatch({ selection: i, scrollIntoView: o, userEvent: l }), !0;
  } else
    return !1;
}
function Lr(n, t, e) {
  let i, s = n.state, r = s.selection.main;
  if (t.from >= r.from && t.to <= r.to && t.to - t.from >= (r.to - r.from) / 3 && (!e || e.main.empty && e.main.from == t.from + t.insert.length) && n.inputState.composing < 0) {
    let l = r.from < t.from ? s.sliceDoc(r.from, t.from) : "", h = r.to > t.to ? s.sliceDoc(t.to, r.to) : "";
    i = s.replaceSelection(n.state.toText(l + t.insert.sliceString(0, void 0, n.state.lineBreak) + h));
  } else {
    let l = s.changes(t), h = e && e.main.to <= l.newLength ? e.main : void 0;
    if (s.selection.ranges.length > 1 && n.inputState.composing >= 0 && t.to <= r.to && t.to >= r.to - 10) {
      let c = n.state.sliceDoc(t.from, t.to), a, f = e && Ts(n, e.main.head);
      if (f) {
        let g = t.insert.length - (t.to - t.from);
        a = { from: f.from, to: f.to - g };
      } else
        a = n.state.doc.lineAt(r.head);
      let d = r.to - t.to, u = r.to - r.from;
      i = s.changeByRange((g) => {
        if (g.from == r.from && g.to == r.to)
          return { changes: l, range: h || g.map(l) };
        let m = g.to - d, p = m - c.length;
        if (g.to - g.from != u || n.state.sliceDoc(p, m) != c || // Unfortunately, there's no way to make multiple
        // changes in the same node work without aborting
        // composition, so cursors in the composition range are
        // ignored.
        g.to >= a.from && g.from <= a.to)
          return { range: g };
        let b = s.changes({ from: p, to: m, insert: t.insert }), v = g.to - r.to;
        return {
          changes: b,
          range: h ? M.range(Math.max(0, h.anchor + v), Math.max(0, h.head + v)) : g.map(b)
        };
      });
    } else
      i = {
        changes: l,
        selection: h && s.selection.replaceRange(h)
      };
  }
  let o = "input.type";
  return (n.composing || n.inputState.compositionPendingChange && n.inputState.compositionEndedAt > Date.now() - 50) && (n.inputState.compositionPendingChange = !1, o += ".compose", n.inputState.compositionFirstChange && (o += ".start", n.inputState.compositionFirstChange = !1)), s.update(i, { userEvent: o, scrollIntoView: !0 });
}
function Br(n, t, e, i) {
  let s = Math.min(n.length, t.length), r = 0;
  for (; r < s && n.charCodeAt(r) == t.charCodeAt(r); )
    r++;
  if (r == s && n.length == t.length)
    return null;
  let o = n.length, l = t.length;
  for (; o > 0 && l > 0 && n.charCodeAt(o - 1) == t.charCodeAt(l - 1); )
    o--, l--;
  if (i == "end") {
    let h = Math.max(0, r - Math.min(o, l));
    e -= o + h - r;
  }
  if (o < r && n.length < t.length) {
    let h = e <= r && e >= o ? r - e : 0;
    r -= h, l = r + (l - o), o = r;
  } else if (l < r) {
    let h = e <= r && e >= l ? r - e : 0;
    r -= h, o = r + (o - l), l = r;
  }
  return { from: r, toA: o, toB: l };
}
function Er(n) {
  let t = [];
  if (n.root.activeElement != n.contentDOM)
    return t;
  let { anchorNode: e, anchorOffset: i, focusNode: s, focusOffset: r } = n.observer.selectionRange;
  return e && (t.push(new Li(e, i)), (s != e || r != i) && t.push(new Li(s, r))), t;
}
function Pr(n, t) {
  if (n.length == 0)
    return null;
  let e = n[0].pos, i = n.length == 2 ? n[1].pos : e;
  return e > -1 && i > -1 ? M.single(e + t, i + t) : null;
}
const Hr = {
  childList: !0,
  characterData: !0,
  subtree: !0,
  attributes: !0,
  characterDataOldValue: !0
}, be = w.ie && w.ie_version <= 11;
class Nr {
  constructor(t) {
    this.view = t, this.active = !1, this.selectionRange = new yn(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.parentCheck = -1, this.dom = t.contentDOM, this.observer = new MutationObserver((e) => {
      for (let i of e)
        this.queue.push(i);
      (w.ie && w.ie_version <= 11 || w.ios && t.composing) && e.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), be && (this.onCharData = (e) => {
      this.queue.push({
        target: e.target,
        type: "characterData",
        oldValue: e.prevValue
      }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
      var e;
      ((e = this.view.docView) === null || e === void 0 ? void 0 : e.lastUpdate) < Date.now() - 75 && this.onResize();
    }), this.resizeScroll.observe(t.scrollDOM)), this.addWindowListeners(this.win = t.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver((e) => {
      this.parentCheck < 0 && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), e.length > 0 && e[e.length - 1].intersectionRatio > 0 != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView && this.onScrollChanged(document.createEvent("Event")));
    }, { threshold: [0, 1e-3] }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver((e) => {
      e.length > 0 && e[e.length - 1].intersectionRatio > 0 && this.onScrollChanged(document.createEvent("Event"));
    }, {})), this.listenForScroll(), this.readSelectionRange();
  }
  onScrollChanged(t) {
    this.view.inputState.runHandlers("scroll", t), this.intersecting && this.view.measure();
  }
  onScroll(t) {
    this.intersecting && this.flush(!1), this.onScrollChanged(t);
  }
  onResize() {
    this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = -1, this.view.requestMeasure();
    }, 50));
  }
  onPrint() {
    this.view.viewState.printing = !0, this.view.measure(), setTimeout(() => {
      this.view.viewState.printing = !1, this.view.requestMeasure();
    }, 500);
  }
  updateGaps(t) {
    if (this.gapIntersection && (t.length != this.gaps.length || this.gaps.some((e, i) => e != t[i]))) {
      this.gapIntersection.disconnect();
      for (let e of t)
        this.gapIntersection.observe(e);
      this.gaps = t;
    }
  }
  onSelectionChange(t) {
    let e = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view: i } = this, s = this.selectionRange;
    if (i.state.facet(fe) ? i.root.activeElement != this.dom : !Zt(i.dom, s))
      return;
    let r = s.anchorNode && i.docView.nearest(s.anchorNode);
    if (r && r.ignoreEvent(t)) {
      e || (this.selectionChanged = !1);
      return;
    }
    (w.ie && w.ie_version <= 11 || w.android && w.chrome) && !i.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
    s.focusNode && re(s.focusNode, s.focusOffset, s.anchorNode, s.anchorOffset) ? this.flushSoon() : this.flush(!1);
  }
  readSelectionRange() {
    let { view: t } = this, e = w.safari && t.root.nodeType == 11 && pn(this.dom.ownerDocument) == this.dom && Vr(this.view) || ne(t.root);
    if (!e || this.selectionRange.eq(e))
      return !1;
    let i = Zt(this.dom, e);
    return i && !this.selectionChanged && t.inputState.lastFocusTime > Date.now() - 200 && t.inputState.lastTouchTime < Date.now() - 300 && Sn(this.dom, e) ? (this.view.inputState.lastFocusTime = 0, t.docView.updateSelection(), !1) : (this.selectionRange.setRange(e), i && (this.selectionChanged = !0), !0);
  }
  setSelectionRange(t, e) {
    this.selectionRange.set(t.node, t.offset, e.node, e.offset), this.selectionChanged = !1;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let t = 0, e = null;
    for (let i = this.dom; i; )
      if (i.nodeType == 1)
        !e && t < this.scrollTargets.length && this.scrollTargets[t] == i ? t++ : e || (e = this.scrollTargets.slice(0, t)), e && e.push(i), i = i.assignedSlot || i.parentNode;
      else if (i.nodeType == 11)
        i = i.host;
      else
        break;
    if (t < this.scrollTargets.length && !e && (e = this.scrollTargets.slice(0, t)), e) {
      for (let i of this.scrollTargets)
        i.removeEventListener("scroll", this.onScroll);
      for (let i of this.scrollTargets = e)
        i.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(t) {
    if (!this.active)
      return t();
    try {
      return this.stop(), t();
    } finally {
      this.start(), this.clear();
    }
  }
  start() {
    this.active || (this.observer.observe(this.dom, Hr), be && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
  }
  stop() {
    this.active && (this.active = !1, this.observer.disconnect(), be && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
  }
  // Throw away any pending changes
  clear() {
    this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
  }
  // Chrome Android, especially in combination with GBoard, not only
  // doesn't reliably fire regular key events, but also often
  // surrounds the effect of enter or backspace with a bunch of
  // composition events that, when interrupted, cause text duplication
  // or other kinds of corruption. This hack makes the editor back off
  // from handling DOM changes for a moment when such a key is
  // detected (via beforeinput or keydown), and then tries to flush
  // them or, if that has no effect, dispatches the given key.
  delayAndroidKey(t, e) {
    var i;
    if (!this.delayedAndroidKey) {
      let s = () => {
        let r = this.delayedAndroidKey;
        r && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = r.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && r.force && bt(this.dom, r.key, r.keyCode));
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(s);
    }
    (!this.delayedAndroidKey || t == "Enter") && (this.delayedAndroidKey = {
      key: t,
      keyCode: e,
      // Only run the key handler when no changes are detected if
      // this isn't coming right after another change, in which case
      // it is probably part of a weird chain of updates, and should
      // be ignored if it returns the DOM to its previous state.
      force: this.lastChange < Date.now() - 50 || !!(!((i = this.delayedAndroidKey) === null || i === void 0) && i.force)
    });
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
  }
  flushSoon() {
    this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
      this.delayedFlush = -1, this.flush();
    }));
  }
  forceFlush() {
    this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
  }
  pendingRecords() {
    for (let t of this.observer.takeRecords())
      this.queue.push(t);
    return this.queue;
  }
  processRecords() {
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let e = -1, i = -1, s = !1;
    for (let r of t) {
      let o = this.readMutation(r);
      o && (o.typeOver && (s = !0), e == -1 ? { from: e, to: i } = o : (e = Math.min(o.from, e), i = Math.max(o.to, i)));
    }
    return { from: e, to: i, typeOver: s };
  }
  readChange() {
    let { from: t, to: e, typeOver: i } = this.processRecords(), s = this.selectionChanged && Zt(this.dom, this.selectionRange);
    if (t < 0 && !s)
      return null;
    t > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1;
    let r = new Rr(this.view, t, e, i);
    return this.view.docView.domChanged = { newSel: r.newSel ? r.newSel.main : null }, r;
  }
  // Apply pending changes, if any
  flush(t = !0) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return !1;
    t && this.readSelectionRange();
    let e = this.readChange();
    if (!e)
      return this.view.requestMeasure(), !1;
    let i = this.view.state, s = Ys(this.view, e);
    return this.view.state == i && this.view.update([]), s;
  }
  readMutation(t) {
    let e = this.view.docView.nearest(t.target);
    if (!e || e.ignoreMutation(t))
      return null;
    if (e.markDirty(t.type == "attributes"), t.type == "attributes" && (e.flags |= 4), t.type == "childList") {
      let i = Bi(e, t.previousSibling || t.target.previousSibling, -1), s = Bi(e, t.nextSibling || t.target.nextSibling, 1);
      return {
        from: i ? e.posAfter(i) : e.posAtStart,
        to: s ? e.posBefore(s) : e.posAtEnd,
        typeOver: !1
      };
    } else
      return t.type == "characterData" ? { from: e.posAtStart, to: e.posAtEnd, typeOver: t.target.nodeValue == t.oldValue } : null;
  }
  setWindow(t) {
    t != this.win && (this.removeWindowListeners(this.win), this.win = t, this.addWindowListeners(this.win));
  }
  addWindowListeners(t) {
    t.addEventListener("resize", this.onResize), t.addEventListener("beforeprint", this.onPrint), t.addEventListener("scroll", this.onScroll), t.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(t) {
    t.removeEventListener("scroll", this.onScroll), t.removeEventListener("resize", this.onResize), t.removeEventListener("beforeprint", this.onPrint), t.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  destroy() {
    var t, e, i;
    this.stop(), (t = this.intersection) === null || t === void 0 || t.disconnect(), (e = this.gapIntersection) === null || e === void 0 || e.disconnect(), (i = this.resizeScroll) === null || i === void 0 || i.disconnect();
    for (let s of this.scrollTargets)
      s.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey);
  }
}
function Bi(n, t, e) {
  for (; t; ) {
    let i = T.get(t);
    if (i && i.parent == n)
      return i;
    let s = t.parentNode;
    t = s != n.dom ? s : e > 0 ? t.nextSibling : t.previousSibling;
  }
  return null;
}
function Vr(n) {
  let t = null;
  function e(h) {
    h.preventDefault(), h.stopImmediatePropagation(), t = h.getTargetRanges()[0];
  }
  if (n.contentDOM.addEventListener("beforeinput", e, !0), n.dom.ownerDocument.execCommand("indent"), n.contentDOM.removeEventListener("beforeinput", e, !0), !t)
    return null;
  let i = t.startContainer, s = t.startOffset, r = t.endContainer, o = t.endOffset, l = n.docView.domAtPos(n.state.selection.main.anchor);
  return re(l.node, l.offset, r, o) && ([i, s, r, o] = [r, o, i, s]), { anchorNode: i, anchorOffset: s, focusNode: r, focusOffset: o };
}
class A {
  /**
  The current editor state.
  */
  get state() {
    return this.viewState.state;
  }
  /**
  To be able to display large documents without consuming too much
  memory or overloading the browser, CodeMirror only draws the
  code that is visible (plus a margin around it) to the DOM. This
  property tells you the extent of the current drawn viewport, in
  document positions.
  */
  get viewport() {
    return this.viewState.viewport;
  }
  /**
  When there are, for example, large collapsed ranges in the
  viewport, its size can be a lot bigger than the actual visible
  content. Thus, if you are doing something like styling the
  content in the viewport, it is preferable to only do so for
  these ranges, which are the subset of the viewport that is
  actually drawn.
  */
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  /**
  Returns false when the editor is entirely scrolled out of view
  or otherwise hidden.
  */
  get inView() {
    return this.viewState.inView;
  }
  /**
  Indicates whether the user is currently composing text via
  [IME](https://en.wikipedia.org/wiki/Input_method), and at least
  one change has been made in the current composition.
  */
  get composing() {
    return this.inputState.composing > 0;
  }
  /**
  Indicates whether the user is currently in composing state. Note
  that on some platforms, like Android, this will be the case a
  lot, since just putting the cursor on a word starts a
  composition there.
  */
  get compositionStarted() {
    return this.inputState.composing >= 0;
  }
  /**
  The document or shadow root that the view lives in.
  */
  get root() {
    return this._root;
  }
  /**
  @internal
  */
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  /**
  Construct a new view. You'll want to either provide a `parent`
  option, or put `view.dom` into your document after creating a
  view, so that the user can see the editor.
  */
  constructor(t = {}) {
    this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.style.cssText = "position: fixed; top: -10000px", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM);
    let { dispatch: e } = t;
    this.dispatchTransactions = t.dispatchTransactions || e && ((i) => i.forEach((s) => e(s, this))) || ((i) => this.update(i)), this.dispatch = this.dispatch.bind(this), this._root = t.root || vn(t.parent) || document, this.viewState = new Oi(t.state || Dt.create(t)), this.plugins = this.state.facet(xt).map((i) => new ue(i));
    for (let i of this.plugins)
      i.update(this);
    this.observer = new Nr(this), this.inputState = new Zn(this), this.inputState.ensureHandlers(this.plugins), this.docView = new ci(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure(), t.parent && t.parent.appendChild(this.dom);
  }
  dispatch(...t) {
    let e = t.length == 1 && t[0] instanceof ln ? t : t.length == 1 && Array.isArray(t[0]) ? t[0] : [this.state.update(...t)];
    this.dispatchTransactions(e, this);
  }
  /**
  Update the view for the given array of transactions. This will
  update the visible document and selection to match the state
  produced by the transactions, and notify view plugins of the
  change. You should usually call
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
  as a primitive.
  */
  update(t) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let e = !1, i = !1, s, r = this.state;
    for (let d of t) {
      if (d.startState != r)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      r = d.state;
    }
    if (this.destroyed) {
      this.viewState.state = r;
      return;
    }
    let o = this.hasFocus, l = 0, h = null;
    t.some((d) => d.annotation(Ws)) ? (this.inputState.notifiedFocused = o, l = 1) : o != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = o, h = Fs(r, o), h || (l = 1));
    let c = this.observer.delayedAndroidKey, a = null;
    if (c ? (this.observer.clearDelayedAndroidKey(), a = this.observer.readChange(), (a && !this.state.doc.eq(r.doc) || !this.state.selection.eq(r.selection)) && (a = null)) : this.observer.clear(), r.facet(Dt.phrases) != this.state.facet(Dt.phrases))
      return this.setState(r);
    s = le.create(this, r, t), s.flags |= l;
    let f = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let d of t) {
        if (f && (f = f.map(d.changes)), d.scrollIntoView) {
          let { main: u } = d.state.selection;
          f = new oe(u.empty ? u : M.cursor(u.head, u.head > u.anchor ? -1 : 1));
        }
        for (let u of d.effects)
          u.is(hi) && (f = u.value);
      }
      this.viewState.update(s, f), this.bidiCache = he.update(this.bidiCache, s.changes), s.empty || (this.updatePlugins(s), this.inputState.update(s)), e = this.docView.update(s), this.state.facet(Ct) != this.styleModules && this.mountStyles(), i = this.updateAttrs(), this.showAnnouncements(t), this.docView.updateSelection(e, t.some((d) => d.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (s.startState.facet($t) != s.state.facet($t) && (this.viewState.mustMeasureContent = !0), (e || i || f || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), !s.empty)
      for (let d of this.state.facet(Re))
        d(s);
    (h || a) && Promise.resolve().then(() => {
      h && this.state == h.startState && this.dispatch(h), a && !Ys(this, a) && c.force && bt(this.contentDOM, c.key, c.keyCode);
    });
  }
  /**
  Reset the view to the given state. (This will cause the entire
  document to be redrawn and all view plugins to be reinitialized,
  so you should probably only use it when the new state isn't
  derived from the old state. Otherwise, use
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
  */
  setState(t) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = t;
      return;
    }
    this.updateState = 2;
    let e = this.hasFocus;
    try {
      for (let i of this.plugins)
        i.destroy(this);
      this.viewState = new Oi(t), this.plugins = t.facet(xt).map((i) => new ue(i)), this.pluginMap.clear();
      for (let i of this.plugins)
        i.update(this);
      this.docView = new ci(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    e && this.focus(), this.requestMeasure();
  }
  updatePlugins(t) {
    let e = t.startState.facet(xt), i = t.state.facet(xt);
    if (e != i) {
      let s = [];
      for (let r of i) {
        let o = e.indexOf(r);
        if (o < 0)
          s.push(new ue(r));
        else {
          let l = this.plugins[o];
          l.mustUpdate = t, s.push(l);
        }
      }
      for (let r of this.plugins)
        r.mustUpdate != t && r.destroy(this);
      this.plugins = s, this.pluginMap.clear();
    } else
      for (let s of this.plugins)
        s.mustUpdate = t;
    for (let s = 0; s < this.plugins.length; s++)
      this.plugins[s].update(this);
    e != i && this.inputState.ensureHandlers(this.plugins);
  }
  /**
  @internal
  */
  measure(t = !0) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) {
      this.measureScheduled = -1, this.requestMeasure();
      return;
    }
    this.measureScheduled = 0, t && this.observer.forceFlush();
    let e = null, i = this.scrollDOM, s = i.scrollTop * this.scaleY, { scrollAnchorPos: r, scrollAnchorHeight: o } = this.viewState;
    Math.abs(s - this.viewState.scrollTop) > 1 && (o = -1), this.viewState.scrollAnchorHeight = -1;
    try {
      for (let l = 0; ; l++) {
        if (o < 0)
          if (is(i))
            r = -1, o = this.viewState.heightMap.height;
          else {
            let u = this.viewState.scrollAnchorAt(s);
            r = u.from, o = u.top;
          }
        this.updateState = 1;
        let h = this.viewState.measure(this);
        if (!h && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (l > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let c = [];
        h & 4 || ([this.measureRequests, c] = [c, this.measureRequests]);
        let a = c.map((u) => {
          try {
            return u.read(this);
          } catch (g) {
            return ct(this.state, g), Ei;
          }
        }), f = le.create(this, this.state, []), d = !1;
        f.flags |= h, e ? e.flags |= h : e = f, this.updateState = 2, f.empty || (this.updatePlugins(f), this.inputState.update(f), this.updateAttrs(), d = this.docView.update(f));
        for (let u = 0; u < c.length; u++)
          if (a[u] != Ei)
            try {
              let g = c[u];
              g.write && g.write(a[u], this);
            } catch (g) {
              ct(this.state, g);
            }
        if (d && this.docView.updateSelection(!0), !f.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight)
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null;
              continue;
            } else {
              let g = (r < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(r).top) - o;
              if (g > 1 || g < -1) {
                s = s + g, i.scrollTop = s / this.scaleY, o = -1;
                continue;
              }
            }
          break;
        }
      }
    } finally {
      this.updateState = 0, this.measureScheduled = -1;
    }
    if (e && !e.empty)
      for (let l of this.state.facet(Re))
        l(e);
  }
  /**
  Get the CSS classes for the currently active editor themes.
  */
  get themeClasses() {
    return We + " " + (this.state.facet(Ve) ? qs : Ks) + " " + this.state.facet($t);
  }
  updateAttrs() {
    let t = Pi(this, vs, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    }), e = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      translate: "no",
      contenteditable: this.state.facet(fe) ? "true" : "false",
      class: "cm-content",
      style: `${w.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    this.state.readOnly && (e["aria-readonly"] = "true"), Pi(this, $e, e);
    let i = this.observer.ignore(() => {
      let s = Oe(this.contentDOM, this.contentAttrs, e), r = Oe(this.dom, this.editorAttrs, t);
      return s || r;
    });
    return this.editorAttrs = t, this.contentAttrs = e, i;
  }
  showAnnouncements(t) {
    let e = !0;
    for (let i of t)
      for (let s of i.effects)
        if (s.is(A.announce)) {
          e && (this.announceDOM.textContent = ""), e = !1;
          let r = this.announceDOM.appendChild(document.createElement("div"));
          r.textContent = s.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet(Ct);
    let t = this.state.facet(A.cspNonce);
    wt.mount(this.root, this.styleModules.concat(Dr).reverse(), t ? { nonce: t } : void 0);
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
  }
  /**
  Schedule a layout measurement, optionally providing callbacks to
  do custom DOM measuring followed by a DOM write phase. Using
  this is preferable reading DOM layout directly from, for
  example, an event handler, because it'll make sure measuring and
  drawing done by other components is synchronized, avoiding
  unnecessary DOM layout computations.
  */
  requestMeasure(t) {
    if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), t) {
      if (this.measureRequests.indexOf(t) > -1)
        return;
      if (t.key != null) {
        for (let e = 0; e < this.measureRequests.length; e++)
          if (this.measureRequests[e].key === t.key) {
            this.measureRequests[e] = t;
            return;
          }
      }
      this.measureRequests.push(t);
    }
  }
  /**
  Get the value of a specific plugin, if present. Note that
  plugins that crash can be dropped from a view, so even when you
  know you registered a given plugin, it is recommended to check
  the return value of this method.
  */
  plugin(t) {
    let e = this.pluginMap.get(t);
    return (e === void 0 || e && e.spec != t) && this.pluginMap.set(t, e = this.plugins.find((i) => i.spec == t) || null), e && e.update(this).value;
  }
  /**
  The top position of the document, in screen coordinates. This
  may be negative when the editor is scrolled down. Points
  directly to the top of the first line, not above the padding.
  */
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  /**
  Reports the padding above and below the document.
  */
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  /**
  If the editor is transformed with CSS, this provides the scale
  along the X axis. Otherwise, it will just be 1. Note that
  transforms other than translation and scaling are not supported.
  */
  get scaleX() {
    return this.viewState.scaleX;
  }
  /**
  Provide the CSS transformed scale along the Y axis.
  */
  get scaleY() {
    return this.viewState.scaleY;
  }
  /**
  Find the text line or block widget at the given vertical
  position (which is interpreted as relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
  */
  elementAtHeight(t) {
    return this.readMeasured(), this.viewState.elementAtHeight(t);
  }
  /**
  Find the line block (see
  [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
  height, again interpreted relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
  */
  lineBlockAtHeight(t) {
    return this.readMeasured(), this.viewState.lineBlockAtHeight(t);
  }
  /**
  Get the extent and vertical position of all [line
  blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
  are relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
  */
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  /**
  Find the line block around the given document position. A line
  block is a range delimited on both sides by either a
  non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line breaks, or the
  start/end of the document. It will usually just hold a line of
  text, but may be broken into multiple textblocks by block
  widgets.
  */
  lineBlockAt(t) {
    return this.viewState.lineBlockAt(t);
  }
  /**
  The editor's total content height.
  */
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  /**
  Move a cursor position by [grapheme
  cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
  the motion is away from the line start, or towards it. In
  bidirectional text, the line is traversed in visual order, using
  the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
  When the start position was the last one on the line, the
  returned position will be across the line break. If there is no
  further line, the original position is returned.
  
  By default, this method moves over a single cluster. The
  optional `by` argument can be used to move across more. It will
  be called with the first cluster as argument, and should return
  a predicate that determines, for each subsequent cluster,
  whether it should also be moved over.
  */
  moveByChar(t, e, i) {
    return pe(this, t, mi(this, t, e, i));
  }
  /**
  Move a cursor position across the next group of either
  [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
  non-whitespace characters.
  */
  moveByGroup(t, e) {
    return pe(this, t, mi(this, t, e, (i) => Un(this, t.head, i)));
  }
  /**
  Move to the next line boundary in the given direction. If
  `includeWrap` is true, line wrapping is on, and there is a
  further wrap point on the current line, the wrap point will be
  returned. Otherwise this function will return the start or end
  of the line.
  */
  moveToLineBoundary(t, e, i = !0) {
    return $n(this, t, e, i);
  }
  /**
  Move a cursor position vertically. When `distance` isn't given,
  it defaults to moving to the next line (including wrapped
  lines). Otherwise, `distance` should provide a positive distance
  in pixels.
  
  When `start` has a
  [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
  motion will use that as a target horizontal position. Otherwise,
  the cursor's own horizontal position is used. The returned
  cursor will have its goal column set to whichever column was
  used.
  */
  moveVertically(t, e, i) {
    return pe(this, t, Jn(this, t, e, i));
  }
  /**
  Find the DOM parent node and offset (child offset if `node` is
  an element, character offset when it is a text node) at the
  given document position.
  
  Note that for positions that aren't currently in
  `visibleRanges`, the resulting DOM position isn't necessarily
  meaningful (it may just point before or after a placeholder
  element).
  */
  domAtPos(t) {
    return this.docView.domAtPos(t);
  }
  /**
  Find the document position at the given DOM node. Can be useful
  for associating positions with DOM events. Will raise an error
  when `node` isn't part of the editor content.
  */
  posAtDOM(t, e = 0) {
    return this.docView.posFromDOM(t, e);
  }
  posAtCoords(t, e = !0) {
    return this.readMeasured(), Ls(this, t, e);
  }
  /**
  Get the screen coordinates at the given document position.
  `side` determines whether the coordinates are based on the
  element before (-1) or after (1) the position (if no element is
  available on the given side, the method will transparently use
  another strategy to get reasonable coordinates).
  */
  coordsAtPos(t, e = 1) {
    this.readMeasured();
    let i = this.docView.coordsAt(t, e);
    if (!i || i.left == i.right)
      return i;
    let s = this.state.doc.lineAt(t), r = this.bidiSpans(s), o = r[nt.find(r, t - s.from, -1, e)];
    return Ge(i, o.dir == L.LTR == e > 0);
  }
  /**
  Return the rectangle around a given character. If `pos` does not
  point in front of a character that is in the viewport and
  rendered (i.e. not replaced, not a line break), this will return
  null. For space characters that are a line wrap point, this will
  return the position before the line break.
  */
  coordsForChar(t) {
    return this.readMeasured(), this.docView.coordsForChar(t);
  }
  /**
  The default width of a character in the editor. May not
  accurately reflect the width of all characters (given variable
  width fonts or styling of invididual ranges).
  */
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  /**
  The default height of a line in the editor. May not be accurate
  for all lines.
  */
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  /**
  The text direction
  ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
  CSS property) of the editor's content element.
  */
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  /**
  Find the text direction of the block at the given position, as
  assigned by CSS. If
  [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
  isn't enabled, or the given position is outside of the viewport,
  this will always return the same as
  [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
  this may trigger a DOM layout.
  */
  textDirectionAt(t) {
    return !this.state.facet(ws) || t < this.viewport.from || t > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(t));
  }
  /**
  Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
  (as determined by the
  [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
  CSS property of its content element).
  */
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  /**
  Returns the bidirectional text structure of the given line
  (which should be in the current document) as an array of span
  objects. The order of these spans matches the [text
  direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
  left-to-right, the leftmost spans come first, otherwise the
  rightmost spans come first.
  */
  bidiSpans(t) {
    if (t.length > Wr)
      return Ds(t.length);
    let e = this.textDirectionAt(t.from), i;
    for (let r of this.bidiCache)
      if (r.from == t.from && r.dir == e && (r.fresh || As(r.isolates, i = ai(this, t.from, t.to))))
        return r.order;
    i || (i = ai(this, t.from, t.to));
    let s = Hn(t.text, e, i);
    return this.bidiCache.push(new he(t.from, t.to, e, i, !0, s)), s;
  }
  /**
  Check whether the editor has focus.
  */
  get hasFocus() {
    var t;
    return (this.dom.ownerDocument.hasFocus() || w.safari && ((t = this.inputState) === null || t === void 0 ? void 0 : t.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  /**
  Put focus on the editor.
  */
  focus() {
    this.observer.ignore(() => {
      ts(this.contentDOM), this.docView.updateSelection();
    });
  }
  /**
  Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
  necessary when moving the editor's existing DOM to a new window or shadow root.
  */
  setRoot(t) {
    this._root != t && (this._root = t, this.observer.setWindow((t.nodeType == 9 ? t : t.ownerDocument).defaultView || window), this.mountStyles());
  }
  /**
  Clean up this editor view, removing its element from the
  document, unregistering event handlers, and notifying
  plugins. The view instance can no longer be used after
  calling this.
  */
  destroy() {
    for (let t of this.plugins)
      t.destroy(this);
    this.plugins = [], this.inputState.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
  }
  /**
  Returns an effect that can be
  [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
  cause it to scroll the given position or range into view.
  */
  static scrollIntoView(t, e = {}) {
    return hi.of(new oe(typeof t == "number" ? M.cursor(t) : t, e.y, e.x, e.yMargin, e.xMargin));
  }
  /**
  Returns an extension that can be used to add DOM event handlers.
  The value should be an object mapping event names to handler
  functions. For any given event, such functions are ordered by
  extension precedence, and the first handler to return true will
  be assumed to have handled that event, and no other handlers or
  built-in behavior will be activated for it. These are registered
  on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
  for `scroll` handlers, which will be called any time the
  editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
  its parent nodes is scrolled.
  */
  static domEventHandlers(t) {
    return z.define(() => ({}), { eventHandlers: t });
  }
  /**
  Create an extension that registers DOM event observers. Contrary
  to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
  observers can't be prevented from running by a higher-precedence
  handler returning true. They also don't prevent other handlers
  and observers from running when they return true, and should not
  call `preventDefault`.
  */
  static domEventObservers(t) {
    return z.define(() => ({}), { eventObservers: t });
  }
  /**
  Create a theme extension. The first argument can be a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)
  style spec providing the styles for the theme. These will be
  prefixed with a generated class for the style.
  
  Because the selectors will be prefixed with a scope class, rule
  that directly match the editor's [wrapper
  element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
  added—need to be explicitly differentiated by adding an `&` to
  the selector for that element—for example
  `&.cm-focused`.
  
  When `dark` is set to true, the theme will be marked as dark,
  which will cause the `&dark` rules from [base
  themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
  `&light` when a light theme is active).
  */
  static theme(t, e) {
    let i = wt.newName(), s = [$t.of(i), Ct.of(Fe(`.${i}`, t))];
    return e && e.dark && s.push(Ve.of(!0)), s;
  }
  /**
  Create an extension that adds styles to the base theme. Like
  with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
  place of the editor wrapper element when directly targeting
  that. You can also use `&dark` or `&light` instead to only
  target editors with a dark or light theme.
  */
  static baseTheme(t) {
    return je.lowest(Ct.of(Fe("." + We, t, js)));
  }
  /**
  Retrieve an editor view instance from the view's DOM
  representation.
  */
  static findFromDOM(t) {
    var e;
    let i = t.querySelector(".cm-content"), s = i && T.get(i) || T.get(t);
    return ((e = s == null ? void 0 : s.rootView) === null || e === void 0 ? void 0 : e.view) || null;
  }
}
A.styleModule = Ct;
A.inputHandler = ms;
A.focusChangeEffect = bs;
A.perLineTextDirection = ws;
A.exceptionSink = ps;
A.updateListener = Re;
A.editable = fe;
A.mouseSelectionStyle = gs;
A.dragMovesSelection = us;
A.clickAddsSelectionRange = ds;
A.decorations = Bt;
A.atomicRanges = Ue;
A.bidiIsolatedRanges = Ss;
A.scrollMargins = xs;
A.darkTheme = Ve;
A.cspNonce = /* @__PURE__ */ k.define({ combine: (n) => n.length ? n[0] : "" });
A.contentAttributes = $e;
A.editorAttributes = vs;
A.lineWrapping = /* @__PURE__ */ A.contentAttributes.of({ class: "cm-lineWrapping" });
A.announce = /* @__PURE__ */ Ht.define();
const Wr = 4096, Ei = {};
class he {
  constructor(t, e, i, s, r, o) {
    this.from = t, this.to = e, this.dir = i, this.isolates = s, this.fresh = r, this.order = o;
  }
  static update(t, e) {
    if (e.empty && !t.some((r) => r.fresh))
      return t;
    let i = [], s = t.length ? t[t.length - 1].dir : L.LTR;
    for (let r = Math.max(0, t.length - 10); r < t.length; r++) {
      let o = t[r];
      o.dir == s && !e.touchesRange(o.from, o.to) && i.push(new he(e.mapPos(o.from, 1), e.mapPos(o.to, -1), o.dir, o.isolates, !1, o.order));
    }
    return i;
  }
}
function Pi(n, t, e) {
  for (let i = n.state.facet(t), s = i.length - 1; s >= 0; s--) {
    let r = i[s], o = typeof r == "function" ? r(n) : r;
    o && De(o, e);
  }
  return e;
}
const Fr = w.mac ? "mac" : w.windows ? "win" : w.linux ? "linux" : "key";
function zr(n, t) {
  const e = n.split(/-(?!$)/);
  let i = e[e.length - 1];
  i == "Space" && (i = " ");
  let s, r, o, l;
  for (let h = 0; h < e.length - 1; ++h) {
    const c = e[h];
    if (/^(cmd|meta|m)$/i.test(c))
      l = !0;
    else if (/^a(lt)?$/i.test(c))
      s = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      r = !0;
    else if (/^s(hift)?$/i.test(c))
      o = !0;
    else if (/^mod$/i.test(c))
      t == "mac" ? l = !0 : r = !0;
    else
      throw new Error("Unrecognized modifier name: " + c);
  }
  return s && (i = "Alt-" + i), r && (i = "Ctrl-" + i), l && (i = "Meta-" + i), o && (i = "Shift-" + i), i;
}
function Ut(n, t, e) {
  return t.altKey && (n = "Alt-" + n), t.ctrlKey && (n = "Ctrl-" + n), t.metaKey && (n = "Meta-" + n), e !== !1 && t.shiftKey && (n = "Shift-" + n), n;
}
const Ir = /* @__PURE__ */ je.default(/* @__PURE__ */ A.domEventHandlers({
  keydown(n, t) {
    return _s(Gs(t.state), n, t, "editor");
  }
})), Kr = /* @__PURE__ */ k.define({ enables: Ir }), Hi = /* @__PURE__ */ new WeakMap();
function Gs(n) {
  let t = n.facet(Kr), e = Hi.get(t);
  return e || Hi.set(t, e = jr(t.reduce((i, s) => i.concat(s), []))), e;
}
function Ho(n, t, e) {
  return _s(Gs(n.state), t, n, e);
}
let it = null;
const qr = 4e3;
function jr(n, t = Fr) {
  let e = /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null), s = (o, l) => {
    let h = i[o];
    if (h == null)
      i[o] = l;
    else if (h != l)
      throw new Error("Key binding " + o + " is used both as a regular binding and as a multi-stroke prefix");
  }, r = (o, l, h, c, a) => {
    var f, d;
    let u = e[o] || (e[o] = /* @__PURE__ */ Object.create(null)), g = l.split(/ (?!$)/).map((b) => zr(b, t));
    for (let b = 1; b < g.length; b++) {
      let v = g.slice(0, b).join(" ");
      s(v, !0), u[v] || (u[v] = {
        preventDefault: !0,
        stopPropagation: !1,
        run: [(x) => {
          let y = it = { view: x, prefix: v, scope: o };
          return setTimeout(() => {
            it == y && (it = null);
          }, qr), !0;
        }]
      });
    }
    let m = g.join(" ");
    s(m, !1);
    let p = u[m] || (u[m] = {
      preventDefault: !1,
      stopPropagation: !1,
      run: ((d = (f = u._any) === null || f === void 0 ? void 0 : f.run) === null || d === void 0 ? void 0 : d.slice()) || []
    });
    h && p.run.push(h), c && (p.preventDefault = !0), a && (p.stopPropagation = !0);
  };
  for (let o of n) {
    let l = o.scope ? o.scope.split(" ") : ["editor"];
    if (o.any)
      for (let c of l) {
        let a = e[c] || (e[c] = /* @__PURE__ */ Object.create(null));
        a._any || (a._any = { preventDefault: !1, stopPropagation: !1, run: [] });
        for (let f in a)
          a[f].run.push(o.any);
      }
    let h = o[t] || o.key;
    if (h)
      for (let c of l)
        r(c, h, o.run, o.preventDefault, o.stopPropagation), o.shift && r(c, "Shift-" + h, o.shift, o.preventDefault, o.stopPropagation);
  }
  return e;
}
function _s(n, t, e, i) {
  let s = dn(t), r = Ji(s, 0), o = cn(r) == s.length && s != " ", l = "", h = !1, c = !1, a = !1;
  it && it.view == e && it.scope == i && (l = it.prefix + " ", Es.indexOf(t.keyCode) < 0 && (c = !0, it = null));
  let f = /* @__PURE__ */ new Set(), d = (p) => {
    if (p) {
      for (let b of p.run)
        if (!f.has(b) && (f.add(b), b(e, t)))
          return p.stopPropagation && (a = !0), !0;
      p.preventDefault && (p.stopPropagation && (a = !0), c = !0);
    }
    return !1;
  }, u = n[i], g, m;
  return u && (d(u[l + Ut(s, t, !o)]) ? h = !0 : o && (t.altKey || t.metaKey || t.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
  !(w.windows && t.ctrlKey && t.altKey) && (g = un[t.keyCode]) && g != s ? (d(u[l + Ut(g, t, !0)]) || t.shiftKey && (m = gn[t.keyCode]) != s && m != g && d(u[l + Ut(m, t, !1)])) && (h = !0) : o && t.shiftKey && d(u[l + Ut(s, t, !0)]) && (h = !0), !h && d(u._any) && (h = !0)), c && (h = !0), h && a && t.stopPropagation(), h;
}
class Ft {
  /**
  Create a marker with the given class and dimensions. If `width`
  is null, the DOM element will get no width style.
  */
  constructor(t, e, i, s, r) {
    this.className = t, this.left = e, this.top = i, this.width = s, this.height = r;
  }
  draw() {
    let t = document.createElement("div");
    return t.className = this.className, this.adjust(t), t;
  }
  update(t, e) {
    return e.className != this.className ? !1 : (this.adjust(t), !0);
  }
  adjust(t) {
    t.style.left = this.left + "px", t.style.top = this.top + "px", this.width != null && (t.style.width = this.width + "px"), t.style.height = this.height + "px";
  }
  eq(t) {
    return this.left == t.left && this.top == t.top && this.width == t.width && this.height == t.height && this.className == t.className;
  }
  /**
  Create a set of rectangles for the given selection range,
  assigning them theclass`className`. Will create a single
  rectangle for empty ranges, and a set of selection-style
  rectangles covering the range's content (in a bidi-aware
  way) for non-empty ones.
  */
  static forRange(t, e, i) {
    if (i.empty) {
      let s = t.coordsAtPos(i.head, i.assoc || 1);
      if (!s)
        return [];
      let r = Xs(t);
      return [new Ft(e, s.left - r.left, s.top - r.top, null, s.bottom - s.top)];
    } else
      return Yr(t, e, i);
  }
}
function Xs(n) {
  let t = n.scrollDOM.getBoundingClientRect();
  return { left: (n.textDirection == L.LTR ? t.left : t.right - n.scrollDOM.clientWidth * n.scaleX) - n.scrollDOM.scrollLeft * n.scaleX, top: t.top - n.scrollDOM.scrollTop * n.scaleY };
}
function Ni(n, t, e) {
  let i = M.cursor(t);
  return {
    from: Math.max(e.from, n.moveToLineBoundary(i, !1, !0).from),
    to: Math.min(e.to, n.moveToLineBoundary(i, !0, !0).from),
    type: N.Text
  };
}
function Yr(n, t, e) {
  if (e.to <= n.viewport.from || e.from >= n.viewport.to)
    return [];
  let i = Math.max(e.from, n.viewport.from), s = Math.min(e.to, n.viewport.to), r = n.textDirection == L.LTR, o = n.contentDOM, l = o.getBoundingClientRect(), h = Xs(n), c = o.querySelector(".cm-line"), a = c && window.getComputedStyle(c), f = l.left + (a ? parseInt(a.paddingLeft) + Math.min(0, parseInt(a.textIndent)) : 0), d = l.right - (a ? parseInt(a.paddingRight) : 0), u = He(n, i), g = He(n, s), m = u.type == N.Text ? u : null, p = g.type == N.Text ? g : null;
  if (m && (n.lineWrapping || u.widgetLineBreaks) && (m = Ni(n, i, m)), p && (n.lineWrapping || g.widgetLineBreaks) && (p = Ni(n, s, p)), m && p && m.from == p.from)
    return v(x(e.from, e.to, m));
  {
    let S = m ? x(e.from, null, m) : y(u, !1), C = p ? x(null, e.to, p) : y(g, !0), R = [];
    return (m || u).to < (p || g).from - (m && p ? 1 : 0) || u.widgetLineBreaks > 1 && S.bottom + n.defaultLineHeight / 2 < C.top ? R.push(b(f, S.bottom, d, C.top)) : S.bottom < C.top && n.elementAtHeight((S.bottom + C.top) / 2).type == N.Text && (S.bottom = C.top = (S.bottom + C.top) / 2), v(S).concat(R).concat(v(C));
  }
  function b(S, C, R, E) {
    return new Ft(
      t,
      S - h.left,
      C - h.top - 0.01,
      R - S,
      E - C + 0.01
      /* C.Epsilon */
    );
  }
  function v({ top: S, bottom: C, horizontal: R }) {
    let E = [];
    for (let tt = 0; tt < R.length; tt += 2)
      E.push(b(R[tt], S, R[tt + 1], C));
    return E;
  }
  function x(S, C, R) {
    let E = 1e9, tt = -1e9, zt = [];
    function Qe(ht, et, dt, at, vt) {
      let $ = n.coordsAtPos(ht, ht == R.to ? -2 : 2), U = n.coordsAtPos(dt, dt == R.from ? 2 : -2);
      !$ || !U || (E = Math.min($.top, U.top, E), tt = Math.max($.bottom, U.bottom, tt), vt == L.LTR ? zt.push(r && et ? f : $.left, r && at ? d : U.right) : zt.push(!r && at ? f : U.left, !r && et ? d : $.right));
    }
    let It = S ?? R.from, Kt = C ?? R.to;
    for (let ht of n.visibleRanges)
      if (ht.to > It && ht.from < Kt)
        for (let et = Math.max(ht.from, It), dt = Math.min(ht.to, Kt); ; ) {
          let at = n.state.doc.lineAt(et);
          for (let vt of n.bidiSpans(at)) {
            let $ = vt.from + at.from, U = vt.to + at.from;
            if ($ >= dt)
              break;
            U > et && Qe(Math.max($, et), S == null && $ <= It, Math.min(U, dt), C == null && U >= Kt, vt.dir);
          }
          if (et = at.to + 1, et >= dt)
            break;
        }
    return zt.length == 0 && Qe(It, S == null, Kt, C == null, n.textDirection), { top: E, bottom: tt, horizontal: zt };
  }
  function y(S, C) {
    let R = l.top + (C ? S.top : S.bottom);
    return { top: R, bottom: R, horizontal: [] };
  }
}
function Gr(n, t) {
  return n.constructor == t.constructor && n.eq(t);
}
class _r {
  constructor(t, e) {
    this.view = t, this.layer = e, this.drawn = [], this.scaleX = 1, this.scaleY = 1, this.measureReq = { read: this.measure.bind(this), write: this.draw.bind(this) }, this.dom = t.scrollDOM.appendChild(document.createElement("div")), this.dom.classList.add("cm-layer"), e.above && this.dom.classList.add("cm-layer-above"), e.class && this.dom.classList.add(e.class), this.scale(), this.dom.setAttribute("aria-hidden", "true"), this.setOrder(t.state), t.requestMeasure(this.measureReq), e.mount && e.mount(this.dom, t);
  }
  update(t) {
    t.startState.facet(ee) != t.state.facet(ee) && this.setOrder(t.state), (this.layer.update(t, this.dom) || t.geometryChanged) && (this.scale(), t.view.requestMeasure(this.measureReq));
  }
  setOrder(t) {
    let e = 0, i = t.facet(ee);
    for (; e < i.length && i[e] != this.layer; )
      e++;
    this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - e);
  }
  measure() {
    return this.layer.markers(this.view);
  }
  scale() {
    let { scaleX: t, scaleY: e } = this.view;
    (t != this.scaleX || e != this.scaleY) && (this.scaleX = t, this.scaleY = e, this.dom.style.transform = `scale(${1 / t}, ${1 / e})`);
  }
  draw(t) {
    if (t.length != this.drawn.length || t.some((e, i) => !Gr(e, this.drawn[i]))) {
      let e = this.dom.firstChild, i = 0;
      for (let s of t)
        s.update && e && s.constructor && this.drawn[i].constructor && s.update(e, this.drawn[i]) ? (e = e.nextSibling, i++) : this.dom.insertBefore(s.draw(), e);
      for (; e; ) {
        let s = e.nextSibling;
        e.remove(), e = s;
      }
      this.drawn = t;
    }
  }
  destroy() {
    this.layer.destroy && this.layer.destroy(this.dom, this.view), this.dom.remove();
  }
}
const ee = /* @__PURE__ */ k.define();
function $s(n) {
  return [
    z.define((t) => new _r(t, n)),
    ee.of(n)
  ];
}
const Us = !w.ios, Pt = /* @__PURE__ */ k.define({
  combine(n) {
    return Ye(n, {
      cursorBlinkRate: 1200,
      drawRangeCursor: !0
    }, {
      cursorBlinkRate: (t, e) => Math.min(t, e),
      drawRangeCursor: (t, e) => t || e
    });
  }
});
function No(n = {}) {
  return [
    Pt.of(n),
    Xr,
    $r,
    Ur,
    ys.of(!0)
  ];
}
function Js(n) {
  return n.startState.facet(Pt) != n.state.facet(Pt);
}
const Xr = /* @__PURE__ */ $s({
  above: !0,
  markers(n) {
    let { state: t } = n, e = t.facet(Pt), i = [];
    for (let s of t.selection.ranges) {
      let r = s == t.selection.main;
      if (s.empty ? !r || Us : e.drawRangeCursor) {
        let o = r ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary", l = s.empty ? s : M.cursor(s.head, s.head > s.anchor ? -1 : 1);
        for (let h of Ft.forRange(n, o, l))
          i.push(h);
      }
    }
    return i;
  },
  update(n, t) {
    n.transactions.some((i) => i.selection) && (t.style.animationName = t.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink");
    let e = Js(n);
    return e && Vi(n.state, t), n.docChanged || n.selectionSet || e;
  },
  mount(n, t) {
    Vi(t.state, n);
  },
  class: "cm-cursorLayer"
});
function Vi(n, t) {
  t.style.animationDuration = n.facet(Pt).cursorBlinkRate + "ms";
}
const $r = /* @__PURE__ */ $s({
  above: !1,
  markers(n) {
    return n.state.selection.ranges.map((t) => t.empty ? [] : Ft.forRange(n, "cm-selectionBackground", t)).reduce((t, e) => t.concat(e));
  },
  update(n, t) {
    return n.docChanged || n.selectionSet || n.viewportChanged || Js(n);
  },
  class: "cm-selectionLayer"
}), Zs = {
  ".cm-line": {
    "& ::selection": { backgroundColor: "transparent !important" },
    "&::selection": { backgroundColor: "transparent !important" }
  }
};
Us && (Zs[".cm-line"].caretColor = "transparent !important");
const Ur = /* @__PURE__ */ je.highest(/* @__PURE__ */ A.theme(Zs)), Qs = /* @__PURE__ */ Ht.define({
  map(n, t) {
    return n == null ? null : t.mapPos(n);
  }
}), At = /* @__PURE__ */ Qi.define({
  create() {
    return null;
  },
  update(n, t) {
    return n != null && (n = t.changes.mapPos(n)), t.effects.reduce((e, i) => i.is(Qs) ? i.value : e, n);
  }
}), Jr = /* @__PURE__ */ z.fromClass(class {
  constructor(n) {
    this.view = n, this.cursor = null, this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
  }
  update(n) {
    var t;
    let e = n.state.field(At);
    e == null ? this.cursor != null && ((t = this.cursor) === null || t === void 0 || t.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (n.startState.field(At) != e || n.docChanged || n.geometryChanged) && this.view.requestMeasure(this.measureReq));
  }
  readPos() {
    let { view: n } = this, t = n.state.field(At), e = t != null && n.coordsAtPos(t);
    if (!e)
      return null;
    let i = n.scrollDOM.getBoundingClientRect();
    return {
      left: e.left - i.left + n.scrollDOM.scrollLeft * n.scaleX,
      top: e.top - i.top + n.scrollDOM.scrollTop * n.scaleY,
      height: e.bottom - e.top
    };
  }
  drawCursor(n) {
    if (this.cursor) {
      let { scaleX: t, scaleY: e } = this.view;
      n ? (this.cursor.style.left = n.left / t + "px", this.cursor.style.top = n.top / e + "px", this.cursor.style.height = n.height / e + "px") : this.cursor.style.left = "-100000px";
    }
  }
  destroy() {
    this.cursor && this.cursor.remove();
  }
  setDropPos(n) {
    this.view.state.field(At) != n && this.view.dispatch({ effects: Qs.of(n) });
  }
}, {
  eventObservers: {
    dragover(n) {
      this.setDropPos(this.view.posAtCoords({ x: n.clientX, y: n.clientY }));
    },
    dragleave(n) {
      (n.target == this.view.contentDOM || !this.view.contentDOM.contains(n.relatedTarget)) && this.setDropPos(null);
    },
    dragend() {
      this.setDropPos(null);
    },
    drop() {
      this.setDropPos(null);
    }
  }
});
function Vo() {
  return [At, Jr];
}
function Wi(n, t, e, i, s) {
  t.lastIndex = 0;
  for (let r = n.iterRange(e, i), o = e, l; !r.next().done; o += r.value.length)
    if (!r.lineBreak)
      for (; l = t.exec(r.value); )
        s(o + l.index, l);
}
function Zr(n, t) {
  let e = n.visibleRanges;
  if (e.length == 1 && e[0].from == n.viewport.from && e[0].to == n.viewport.to)
    return e;
  let i = [];
  for (let { from: s, to: r } of e)
    s = Math.max(n.state.doc.lineAt(s).from, s - t), r = Math.min(n.state.doc.lineAt(r).to, r + t), i.length && i[i.length - 1].to >= s ? i[i.length - 1].to = r : i.push({ from: s, to: r });
  return i;
}
class Qr {
  /**
  Create a decorator.
  */
  constructor(t) {
    const { regexp: e, decoration: i, decorate: s, boundary: r, maxLength: o = 1e3 } = t;
    if (!e.global)
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    if (this.regexp = e, s)
      this.addMatch = (l, h, c, a) => s(a, c, c + l[0].length, l, h);
    else if (typeof i == "function")
      this.addMatch = (l, h, c, a) => {
        let f = i(l, h, c);
        f && a(c, c + l[0].length, f);
      };
    else if (i)
      this.addMatch = (l, h, c, a) => a(c, c + l[0].length, i);
    else
      throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
    this.boundary = r, this.maxLength = o;
  }
  /**
  Compute the full set of decorations for matches in the given
  view's viewport. You'll want to call this when initializing your
  plugin.
  */
  createDeco(t) {
    let e = new fn(), i = e.add.bind(e);
    for (let { from: s, to: r } of Zr(t, this.maxLength))
      Wi(t.state.doc, this.regexp, s, r, (o, l) => this.addMatch(l, t, o, i));
    return e.finish();
  }
  /**
  Update a set of decorations for a view update. `deco` _must_ be
  the set of decorations produced by _this_ `MatchDecorator` for
  the view state before the update.
  */
  updateDeco(t, e) {
    let i = 1e9, s = -1;
    return t.docChanged && t.changes.iterChanges((r, o, l, h) => {
      h > t.view.viewport.from && l < t.view.viewport.to && (i = Math.min(l, i), s = Math.max(h, s));
    }), t.viewportChanged || s - i > 1e3 ? this.createDeco(t.view) : s > -1 ? this.updateRange(t.view, e.map(t.changes), i, s) : e;
  }
  updateRange(t, e, i, s) {
    for (let r of t.visibleRanges) {
      let o = Math.max(r.from, i), l = Math.min(r.to, s);
      if (l > o) {
        let h = t.state.doc.lineAt(o), c = h.to < l ? t.state.doc.lineAt(l) : h, a = Math.max(r.from, h.from), f = Math.min(r.to, c.to);
        if (this.boundary) {
          for (; o > h.from; o--)
            if (this.boundary.test(h.text[o - 1 - h.from])) {
              a = o;
              break;
            }
          for (; l < c.to; l++)
            if (this.boundary.test(c.text[l - c.from])) {
              f = l;
              break;
            }
        }
        let d = [], u, g = (m, p, b) => d.push(b.range(m, p));
        if (h == c)
          for (this.regexp.lastIndex = a - h.from; (u = this.regexp.exec(h.text)) && u.index < f - h.from; )
            this.addMatch(u, t, u.index + h.from, g);
        else
          Wi(t.state.doc, this.regexp, a, f, (m, p) => this.addMatch(p, t, m, g));
        e = e.update({ filterFrom: a, filterTo: f, filter: (m, p) => m < a || p > f, add: d });
      }
    }
    return e;
  }
}
const ze = /x/.unicode != null ? "gu" : "g", to = /* @__PURE__ */ new RegExp(`[\0-\b
--­؜​‎‏\u2028\u2029‭‮⁦⁧⁩\uFEFF￹-￼]`, ze), eo = {
  0: "null",
  7: "bell",
  8: "backspace",
  10: "newline",
  11: "vertical tab",
  13: "carriage return",
  27: "escape",
  8203: "zero width space",
  8204: "zero width non-joiner",
  8205: "zero width joiner",
  8206: "left-to-right mark",
  8207: "right-to-left mark",
  8232: "line separator",
  8237: "left-to-right override",
  8238: "right-to-left override",
  8294: "left-to-right isolate",
  8295: "right-to-left isolate",
  8297: "pop directional isolate",
  8233: "paragraph separator",
  65279: "zero width no-break space",
  65532: "object replacement"
};
let we = null;
function io() {
  var n;
  if (we == null && typeof document < "u" && document.body) {
    let t = document.body.style;
    we = ((n = t.tabSize) !== null && n !== void 0 ? n : t.MozTabSize) != null;
  }
  return we || !1;
}
const ie = /* @__PURE__ */ k.define({
  combine(n) {
    let t = Ye(n, {
      render: null,
      specialChars: to,
      addSpecialChars: null
    });
    return (t.replaceTabs = !io()) && (t.specialChars = new RegExp("	|" + t.specialChars.source, ze)), t.addSpecialChars && (t.specialChars = new RegExp(t.specialChars.source + "|" + t.addSpecialChars.source, ze)), t;
  }
});
function Wo(n = {}) {
  return [ie.of(n), so()];
}
let Fi = null;
function so() {
  return Fi || (Fi = z.fromClass(class {
    constructor(n) {
      this.view = n, this.decorations = V.none, this.decorationCache = /* @__PURE__ */ Object.create(null), this.decorator = this.makeDecorator(n.state.facet(ie)), this.decorations = this.decorator.createDeco(n);
    }
    makeDecorator(n) {
      return new Qr({
        regexp: n.specialChars,
        decoration: (t, e, i) => {
          let { doc: s } = e.state, r = Ji(t[0], 0);
          if (r == 9) {
            let o = s.lineAt(i), l = e.state.tabSize, h = Zi(o.text, l, i - o.from);
            return V.replace({
              widget: new lo((l - h % l) * this.view.defaultCharacterWidth / this.view.scaleX)
            });
          }
          return this.decorationCache[r] || (this.decorationCache[r] = V.replace({ widget: new oo(n, r) }));
        },
        boundary: n.replaceTabs ? void 0 : /[^]/
      });
    }
    update(n) {
      let t = n.state.facet(ie);
      n.startState.facet(ie) != t ? (this.decorator = this.makeDecorator(t), this.decorations = this.decorator.createDeco(n.view)) : this.decorations = this.decorator.updateDeco(n, this.decorations);
    }
  }, {
    decorations: (n) => n.decorations
  }));
}
const no = "•";
function ro(n) {
  return n >= 32 ? no : n == 10 ? "␤" : String.fromCharCode(9216 + n);
}
class oo extends Nt {
  constructor(t, e) {
    super(), this.options = t, this.code = e;
  }
  eq(t) {
    return t.code == this.code;
  }
  toDOM(t) {
    let e = ro(this.code), i = t.state.phrase("Control character") + " " + (eo[this.code] || "0x" + this.code.toString(16)), s = this.options.render && this.options.render(this.code, i, e);
    if (s)
      return s;
    let r = document.createElement("span");
    return r.textContent = e, r.title = i, r.setAttribute("aria-label", i), r.className = "cm-specialChar", r;
  }
  ignoreEvent() {
    return !1;
  }
}
class lo extends Nt {
  constructor(t) {
    super(), this.width = t;
  }
  eq(t) {
    return t.width == this.width;
  }
  toDOM() {
    let t = document.createElement("span");
    return t.textContent = "	", t.className = "cm-tab", t.style.width = this.width + "px", t;
  }
  ignoreEvent() {
    return !1;
  }
}
function Fo() {
  return ao;
}
const ho = /* @__PURE__ */ V.line({ class: "cm-activeLine" }), ao = /* @__PURE__ */ z.fromClass(class {
  constructor(n) {
    this.decorations = this.getDeco(n);
  }
  update(n) {
    (n.docChanged || n.selectionSet) && (this.decorations = this.getDeco(n.view));
  }
  getDeco(n) {
    let t = -1, e = [];
    for (let i of n.state.selection.ranges) {
      let s = n.lineBlockAt(i.head);
      s.from > t && (e.push(ho.range(s.from)), t = s.from);
    }
    return V.set(e);
  }
}, {
  decorations: (n) => n.decorations
}), Ie = 2e3;
function co(n, t, e) {
  let i = Math.min(t.line, e.line), s = Math.max(t.line, e.line), r = [];
  if (t.off > Ie || e.off > Ie || t.col < 0 || e.col < 0) {
    let o = Math.min(t.off, e.off), l = Math.max(t.off, e.off);
    for (let h = i; h <= s; h++) {
      let c = n.doc.line(h);
      c.length <= l && r.push(M.range(c.from + o, c.to + l));
    }
  } else {
    let o = Math.min(t.col, e.col), l = Math.max(t.col, e.col);
    for (let h = i; h <= s; h++) {
      let c = n.doc.line(h), a = xe(c.text, o, n.tabSize, !0);
      if (a < 0)
        r.push(M.cursor(c.to));
      else {
        let f = xe(c.text, l, n.tabSize);
        r.push(M.range(c.from + a, c.from + f));
      }
    }
  }
  return r;
}
function fo(n, t) {
  let e = n.coordsAtPos(n.viewport.from);
  return e ? Math.round(Math.abs((e.left - t) / n.defaultCharacterWidth)) : -1;
}
function zi(n, t) {
  let e = n.posAtCoords({ x: t.clientX, y: t.clientY }, !1), i = n.state.doc.lineAt(e), s = e - i.from, r = s > Ie ? -1 : s == i.length ? fo(n, t.clientX) : Zi(i.text, n.state.tabSize, e - i.from);
  return { line: i.number, col: r, off: s };
}
function uo(n, t) {
  let e = zi(n, t), i = n.state.selection;
  return e ? {
    update(s) {
      if (s.docChanged) {
        let r = s.changes.mapPos(s.startState.doc.line(e.line).from), o = s.state.doc.lineAt(r);
        e = { line: o.number, col: e.col, off: Math.min(e.off, o.length) }, i = i.map(s.changes);
      }
    },
    get(s, r, o) {
      let l = zi(n, s);
      if (!l)
        return i;
      let h = co(n.state, e, l);
      return h.length ? o ? M.create(h.concat(i.ranges)) : M.create(h) : i;
    }
  } : null;
}
function zo(n) {
  let t = (n == null ? void 0 : n.eventFilter) || ((e) => e.altKey && e.button == 0);
  return A.mouseSelectionStyle.of((e, i) => t(i) ? uo(e, i) : null);
}
const go = {
  Alt: [18, (n) => !!n.altKey],
  Control: [17, (n) => !!n.ctrlKey],
  Shift: [16, (n) => !!n.shiftKey],
  Meta: [91, (n) => !!n.metaKey]
}, po = { style: "cursor: crosshair" };
function Io(n = {}) {
  let [t, e] = go[n.key || "Alt"], i = z.fromClass(class {
    constructor(s) {
      this.view = s, this.isDown = !1;
    }
    set(s) {
      this.isDown != s && (this.isDown = s, this.view.update([]));
    }
  }, {
    eventObservers: {
      keydown(s) {
        this.set(s.keyCode == t || e(s));
      },
      keyup(s) {
        (s.keyCode == t || !e(s)) && this.set(!1);
      },
      mousemove(s) {
        this.set(e(s));
      }
    }
  });
  return [
    i,
    A.contentAttributes.of((s) => {
      var r;
      return !((r = s.plugin(i)) === null || r === void 0) && r.isDown ? po : null;
    })
  ];
}
const St = "-10000px";
class tn {
  constructor(t, e, i) {
    this.facet = e, this.createTooltipView = i, this.input = t.state.facet(e), this.tooltips = this.input.filter((s) => s), this.tooltipViews = this.tooltips.map(i);
  }
  update(t, e) {
    var i;
    let s = t.state.facet(this.facet), r = s.filter((h) => h);
    if (s === this.input) {
      for (let h of this.tooltipViews)
        h.update && h.update(t);
      return !1;
    }
    let o = [], l = e ? [] : null;
    for (let h = 0; h < r.length; h++) {
      let c = r[h], a = -1;
      if (c) {
        for (let f = 0; f < this.tooltips.length; f++) {
          let d = this.tooltips[f];
          d && d.create == c.create && (a = f);
        }
        if (a < 0)
          o[h] = this.createTooltipView(c), l && (l[h] = !!c.above);
        else {
          let f = o[h] = this.tooltipViews[a];
          l && (l[h] = e[a]), f.update && f.update(t);
        }
      }
    }
    for (let h of this.tooltipViews)
      o.indexOf(h) < 0 && (h.dom.remove(), (i = h.destroy) === null || i === void 0 || i.call(h));
    return e && (l.forEach((h, c) => e[c] = h), e.length = l.length), this.input = s, this.tooltips = r, this.tooltipViews = o, !0;
  }
}
function mo(n) {
  let { win: t } = n;
  return { top: 0, left: 0, bottom: t.innerHeight, right: t.innerWidth };
}
const ye = /* @__PURE__ */ k.define({
  combine: (n) => {
    var t, e, i;
    return {
      position: w.ios ? "absolute" : ((t = n.find((s) => s.position)) === null || t === void 0 ? void 0 : t.position) || "fixed",
      parent: ((e = n.find((s) => s.parent)) === null || e === void 0 ? void 0 : e.parent) || null,
      tooltipSpace: ((i = n.find((s) => s.tooltipSpace)) === null || i === void 0 ? void 0 : i.tooltipSpace) || mo
    };
  }
}), Ii = /* @__PURE__ */ new WeakMap(), en = /* @__PURE__ */ z.fromClass(class {
  constructor(n) {
    this.view = n, this.above = [], this.inView = !0, this.madeAbsolute = !1, this.lastTransaction = 0, this.measureTimeout = -1;
    let t = n.state.facet(ye);
    this.position = t.position, this.parent = t.parent, this.classes = n.themeClasses, this.createContainer(), this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this }, this.manager = new tn(n, sn, (e) => this.createTooltip(e)), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((e) => {
      Date.now() > this.lastTransaction - 50 && e.length > 0 && e[e.length - 1].intersectionRatio < 1 && this.measureSoon();
    }, { threshold: [1] }) : null, this.observeIntersection(), n.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
  }
  createContainer() {
    this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let n of this.manager.tooltipViews)
        this.intersectionObserver.observe(n.dom);
    }
  }
  measureSoon() {
    this.measureTimeout < 0 && (this.measureTimeout = setTimeout(() => {
      this.measureTimeout = -1, this.maybeMeasure();
    }, 50));
  }
  update(n) {
    n.transactions.length && (this.lastTransaction = Date.now());
    let t = this.manager.update(n, this.above);
    t && this.observeIntersection();
    let e = t || n.geometryChanged, i = n.state.facet(ye);
    if (i.position != this.position && !this.madeAbsolute) {
      this.position = i.position;
      for (let s of this.manager.tooltipViews)
        s.dom.style.position = this.position;
      e = !0;
    }
    if (i.parent != this.parent) {
      this.parent && this.container.remove(), this.parent = i.parent, this.createContainer();
      for (let s of this.manager.tooltipViews)
        this.container.appendChild(s.dom);
      e = !0;
    } else
      this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
    e && this.maybeMeasure();
  }
  createTooltip(n) {
    let t = n.create(this.view);
    if (t.dom.classList.add("cm-tooltip"), n.arrow && !t.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      let e = document.createElement("div");
      e.className = "cm-tooltip-arrow", t.dom.appendChild(e);
    }
    return t.dom.style.position = this.position, t.dom.style.top = St, t.dom.style.left = "0px", this.container.appendChild(t.dom), t.mount && t.mount(this.view), t;
  }
  destroy() {
    var n, t;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let e of this.manager.tooltipViews)
      e.dom.remove(), (n = e.destroy) === null || n === void 0 || n.call(e);
    this.parent && this.container.remove(), (t = this.intersectionObserver) === null || t === void 0 || t.disconnect(), clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let n = this.view.dom.getBoundingClientRect(), t = 1, e = 1, i = !1;
    if (this.position == "fixed" && this.manager.tooltipViews.length) {
      let { dom: s } = this.manager.tooltipViews[0];
      if (w.gecko)
        i = s.offsetParent != this.container.ownerDocument.body;
      else if (this.view.scaleX != 1 || this.view.scaleY != 1)
        i = !0;
      else if (s.style.top == St && s.style.left == "0px") {
        let r = s.getBoundingClientRect();
        i = Math.abs(r.top + 1e4) > 1 || Math.abs(r.left) > 1;
      }
    }
    if (i || this.position == "absolute")
      if (this.parent) {
        let s = this.parent.getBoundingClientRect();
        s.width && s.height && (t = s.width / this.parent.offsetWidth, e = s.height / this.parent.offsetHeight);
      } else
        ({ scaleX: t, scaleY: e } = this.view.viewState);
    return {
      editor: n,
      parent: this.parent ? this.container.getBoundingClientRect() : n,
      pos: this.manager.tooltips.map((s, r) => {
        let o = this.manager.tooltipViews[r];
        return o.getCoords ? o.getCoords(s.pos) : this.view.coordsAtPos(s.pos);
      }),
      size: this.manager.tooltipViews.map(({ dom: s }) => s.getBoundingClientRect()),
      space: this.view.state.facet(ye).tooltipSpace(this.view),
      scaleX: t,
      scaleY: e,
      makeAbsolute: i
    };
  }
  writeMeasure(n) {
    var t;
    if (n.makeAbsolute) {
      this.madeAbsolute = !0, this.position = "absolute";
      for (let l of this.manager.tooltipViews)
        l.dom.style.position = "absolute";
    }
    let { editor: e, space: i, scaleX: s, scaleY: r } = n, o = [];
    for (let l = 0; l < this.manager.tooltips.length; l++) {
      let h = this.manager.tooltips[l], c = this.manager.tooltipViews[l], { dom: a } = c, f = n.pos[l], d = n.size[l];
      if (!f || f.bottom <= Math.max(e.top, i.top) || f.top >= Math.min(e.bottom, i.bottom) || f.right < Math.max(e.left, i.left) - 0.1 || f.left > Math.min(e.right, i.right) + 0.1) {
        a.style.top = St;
        continue;
      }
      let u = h.arrow ? c.dom.querySelector(".cm-tooltip-arrow") : null, g = u ? 7 : 0, m = d.right - d.left, p = (t = Ii.get(c)) !== null && t !== void 0 ? t : d.bottom - d.top, b = c.offset || wo, v = this.view.textDirection == L.LTR, x = d.width > i.right - i.left ? v ? i.left : i.right - d.width : v ? Math.min(f.left - (u ? 14 : 0) + b.x, i.right - m) : Math.max(i.left, f.left - m + (u ? 14 : 0) - b.x), y = this.above[l];
      !h.strictSide && (y ? f.top - (d.bottom - d.top) - b.y < i.top : f.bottom + (d.bottom - d.top) + b.y > i.bottom) && y == i.bottom - f.bottom > f.top - i.top && (y = this.above[l] = !y);
      let S = (y ? f.top - i.top : i.bottom - f.bottom) - g;
      if (S < p && c.resize !== !1) {
        if (S < this.view.defaultLineHeight) {
          a.style.top = St;
          continue;
        }
        Ii.set(c, p), a.style.height = (p = S) / r + "px";
      } else
        a.style.height && (a.style.height = "");
      let C = y ? f.top - p - g - b.y : f.bottom + g + b.y, R = x + m;
      if (c.overlap !== !0)
        for (let E of o)
          E.left < R && E.right > x && E.top < C + p && E.bottom > C && (C = y ? E.top - p - 2 - g : E.bottom + g + 2);
      if (this.position == "absolute" ? (a.style.top = (C - n.parent.top) / r + "px", a.style.left = (x - n.parent.left) / s + "px") : (a.style.top = C / r + "px", a.style.left = x / s + "px"), u) {
        let E = f.left + (v ? b.x : -b.x) - (x + 14 - 7);
        u.style.left = E / s + "px";
      }
      c.overlap !== !0 && o.push({ left: x, top: C, right: R, bottom: C + p }), a.classList.toggle("cm-tooltip-above", y), a.classList.toggle("cm-tooltip-below", !y), c.positioned && c.positioned(n.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView)))
      for (let n of this.manager.tooltipViews)
        n.dom.style.top = St;
  }
}, {
  eventObservers: {
    scroll() {
      this.maybeMeasure();
    }
  }
}), bo = /* @__PURE__ */ A.baseTheme({
  ".cm-tooltip": {
    zIndex: 100,
    boxSizing: "border-box"
  },
  "&light .cm-tooltip": {
    border: "1px solid #bbb",
    backgroundColor: "#f5f5f5"
  },
  "&light .cm-tooltip-section:not(:first-child)": {
    borderTop: "1px solid #bbb"
  },
  "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tooltip-arrow": {
    height: "7px",
    width: `${7 * 2}px`,
    position: "absolute",
    zIndex: -1,
    overflow: "hidden",
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      width: 0,
      height: 0,
      borderLeft: "7px solid transparent",
      borderRight: "7px solid transparent"
    },
    ".cm-tooltip-above &": {
      bottom: "-7px",
      "&:before": {
        borderTop: "7px solid #bbb"
      },
      "&:after": {
        borderTop: "7px solid #f5f5f5",
        bottom: "1px"
      }
    },
    ".cm-tooltip-below &": {
      top: "-7px",
      "&:before": {
        borderBottom: "7px solid #bbb"
      },
      "&:after": {
        borderBottom: "7px solid #f5f5f5",
        top: "1px"
      }
    }
  },
  "&dark .cm-tooltip .cm-tooltip-arrow": {
    "&:before": {
      borderTopColor: "#333338",
      borderBottomColor: "#333338"
    },
    "&:after": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    }
  }
}), wo = { x: 0, y: 0 }, sn = /* @__PURE__ */ k.define({
  enables: [en, bo]
}), ae = /* @__PURE__ */ k.define();
class Ze {
  // Needs to be static so that host tooltip instances always match
  static create(t) {
    return new Ze(t);
  }
  constructor(t) {
    this.view = t, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new tn(t, ae, (e) => this.createHostedView(e));
  }
  createHostedView(t) {
    let e = t.create(this.view);
    return e.dom.classList.add("cm-tooltip-section"), this.dom.appendChild(e.dom), this.mounted && e.mount && e.mount(this.view), e;
  }
  mount(t) {
    for (let e of this.manager.tooltipViews)
      e.mount && e.mount(t);
    this.mounted = !0;
  }
  positioned(t) {
    for (let e of this.manager.tooltipViews)
      e.positioned && e.positioned(t);
  }
  update(t) {
    this.manager.update(t);
  }
  destroy() {
    var t;
    for (let e of this.manager.tooltipViews)
      (t = e.destroy) === null || t === void 0 || t.call(e);
  }
  passProp(t) {
    let e;
    for (let i of this.manager.tooltipViews) {
      let s = i[t];
      if (s !== void 0) {
        if (e === void 0)
          e = s;
        else if (e !== s)
          return;
      }
    }
    return e;
  }
  get offset() {
    return this.passProp("offset");
  }
  get getCoords() {
    return this.passProp("getCoords");
  }
  get overlap() {
    return this.passProp("overlap");
  }
  get resize() {
    return this.passProp("resize");
  }
}
const yo = /* @__PURE__ */ sn.compute([ae], (n) => {
  let t = n.facet(ae).filter((e) => e);
  return t.length === 0 ? null : {
    pos: Math.min(...t.map((e) => e.pos)),
    end: Math.max(...t.filter((e) => e.end != null).map((e) => e.end)),
    create: Ze.create,
    above: t[0].above,
    arrow: t.some((e) => e.arrow)
  };
});
class vo {
  constructor(t, e, i, s, r) {
    this.view = t, this.source = e, this.field = i, this.setHover = s, this.hoverTime = r, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = { x: 0, y: 0, target: t.dom, time: 0 }, this.checkHover = this.checkHover.bind(this), t.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), t.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  update() {
    this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(() => this.startHover(), 20));
  }
  get active() {
    return this.view.state.field(this.field);
  }
  checkHover() {
    if (this.hoverTimeout = -1, this.active)
      return;
    let t = Date.now() - this.lastMove.time;
    t < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - t) : this.startHover();
  }
  startHover() {
    clearTimeout(this.restartTimeout);
    let { view: t, lastMove: e } = this, i = t.docView.nearest(e.target);
    if (!i)
      return;
    let s, r = 1;
    if (i instanceof st)
      s = i.posAtStart;
    else {
      if (s = t.posAtCoords(e), s == null)
        return;
      let l = t.coordsAtPos(s);
      if (!l || e.y < l.top || e.y > l.bottom || e.x < l.left - t.defaultCharacterWidth || e.x > l.right + t.defaultCharacterWidth)
        return;
      let h = t.bidiSpans(t.state.doc.lineAt(s)).find((a) => a.from <= s && a.to >= s), c = h && h.dir == L.RTL ? -1 : 1;
      r = e.x < l.left ? -c : c;
    }
    let o = this.source(t, s, r);
    if (o != null && o.then) {
      let l = this.pending = { pos: s };
      o.then((h) => {
        this.pending == l && (this.pending = null, h && t.dispatch({ effects: this.setHover.of(h) }));
      }, (h) => ct(t.state, h, "hover tooltip"));
    } else
      o && t.dispatch({ effects: this.setHover.of(o) });
  }
  mousemove(t) {
    var e;
    this.lastMove = { x: t.clientX, y: t.clientY, target: t.target, time: Date.now() }, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
    let i = this.active;
    if (i && !Ki(this.lastMove.target) || this.pending) {
      let { pos: s } = i || this.pending, r = (e = i == null ? void 0 : i.end) !== null && e !== void 0 ? e : s;
      (s == r ? this.view.posAtCoords(this.lastMove) != s : !So(this.view, s, r, t.clientX, t.clientY)) && (this.view.dispatch({ effects: this.setHover.of(null) }), this.pending = null);
    }
  }
  mouseleave(t) {
    clearTimeout(this.hoverTimeout), this.hoverTimeout = -1, this.active && !Ki(t.relatedTarget) && this.view.dispatch({ effects: this.setHover.of(null) });
  }
  destroy() {
    clearTimeout(this.hoverTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
  }
}
function Ki(n) {
  for (let t = n; t; t = t.parentNode)
    if (t.nodeType == 1 && t.classList.contains("cm-tooltip"))
      return !0;
  return !1;
}
function So(n, t, e, i, s, r) {
  let o = n.scrollDOM.getBoundingClientRect(), l = n.documentTop + n.documentPadding.top + n.contentHeight;
  if (o.left > i || o.right < i || o.top > s || Math.min(o.bottom, l) < s)
    return !1;
  let h = n.posAtCoords({ x: i, y: s }, !1);
  return h >= t && h <= e;
}
function Ko(n, t = {}) {
  let e = Ht.define(), i = Qi.define({
    create() {
      return null;
    },
    update(s, r) {
      if (s && (t.hideOnChange && (r.docChanged || r.selection) || t.hideOn && t.hideOn(r, s)))
        return null;
      if (s && r.docChanged) {
        let o = r.changes.mapPos(s.pos, -1, mt.TrackDel);
        if (o == null)
          return null;
        let l = Object.assign(/* @__PURE__ */ Object.create(null), s);
        l.pos = o, s.end != null && (l.end = r.changes.mapPos(s.end)), s = l;
      }
      for (let o of r.effects)
        o.is(e) && (s = o.value), o.is(xo) && (s = null);
      return s;
    },
    provide: (s) => ae.from(s)
  });
  return [
    i,
    z.define((s) => new vo(
      s,
      n,
      i,
      e,
      t.hoverTime || 300
      /* Hover.Time */
    )),
    yo
  ];
}
function qo(n, t) {
  let e = n.plugin(en);
  if (!e)
    return null;
  let i = e.manager.tooltips.indexOf(t);
  return i < 0 ? null : e.manager.tooltipViews[i];
}
const xo = /* @__PURE__ */ Ht.define(), qi = /* @__PURE__ */ k.define({
  combine(n) {
    let t, e;
    for (let i of n)
      t = t || i.topContainer, e = e || i.bottomContainer;
    return { topContainer: t, bottomContainer: e };
  }
});
function jo(n, t) {
  let e = n.plugin(nn), i = e ? e.specs.indexOf(t) : -1;
  return i > -1 ? e.panels[i] : null;
}
const nn = /* @__PURE__ */ z.fromClass(class {
  constructor(n) {
    this.input = n.state.facet(Yi), this.specs = this.input.filter((e) => e), this.panels = this.specs.map((e) => e(n));
    let t = n.state.facet(qi);
    this.top = new Jt(n, !0, t.topContainer), this.bottom = new Jt(n, !1, t.bottomContainer), this.top.sync(this.panels.filter((e) => e.top)), this.bottom.sync(this.panels.filter((e) => !e.top));
    for (let e of this.panels)
      e.dom.classList.add("cm-panel"), e.mount && e.mount();
  }
  update(n) {
    let t = n.state.facet(qi);
    this.top.container != t.topContainer && (this.top.sync([]), this.top = new Jt(n.view, !0, t.topContainer)), this.bottom.container != t.bottomContainer && (this.bottom.sync([]), this.bottom = new Jt(n.view, !1, t.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
    let e = n.state.facet(Yi);
    if (e != this.input) {
      let i = e.filter((h) => h), s = [], r = [], o = [], l = [];
      for (let h of i) {
        let c = this.specs.indexOf(h), a;
        c < 0 ? (a = h(n.view), l.push(a)) : (a = this.panels[c], a.update && a.update(n)), s.push(a), (a.top ? r : o).push(a);
      }
      this.specs = i, this.panels = s, this.top.sync(r), this.bottom.sync(o);
      for (let h of l)
        h.dom.classList.add("cm-panel"), h.mount && h.mount();
    } else
      for (let i of this.panels)
        i.update && i.update(n);
  }
  destroy() {
    this.top.sync([]), this.bottom.sync([]);
  }
}, {
  provide: (n) => A.scrollMargins.of((t) => {
    let e = t.plugin(n);
    return e && { top: e.top.scrollMargin(), bottom: e.bottom.scrollMargin() };
  })
});
class Jt {
  constructor(t, e, i) {
    this.view = t, this.top = e, this.container = i, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
  }
  sync(t) {
    for (let e of this.panels)
      e.destroy && t.indexOf(e) < 0 && e.destroy();
    this.panels = t, this.syncDOM();
  }
  syncDOM() {
    if (this.panels.length == 0) {
      this.dom && (this.dom.remove(), this.dom = void 0);
      return;
    }
    if (!this.dom) {
      this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
      let e = this.container || this.view.dom;
      e.insertBefore(this.dom, this.top ? e.firstChild : null);
    }
    let t = this.dom.firstChild;
    for (let e of this.panels)
      if (e.dom.parentNode == this.dom) {
        for (; t != e.dom; )
          t = ji(t);
        t = t.nextSibling;
      } else
        this.dom.insertBefore(e.dom, t);
    for (; t; )
      t = ji(t);
  }
  scrollMargin() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  }
  syncClasses() {
    if (!(!this.container || this.classes == this.view.themeClasses)) {
      for (let t of this.classes.split(" "))
        t && this.container.classList.remove(t);
      for (let t of (this.classes = this.view.themeClasses).split(" "))
        t && this.container.classList.add(t);
    }
  }
}
function ji(n) {
  let t = n.nextSibling;
  return n.remove(), t;
}
const Yi = /* @__PURE__ */ k.define({
  enables: nn
});
class lt extends $i {
  /**
  @internal
  */
  compare(t) {
    return this == t || this.constructor == t.constructor && this.eq(t);
  }
  /**
  Compare this marker to another marker of the same type.
  */
  eq(t) {
    return !1;
  }
  /**
  Called if the marker has a `toDOM` method and its representation
  was removed from a gutter.
  */
  destroy(t) {
  }
}
lt.prototype.elementClass = "";
lt.prototype.toDOM = void 0;
lt.prototype.mapMode = mt.TrackBefore;
lt.prototype.startSide = lt.prototype.endSide = -1;
lt.prototype.point = !0;
const se = /* @__PURE__ */ k.define(), Co = {
  class: "",
  renderEmptyElements: !1,
  elementStyle: "",
  markers: () => F.empty,
  lineMarker: () => null,
  widgetMarker: () => null,
  lineMarkerChange: null,
  initialSpacer: null,
  updateSpacer: null,
  domEventHandlers: {}
}, Tt = /* @__PURE__ */ k.define();
function Yo(n) {
  return [rn(), Tt.of(Object.assign(Object.assign({}, Co), n))];
}
const Ke = /* @__PURE__ */ k.define({
  combine: (n) => n.some((t) => t)
});
function rn(n) {
  let t = [
    Mo
  ];
  return n && n.fixed === !1 && t.push(Ke.of(!0)), t;
}
const Mo = /* @__PURE__ */ z.fromClass(class {
  constructor(n) {
    this.view = n, this.prevViewport = n.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = n.state.facet(Tt).map((t) => new _i(n, t));
    for (let t of this.gutters)
      this.dom.appendChild(t.dom);
    this.fixed = !n.state.facet(Ke), this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), n.scrollDOM.insertBefore(this.dom, n.contentDOM);
  }
  update(n) {
    if (this.updateGutters(n)) {
      let t = this.prevViewport, e = n.view.viewport, i = Math.min(t.to, e.to) - Math.max(t.from, e.from);
      this.syncGutters(i < (e.to - e.from) * 0.8);
    }
    n.geometryChanged && (this.dom.style.minHeight = this.view.contentHeight + "px"), this.view.state.facet(Ke) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : ""), this.prevViewport = n.view.viewport;
  }
  syncGutters(n) {
    let t = this.dom.nextSibling;
    n && this.dom.remove();
    let e = F.iter(this.view.state.facet(se), this.view.viewport.from), i = [], s = this.gutters.map((r) => new ko(r, this.view.viewport, -this.view.documentPadding.top));
    for (let r of this.view.viewportLineBlocks)
      if (i.length && (i = []), Array.isArray(r.type)) {
        let o = !0;
        for (let l of r.type)
          if (l.type == N.Text && o) {
            qe(e, i, l.from);
            for (let h of s)
              h.line(this.view, l, i);
            o = !1;
          } else if (l.widget)
            for (let h of s)
              h.widget(this.view, l);
      } else if (r.type == N.Text) {
        qe(e, i, r.from);
        for (let o of s)
          o.line(this.view, r, i);
      } else if (r.widget)
        for (let o of s)
          o.widget(this.view, r);
    for (let r of s)
      r.finish();
    n && this.view.scrollDOM.insertBefore(this.dom, t);
  }
  updateGutters(n) {
    let t = n.startState.facet(Tt), e = n.state.facet(Tt), i = n.docChanged || n.heightChanged || n.viewportChanged || !F.eq(n.startState.facet(se), n.state.facet(se), n.view.viewport.from, n.view.viewport.to);
    if (t == e)
      for (let s of this.gutters)
        s.update(n) && (i = !0);
    else {
      i = !0;
      let s = [];
      for (let r of e) {
        let o = t.indexOf(r);
        o < 0 ? s.push(new _i(this.view, r)) : (this.gutters[o].update(n), s.push(this.gutters[o]));
      }
      for (let r of this.gutters)
        r.dom.remove(), s.indexOf(r) < 0 && r.destroy();
      for (let r of s)
        this.dom.appendChild(r.dom);
      this.gutters = s;
    }
    return i;
  }
  destroy() {
    for (let n of this.gutters)
      n.destroy();
    this.dom.remove();
  }
}, {
  provide: (n) => A.scrollMargins.of((t) => {
    let e = t.plugin(n);
    return !e || e.gutters.length == 0 || !e.fixed ? null : t.textDirection == L.LTR ? { left: e.dom.offsetWidth * t.scaleX } : { right: e.dom.offsetWidth * t.scaleX };
  })
});
function Gi(n) {
  return Array.isArray(n) ? n : [n];
}
function qe(n, t, e) {
  for (; n.value && n.from <= e; )
    n.from == e && t.push(n.value), n.next();
}
class ko {
  constructor(t, e, i) {
    this.gutter = t, this.height = i, this.i = 0, this.cursor = F.iter(t.markers, e.from);
  }
  addElement(t, e, i) {
    let { gutter: s } = this, r = (e.top - this.height) / t.scaleY, o = e.height / t.scaleY;
    if (this.i == s.elements.length) {
      let l = new on(t, o, r, i);
      s.elements.push(l), s.dom.appendChild(l.dom);
    } else
      s.elements[this.i].update(t, o, r, i);
    this.height = e.bottom, this.i++;
  }
  line(t, e, i) {
    let s = [];
    qe(this.cursor, s, e.from), i.length && (s = s.concat(i));
    let r = this.gutter.config.lineMarker(t, e, s);
    r && s.unshift(r);
    let o = this.gutter;
    s.length == 0 && !o.config.renderEmptyElements || this.addElement(t, e, s);
  }
  widget(t, e) {
    let i = this.gutter.config.widgetMarker(t, e.widget, e);
    i && this.addElement(t, e, [i]);
  }
  finish() {
    let t = this.gutter;
    for (; t.elements.length > this.i; ) {
      let e = t.elements.pop();
      t.dom.removeChild(e.dom), e.destroy();
    }
  }
}
class _i {
  constructor(t, e) {
    this.view = t, this.config = e, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let i in e.domEventHandlers)
      this.dom.addEventListener(i, (s) => {
        let r = s.target, o;
        if (r != this.dom && this.dom.contains(r)) {
          for (; r.parentNode != this.dom; )
            r = r.parentNode;
          let h = r.getBoundingClientRect();
          o = (h.top + h.bottom) / 2;
        } else
          o = s.clientY;
        let l = t.lineBlockAtHeight(o - t.documentTop);
        e.domEventHandlers[i](t, l, s) && s.preventDefault();
      });
    this.markers = Gi(e.markers(t)), e.initialSpacer && (this.spacer = new on(t, 0, 0, [e.initialSpacer(t)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
  }
  update(t) {
    let e = this.markers;
    if (this.markers = Gi(this.config.markers(t.view)), this.spacer && this.config.updateSpacer) {
      let s = this.config.updateSpacer(this.spacer.markers[0], t);
      s != this.spacer.markers[0] && this.spacer.update(t.view, 0, 0, [s]);
    }
    let i = t.view.viewport;
    return !F.eq(this.markers, e, i.from, i.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(t) : !1);
  }
  destroy() {
    for (let t of this.elements)
      t.destroy();
  }
}
class on {
  constructor(t, e, i, s) {
    this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(t, e, i, s);
  }
  update(t, e, i, s) {
    this.height != e && (this.height = e, this.dom.style.height = e + "px"), this.above != i && (this.dom.style.marginTop = (this.above = i) ? i + "px" : ""), Ao(this.markers, s) || this.setMarkers(t, s);
  }
  setMarkers(t, e) {
    let i = "cm-gutterElement", s = this.dom.firstChild;
    for (let r = 0, o = 0; ; ) {
      let l = o, h = r < e.length ? e[r++] : null, c = !1;
      if (h) {
        let a = h.elementClass;
        a && (i += " " + a);
        for (let f = o; f < this.markers.length; f++)
          if (this.markers[f].compare(h)) {
            l = f, c = !0;
            break;
          }
      } else
        l = this.markers.length;
      for (; o < l; ) {
        let a = this.markers[o++];
        if (a.toDOM) {
          a.destroy(s);
          let f = s.nextSibling;
          s.remove(), s = f;
        }
      }
      if (!h)
        break;
      h.toDOM && (c ? s = s.nextSibling : this.dom.insertBefore(h.toDOM(t), s)), c && o++;
    }
    this.dom.className = i, this.markers = e;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function Ao(n, t) {
  if (n.length != t.length)
    return !1;
  for (let e = 0; e < n.length; e++)
    if (!n[e].compare(t[e]))
      return !1;
  return !0;
}
const Do = /* @__PURE__ */ k.define(), pt = /* @__PURE__ */ k.define({
  combine(n) {
    return Ye(n, { formatNumber: String, domEventHandlers: {} }, {
      domEventHandlers(t, e) {
        let i = Object.assign({}, t);
        for (let s in e) {
          let r = i[s], o = e[s];
          i[s] = r ? (l, h, c) => r(l, h, c) || o(l, h, c) : o;
        }
        return i;
      }
    });
  }
});
class ve extends lt {
  constructor(t) {
    super(), this.number = t;
  }
  eq(t) {
    return this.number == t.number;
  }
  toDOM() {
    return document.createTextNode(this.number);
  }
}
function Se(n, t) {
  return n.state.facet(pt).formatNumber(t, n.state);
}
const Oo = /* @__PURE__ */ Tt.compute([pt], (n) => ({
  class: "cm-lineNumbers",
  renderEmptyElements: !1,
  markers(t) {
    return t.state.facet(Do);
  },
  lineMarker(t, e, i) {
    return i.some((s) => s.toDOM) ? null : new ve(Se(t, t.state.doc.lineAt(e.from).number));
  },
  widgetMarker: () => null,
  lineMarkerChange: (t) => t.startState.facet(pt) != t.state.facet(pt),
  initialSpacer(t) {
    return new ve(Se(t, Xi(t.state.doc.lines)));
  },
  updateSpacer(t, e) {
    let i = Se(e.view, Xi(e.view.state.doc.lines));
    return i == t.number ? t : new ve(i);
  },
  domEventHandlers: n.facet(pt).domEventHandlers
}));
function Go(n = {}) {
  return [
    pt.of(n),
    rn(),
    Oo
  ];
}
function Xi(n) {
  let t = 9;
  for (; t < n; )
    t = t * 10 + 9;
  return t;
}
const To = /* @__PURE__ */ new class extends lt {
  constructor() {
    super(...arguments), this.elementClass = "cm-activeLineGutter";
  }
}(), Ro = /* @__PURE__ */ se.compute(["selection"], (n) => {
  let t = [], e = -1;
  for (let i of n.selection.ranges) {
    let s = n.doc.lineAt(i.head).from;
    s > e && (e = s, t.push(To.range(s)));
  }
  return F.of(t);
});
function _o() {
  return Ro;
}
export {
  nt as BidiSpan,
  G as BlockInfo,
  N as BlockType,
  V as Decoration,
  L as Direction,
  A as EditorView,
  lt as GutterMarker,
  Qr as MatchDecorator,
  Ft as RectangleMarker,
  z as ViewPlugin,
  le as ViewUpdate,
  Nt as WidgetType,
  Io as crosshairCursor,
  No as drawSelection,
  Vo as dropCursor,
  jo as getPanel,
  qo as getTooltip,
  Yo as gutter,
  se as gutterLineClass,
  rn as gutters,
  Fo as highlightActiveLine,
  _o as highlightActiveLineGutter,
  Wo as highlightSpecialChars,
  Ko as hoverTooltip,
  Kr as keymap,
  $s as layer,
  Do as lineNumberMarkers,
  Go as lineNumbers,
  ct as logException,
  zo as rectangularSelection,
  Ho as runScopeHandlers,
  Yi as showPanel,
  sn as showTooltip
};
